// src/type.ts
var AICommentViewTypeEnum = /* @__PURE__ */ ((AICommentViewTypeEnum2) => {
  AICommentViewTypeEnum2["ACTIVITY_LINK"] = "ACTIVITY_LINK";
  AICommentViewTypeEnum2["ERROR_TEXT"] = "ERROR_TEXT";
  AICommentViewTypeEnum2["GRAY_CHIP"] = "GRAY_CHIP";
  AICommentViewTypeEnum2["GREEN_CHIP"] = "GREEN_CHIP";
  AICommentViewTypeEnum2["PLAIN_TEXT"] = "PLAIN_TEXT";
  AICommentViewTypeEnum2["RED_CHIP"] = "RED_CHIP";
  AICommentViewTypeEnum2["STUDENT_LINK"] = "STUDENT_LINK";
  AICommentViewTypeEnum2["SUCCESS_TEXT"] = "SUCCESS_TEXT";
  return AICommentViewTypeEnum2;
})(AICommentViewTypeEnum || {});
var AIFeedbackResultStatusEnum = /* @__PURE__ */ ((AIFeedbackResultStatusEnum2) => {
  AIFeedbackResultStatusEnum2["COMPLETE"] = "COMPLETE";
  AIFeedbackResultStatusEnum2["ERROR"] = "ERROR";
  AIFeedbackResultStatusEnum2["LOADING"] = "LOADING";
  return AIFeedbackResultStatusEnum2;
})(AIFeedbackResultStatusEnum || {});
var AchievementLevelEnum = /* @__PURE__ */ ((AchievementLevelEnum2) => {
  AchievementLevelEnum2["HIGH"] = "HIGH";
  AchievementLevelEnum2["LOW"] = "LOW";
  AchievementLevelEnum2["MEDIUM"] = "MEDIUM";
  AchievementLevelEnum2["UNCLASSIFIED"] = "UNCLASSIFIED";
  return AchievementLevelEnum2;
})(AchievementLevelEnum || {});
var AcquireStatusEnum = /* @__PURE__ */ ((AcquireStatusEnum2) => {
  AcquireStatusEnum2["ACQUIRED"] = "ACQUIRED";
  AcquireStatusEnum2["NOT_ACQUIRED"] = "NOT_ACQUIRED";
  return AcquireStatusEnum2;
})(AcquireStatusEnum || {});
var AcquisitionLevelEnum = /* @__PURE__ */ ((AcquisitionLevelEnum2) => {
  AcquisitionLevelEnum2["HIGH"] = "HIGH";
  AcquisitionLevelEnum2["LOW"] = "LOW";
  AcquisitionLevelEnum2["MEDIUM"] = "MEDIUM";
  return AcquisitionLevelEnum2;
})(AcquisitionLevelEnum || {});
var ActivityCategoryEnum = /* @__PURE__ */ ((ActivityCategoryEnum2) => {
  ActivityCategoryEnum2["GENERAL"] = "GENERAL";
  ActivityCategoryEnum2["MODUM"] = "MODUM";
  return ActivityCategoryEnum2;
})(ActivityCategoryEnum || {});
var ActivityPageWidthEnum = /* @__PURE__ */ ((ActivityPageWidthEnum2) => {
  ActivityPageWidthEnum2["DEFAULT"] = "DEFAULT";
  ActivityPageWidthEnum2["WIDELY"] = "WIDELY";
  return ActivityPageWidthEnum2;
})(ActivityPageWidthEnum || {});
var ActivitySetTypeEnum = /* @__PURE__ */ ((ActivitySetTypeEnum2) => {
  ActivitySetTypeEnum2["EVALUATION"] = "EVALUATION";
  ActivitySetTypeEnum2["LEARNING"] = "LEARNING";
  ActivitySetTypeEnum2["MIXED"] = "MIXED";
  return ActivitySetTypeEnum2;
})(ActivitySetTypeEnum || {});
var ActivityStateEnum = /* @__PURE__ */ ((ActivityStateEnum2) => {
  ActivityStateEnum2["EDIT"] = "EDIT";
  ActivityStateEnum2["MEMORIZATION"] = "MEMORIZATION";
  ActivityStateEnum2["RELEARN"] = "RELEARN";
  ActivityStateEnum2["RETRY"] = "RETRY";
  ActivityStateEnum2["REVIEW"] = "REVIEW";
  ActivityStateEnum2["SHOW_ANSWER"] = "SHOW_ANSWER";
  ActivityStateEnum2["SUBMIT"] = "SUBMIT";
  return ActivityStateEnum2;
})(ActivityStateEnum || {});
var ActivityStatusEnum = /* @__PURE__ */ ((ActivityStatusEnum2) => {
  ActivityStatusEnum2["DELETED"] = "DELETED";
  ActivityStatusEnum2["PUBLISHED"] = "PUBLISHED";
  ActivityStatusEnum2["UN_PUBLISHED"] = "UN_PUBLISHED";
  return ActivityStatusEnum2;
})(ActivityStatusEnum || {});
var AiStatusEnum = /* @__PURE__ */ ((AiStatusEnum2) => {
  AiStatusEnum2["STARTED"] = "STARTED";
  AiStatusEnum2["STOPPED"] = "STOPPED";
  return AiStatusEnum2;
})(AiStatusEnum || {});
var AiTutorMessageSenderTypeEnum = /* @__PURE__ */ ((AiTutorMessageSenderTypeEnum2) => {
  AiTutorMessageSenderTypeEnum2["AI_TUTOR"] = "AI_TUTOR";
  AiTutorMessageSenderTypeEnum2["STUDENT"] = "STUDENT";
  return AiTutorMessageSenderTypeEnum2;
})(AiTutorMessageSenderTypeEnum || {});
var AiTutorMessageTypeEnum = /* @__PURE__ */ ((AiTutorMessageTypeEnum2) => {
  AiTutorMessageTypeEnum2["FILE"] = "FILE";
  AiTutorMessageTypeEnum2["MESSAGE"] = "MESSAGE";
  return AiTutorMessageTypeEnum2;
})(AiTutorMessageTypeEnum || {});
var AidtExternalUserDigitalTextBookTypeEnum = /* @__PURE__ */ ((AidtExternalUserDigitalTextBookTypeEnum2) => {
  AidtExternalUserDigitalTextBookTypeEnum2["COMMON_ENGLISH_1"] = "COMMON_ENGLISH_1";
  AidtExternalUserDigitalTextBookTypeEnum2["COMMON_ENGLISH_2"] = "COMMON_ENGLISH_2";
  AidtExternalUserDigitalTextBookTypeEnum2["COMMON_MATH_1"] = "COMMON_MATH_1";
  AidtExternalUserDigitalTextBookTypeEnum2["COMMON_MATH_2"] = "COMMON_MATH_2";
  AidtExternalUserDigitalTextBookTypeEnum2["ELEMENTARY_MATH_3_1"] = "ELEMENTARY_MATH_3_1";
  AidtExternalUserDigitalTextBookTypeEnum2["ELEMENTARY_MATH_3_2"] = "ELEMENTARY_MATH_3_2";
  AidtExternalUserDigitalTextBookTypeEnum2["ELEMENTARY_MATH_4_1"] = "ELEMENTARY_MATH_4_1";
  AidtExternalUserDigitalTextBookTypeEnum2["ELEMENTARY_MATH_4_2"] = "ELEMENTARY_MATH_4_2";
  AidtExternalUserDigitalTextBookTypeEnum2["ELEMENTARY_MATH_5_1"] = "ELEMENTARY_MATH_5_1";
  AidtExternalUserDigitalTextBookTypeEnum2["ELEMENTARY_MATH_5_2"] = "ELEMENTARY_MATH_5_2";
  AidtExternalUserDigitalTextBookTypeEnum2["ELEMENTARY_MATH_6_1"] = "ELEMENTARY_MATH_6_1";
  AidtExternalUserDigitalTextBookTypeEnum2["ELEMENTARY_MATH_6_2"] = "ELEMENTARY_MATH_6_2";
  AidtExternalUserDigitalTextBookTypeEnum2["MIDDLE_ENGLISH_1"] = "MIDDLE_ENGLISH_1";
  AidtExternalUserDigitalTextBookTypeEnum2["MIDDLE_ENGLISH_2"] = "MIDDLE_ENGLISH_2";
  AidtExternalUserDigitalTextBookTypeEnum2["MIDDLE_MATH_1"] = "MIDDLE_MATH_1";
  AidtExternalUserDigitalTextBookTypeEnum2["MIDDLE_MATH_2"] = "MIDDLE_MATH_2";
  return AidtExternalUserDigitalTextBookTypeEnum2;
})(AidtExternalUserDigitalTextBookTypeEnum || {});
var AidtExternalUserPublisherTypeEnum = /* @__PURE__ */ ((AidtExternalUserPublisherTypeEnum2) => {
  AidtExternalUserPublisherTypeEnum2["DIDIMDOL"] = "DIDIMDOL";
  AidtExternalUserPublisherTypeEnum2["JIHAK"] = "JIHAK";
  AidtExternalUserPublisherTypeEnum2["KYOHAK"] = "KYOHAK";
  AidtExternalUserPublisherTypeEnum2["NE"] = "NE";
  return AidtExternalUserPublisherTypeEnum2;
})(AidtExternalUserPublisherTypeEnum || {});
var AidtExternalUserTypeEnum = /* @__PURE__ */ ((AidtExternalUserTypeEnum2) => {
  AidtExternalUserTypeEnum2["STUDENT"] = "STUDENT";
  AidtExternalUserTypeEnum2["TEACHER"] = "TEACHER";
  return AidtExternalUserTypeEnum2;
})(AidtExternalUserTypeEnum || {});
var AidtUserSettingStatusEnum = /* @__PURE__ */ ((AidtUserSettingStatusEnum2) => {
  AidtUserSettingStatusEnum2["COMPLETED"] = "COMPLETED";
  AidtUserSettingStatusEnum2["ERROR"] = "ERROR";
  AidtUserSettingStatusEnum2["INIT"] = "INIT";
  AidtUserSettingStatusEnum2["NONE"] = "NONE";
  AidtUserSettingStatusEnum2["PROGRESSING"] = "PROGRESSING";
  return AidtUserSettingStatusEnum2;
})(AidtUserSettingStatusEnum || {});
var AmendReasonTypeEnum = /* @__PURE__ */ ((AmendReasonTypeEnum2) => {
  AmendReasonTypeEnum2["ERROR"] = "ERROR";
  AmendReasonTypeEnum2["ETC"] = "ETC";
  AmendReasonTypeEnum2["IMPROVE"] = "IMPROVE";
  return AmendReasonTypeEnum2;
})(AmendReasonTypeEnum || {});
var AnswerSymbolTypeEnum = /* @__PURE__ */ ((AnswerSymbolTypeEnum2) => {
  AnswerSymbolTypeEnum2["ALPHABET_MATH_SYMBOL"] = "ALPHABET_MATH_SYMBOL";
  AnswerSymbolTypeEnum2["ALPHABET_WITH_BRACKET"] = "ALPHABET_WITH_BRACKET";
  AnswerSymbolTypeEnum2["ALPHABET_WITH_BRACKET_OF_LOWER_CASE"] = "ALPHABET_WITH_BRACKET_OF_LOWER_CASE";
  AnswerSymbolTypeEnum2["ALPHABET_WITH_CIRCLE"] = "ALPHABET_WITH_CIRCLE";
  AnswerSymbolTypeEnum2["ALPHABET_WITH_CIRCLE_OF_LOWER_CASE"] = "ALPHABET_WITH_CIRCLE_OF_LOWER_CASE";
  AnswerSymbolTypeEnum2["GANADA_WITH_BRACKET"] = "GANADA_WITH_BRACKET";
  AnswerSymbolTypeEnum2["GANADA_WITH_CIRCLE"] = "GANADA_WITH_CIRCLE";
  AnswerSymbolTypeEnum2["KOREAN_ABC_WITH_BRACKET"] = "KOREAN_ABC_WITH_BRACKET";
  AnswerSymbolTypeEnum2["KOREAN_ABC_WITH_CIRCLE"] = "KOREAN_ABC_WITH_CIRCLE";
  AnswerSymbolTypeEnum2["LOWER_CASE_ALPHABET_MATH_SYMBOL"] = "LOWER_CASE_ALPHABET_MATH_SYMBOL";
  AnswerSymbolTypeEnum2["MN_MATH_SYMBOL"] = "MN_MATH_SYMBOL";
  AnswerSymbolTypeEnum2["NONE"] = "NONE";
  AnswerSymbolTypeEnum2["NUMERIC_WITH_BRACKET"] = "NUMERIC_WITH_BRACKET";
  AnswerSymbolTypeEnum2["NUMERIC_WITH_CIRCLE"] = "NUMERIC_WITH_CIRCLE";
  AnswerSymbolTypeEnum2["PQRS_MATH_SYMBOL"] = "PQRS_MATH_SYMBOL";
  AnswerSymbolTypeEnum2["XYZ_OMEGA_MATH_SYMBOL"] = "XYZ_OMEGA_MATH_SYMBOL";
  return AnswerSymbolTypeEnum2;
})(AnswerSymbolTypeEnum || {});
var AssignmentBaseContentTypeEnum = /* @__PURE__ */ ((AssignmentBaseContentTypeEnum2) => {
  AssignmentBaseContentTypeEnum2["CUSTOM_CURRICULUM"] = "CUSTOM_CURRICULUM";
  AssignmentBaseContentTypeEnum2["CUSTOM_DAILY_CURRICULUM"] = "CUSTOM_DAILY_CURRICULUM";
  AssignmentBaseContentTypeEnum2["REPLICA_STUDY_ACTIVITY"] = "REPLICA_STUDY_ACTIVITY";
  AssignmentBaseContentTypeEnum2["REPLICA_STUDY_MODULE"] = "REPLICA_STUDY_MODULE";
  AssignmentBaseContentTypeEnum2["REPLICA_STUDY_UNIT"] = "REPLICA_STUDY_UNIT";
  return AssignmentBaseContentTypeEnum2;
})(AssignmentBaseContentTypeEnum || {});
var AssignmentStatusEnum = /* @__PURE__ */ ((AssignmentStatusEnum2) => {
  AssignmentStatusEnum2["FINISHED"] = "FINISHED";
  AssignmentStatusEnum2["FINISHES_TODAY"] = "FINISHES_TODAY";
  AssignmentStatusEnum2["IN_PROGRESS"] = "IN_PROGRESS";
  AssignmentStatusEnum2["NON_END_DATE"] = "NON_END_DATE";
  AssignmentStatusEnum2["SCHEDULED"] = "SCHEDULED";
  return AssignmentStatusEnum2;
})(AssignmentStatusEnum || {});
var AssignmentTypeEnum = /* @__PURE__ */ ((AssignmentTypeEnum2) => {
  AssignmentTypeEnum2["RECOMMENDATION"] = "RECOMMENDATION";
  return AssignmentTypeEnum2;
})(AssignmentTypeEnum || {});
var AssignmentUserStatusEnum = /* @__PURE__ */ ((AssignmentUserStatusEnum2) => {
  AssignmentUserStatusEnum2["FINISHED"] = "FINISHED";
  AssignmentUserStatusEnum2["PARTIALLY_LEARNED"] = "PARTIALLY_LEARNED";
  AssignmentUserStatusEnum2["UNLEARNED"] = "UNLEARNED";
  return AssignmentUserStatusEnum2;
})(AssignmentUserStatusEnum || {});
var AttributeCategoryTypeEnum = /* @__PURE__ */ ((AttributeCategoryTypeEnum2) => {
  AttributeCategoryTypeEnum2["CLASS_LEVEL"] = "CLASS_LEVEL";
  AttributeCategoryTypeEnum2["ETC"] = "ETC";
  AttributeCategoryTypeEnum2["EVALUATION_CYCLE"] = "EVALUATION_CYCLE";
  AttributeCategoryTypeEnum2["LEARNING_LEVEL"] = "LEARNING_LEVEL";
  AttributeCategoryTypeEnum2["RECOMMEND"] = "RECOMMEND";
  return AttributeCategoryTypeEnum2;
})(AttributeCategoryTypeEnum || {});
var AuthenticationTypesEnum = /* @__PURE__ */ ((AuthenticationTypesEnum2) => {
  AuthenticationTypesEnum2["FIND_PASSWORD"] = "FIND_PASSWORD";
  AuthenticationTypesEnum2["SINGUP"] = "SINGUP";
  return AuthenticationTypesEnum2;
})(AuthenticationTypesEnum || {});
var AuthorityTypesEnum = /* @__PURE__ */ ((AuthorityTypesEnum2) => {
  AuthorityTypesEnum2["CMS"] = "CMS";
  AuthorityTypesEnum2["CRM"] = "CRM";
  AuthorityTypesEnum2["LMS"] = "LMS";
  AuthorityTypesEnum2["STUDENT"] = "STUDENT";
  return AuthorityTypesEnum2;
})(AuthorityTypesEnum || {});
var AutoSendFeedRuleEntityTypeEnum = /* @__PURE__ */ ((AutoSendFeedRuleEntityTypeEnum2) => {
  AutoSendFeedRuleEntityTypeEnum2["GROUP_REPLICA_CURRICULUM"] = "GROUP_REPLICA_CURRICULUM";
  return AutoSendFeedRuleEntityTypeEnum2;
})(AutoSendFeedRuleEntityTypeEnum || {});
var AutoSendFeedRuleTypeEnum = /* @__PURE__ */ ((AutoSendFeedRuleTypeEnum2) => {
  AutoSendFeedRuleTypeEnum2["COLLECTION"] = "COLLECTION";
  AutoSendFeedRuleTypeEnum2["STEP"] = "STEP";
  return AutoSendFeedRuleTypeEnum2;
})(AutoSendFeedRuleTypeEnum || {});
var AutoSendStatusEnum = /* @__PURE__ */ ((AutoSendStatusEnum2) => {
  AutoSendStatusEnum2["AUTO_SEND"] = "AUTO_SEND";
  AutoSendStatusEnum2["FINISHED"] = "FINISHED";
  AutoSendStatusEnum2["PAUSED"] = "PAUSED";
  return AutoSendStatusEnum2;
})(AutoSendStatusEnum || {});
var B2BVideoLectureTypeEnum = /* @__PURE__ */ ((B2BVideoLectureTypeEnum2) => {
  B2BVideoLectureTypeEnum2["ETOOS"] = "ETOOS";
  B2BVideoLectureTypeEnum2["MEGASTUDY"] = "MEGASTUDY";
  return B2BVideoLectureTypeEnum2;
})(B2BVideoLectureTypeEnum || {});
var BlankQuizOptionEnumEnum = /* @__PURE__ */ ((BlankQuizOptionEnumEnum2) => {
  BlankQuizOptionEnumEnum2["DEFAULT"] = "DEFAULT";
  BlankQuizOptionEnumEnum2["SHOW_WORD_COUNT_HINT"] = "SHOW_WORD_COUNT_HINT";
  BlankQuizOptionEnumEnum2["SHOW_WRONG_WORD_HINT"] = "SHOW_WRONG_WORD_HINT";
  return BlankQuizOptionEnumEnum2;
})(BlankQuizOptionEnumEnum || {});
var BoardTypeEnum = /* @__PURE__ */ ((BoardTypeEnum2) => {
  BoardTypeEnum2["CLASS"] = "CLASS";
  BoardTypeEnum2["HOMEWORK"] = "HOMEWORK";
  return BoardTypeEnum2;
})(BoardTypeEnum || {});
var BookmarkTargetTypeEnum = /* @__PURE__ */ ((BookmarkTargetTypeEnum2) => {
  BookmarkTargetTypeEnum2["CURRICULUM"] = "CURRICULUM";
  return BookmarkTargetTypeEnum2;
})(BookmarkTargetTypeEnum || {});
var BookmarkTypesEnum = /* @__PURE__ */ ((BookmarkTypesEnum2) => {
  BookmarkTypesEnum2["GRAMMAR"] = "GRAMMAR";
  BookmarkTypesEnum2["MATH_QUESTION"] = "MATH_QUESTION";
  BookmarkTypesEnum2["QUESTION"] = "QUESTION";
  BookmarkTypesEnum2["SENTENCE"] = "SENTENCE";
  BookmarkTypesEnum2["WORD"] = "WORD";
  return BookmarkTypesEnum2;
})(BookmarkTypesEnum || {});
var BookmarksOrderFieldTypeEnum = /* @__PURE__ */ ((BookmarksOrderFieldTypeEnum2) => {
  BookmarksOrderFieldTypeEnum2["CREATED_AT"] = "CREATED_AT";
  BookmarksOrderFieldTypeEnum2["TITLE"] = "TITLE";
  return BookmarksOrderFieldTypeEnum2;
})(BookmarksOrderFieldTypeEnum || {});
var ChannelMemberTypeEnum = /* @__PURE__ */ ((ChannelMemberTypeEnum2) => {
  ChannelMemberTypeEnum2["BOT"] = "BOT";
  ChannelMemberTypeEnum2["MANAGER"] = "MANAGER";
  ChannelMemberTypeEnum2["STUDENT"] = "STUDENT";
  return ChannelMemberTypeEnum2;
})(ChannelMemberTypeEnum || {});
var ChannelMemoEventTypeEnum = /* @__PURE__ */ ((ChannelMemoEventTypeEnum2) => {
  ChannelMemoEventTypeEnum2["ADDED"] = "ADDED";
  ChannelMemoEventTypeEnum2["DELETED"] = "DELETED";
  ChannelMemoEventTypeEnum2["FIXED"] = "FIXED";
  ChannelMemoEventTypeEnum2["UNFIXED"] = "UNFIXED";
  ChannelMemoEventTypeEnum2["UPDATED"] = "UPDATED";
  return ChannelMemoEventTypeEnum2;
})(ChannelMemoEventTypeEnum || {});
var ChannelTypeEnum = /* @__PURE__ */ ((ChannelTypeEnum2) => {
  ChannelTypeEnum2["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
  ChannelTypeEnum2["GROUP"] = "GROUP";
  ChannelTypeEnum2["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
  return ChannelTypeEnum2;
})(ChannelTypeEnum || {});
var ChatBotMessageTypeEnum = /* @__PURE__ */ ((ChatBotMessageTypeEnum2) => {
  ChatBotMessageTypeEnum2["FILE"] = "FILE";
  ChatBotMessageTypeEnum2["MESSAGE"] = "MESSAGE";
  return ChatBotMessageTypeEnum2;
})(ChatBotMessageTypeEnum || {});
var CheckPolicyEnum = /* @__PURE__ */ ((CheckPolicyEnum2) => {
  CheckPolicyEnum2["CHECK_ALL"] = "CHECK_ALL";
  CheckPolicyEnum2["PARTIAL_CHECK"] = "PARTIAL_CHECK";
  return CheckPolicyEnum2;
})(CheckPolicyEnum || {});
var ClassStateEnum = /* @__PURE__ */ ((ClassStateEnum2) => {
  ClassStateEnum2["ABSENT"] = "ABSENT";
  ClassStateEnum2["COMPLETE"] = "COMPLETE";
  ClassStateEnum2["END_OF_MANAGEMENT"] = "END_OF_MANAGEMENT";
  ClassStateEnum2["IN_CLASS"] = "IN_CLASS";
  ClassStateEnum2["LEARNING_BEFORE_CLASS"] = "LEARNING_BEFORE_CLASS";
  ClassStateEnum2["NONE_FEED"] = "NONE_FEED";
  ClassStateEnum2["NOT_IN_CLASS"] = "NOT_IN_CLASS";
  ClassStateEnum2["PARTIAL_LEARNING"] = "PARTIAL_LEARNING";
  ClassStateEnum2["RESERVATION"] = "RESERVATION";
  ClassStateEnum2["UNLEARNED"] = "UNLEARNED";
  return ClassStateEnum2;
})(ClassStateEnum || {});
var ClassTimeRecordStatusEnum = /* @__PURE__ */ ((ClassTimeRecordStatusEnum2) => {
  ClassTimeRecordStatusEnum2["EARLY"] = "EARLY";
  ClassTimeRecordStatusEnum2["LATE"] = "LATE";
  ClassTimeRecordStatusEnum2["ON_TIME"] = "ON_TIME";
  ClassTimeRecordStatusEnum2["RESTART"] = "RESTART";
  return ClassTimeRecordStatusEnum2;
})(ClassTimeRecordStatusEnum || {});
var ClassTimeStateEnum = /* @__PURE__ */ ((ClassTimeStateEnum2) => {
  ClassTimeStateEnum2["ABSENT"] = "ABSENT";
  ClassTimeStateEnum2["BEFORE_CLASS"] = "BEFORE_CLASS";
  ClassTimeStateEnum2["COMPLETED"] = "COMPLETED";
  ClassTimeStateEnum2["IN_CLASS"] = "IN_CLASS";
  ClassTimeStateEnum2["NO_CLASS"] = "NO_CLASS";
  return ClassTimeStateEnum2;
})(ClassTimeStateEnum || {});
var ClientChatMessageUploadStatusEnum = /* @__PURE__ */ ((ClientChatMessageUploadStatusEnum2) => {
  ClientChatMessageUploadStatusEnum2["ERROR"] = "ERROR";
  ClientChatMessageUploadStatusEnum2["IDLE"] = "IDLE";
  ClientChatMessageUploadStatusEnum2["UPLOADED"] = "UPLOADED";
  ClientChatMessageUploadStatusEnum2["UPLOADING"] = "UPLOADING";
  return ClientChatMessageUploadStatusEnum2;
})(ClientChatMessageUploadStatusEnum || {});
var ColorOfLetterEnum = /* @__PURE__ */ ((ColorOfLetterEnum2) => {
  ColorOfLetterEnum2["GREEN"] = "GREEN";
  ColorOfLetterEnum2["ORANGE"] = "ORANGE";
  ColorOfLetterEnum2["RED"] = "RED";
  return ColorOfLetterEnum2;
})(ColorOfLetterEnum || {});
var ConnectionStateEnum = /* @__PURE__ */ ((ConnectionStateEnum2) => {
  ConnectionStateEnum2["FOCUS_OUT"] = "FOCUS_OUT";
  ConnectionStateEnum2["NEVER"] = "NEVER";
  ConnectionStateEnum2["ON"] = "ON";
  ConnectionStateEnum2["SESSION_EXPIRATION"] = "SESSION_EXPIRATION";
  return ConnectionStateEnum2;
})(ConnectionStateEnum || {});
var ContentScopeEnum = /* @__PURE__ */ ((ContentScopeEnum2) => {
  ContentScopeEnum2["ALL"] = "ALL";
  ContentScopeEnum2["INTERNAL"] = "INTERNAL";
  return ContentScopeEnum2;
})(ContentScopeEnum || {});
var ContentTypeEnum = /* @__PURE__ */ ((ContentTypeEnum2) => {
  ContentTypeEnum2["TYPE_1"] = "TYPE_1";
  ContentTypeEnum2["TYPE_2"] = "TYPE_2";
  return ContentTypeEnum2;
})(ContentTypeEnum || {});
var CorrectAnswerMultipleChoiceTypeEnum = /* @__PURE__ */ ((CorrectAnswerMultipleChoiceTypeEnum2) => {
  CorrectAnswerMultipleChoiceTypeEnum2["MULTIPLE_CHOICE_MULTIPLE_ANSWER"] = "MULTIPLE_CHOICE_MULTIPLE_ANSWER";
  CorrectAnswerMultipleChoiceTypeEnum2["MULTIPLE_CHOICE_SINGLE_ANSWER"] = "MULTIPLE_CHOICE_SINGLE_ANSWER";
  return CorrectAnswerMultipleChoiceTypeEnum2;
})(CorrectAnswerMultipleChoiceTypeEnum || {});
var CorrectAnswerReferralTargetTypeEnum = /* @__PURE__ */ ((CorrectAnswerReferralTargetTypeEnum2) => {
  CorrectAnswerReferralTargetTypeEnum2["REFERRAL_TARGET"] = "REFERRAL_TARGET";
  return CorrectAnswerReferralTargetTypeEnum2;
})(CorrectAnswerReferralTargetTypeEnum || {});
var CorrectAnswerShortAnswerTypeEnum = /* @__PURE__ */ ((CorrectAnswerShortAnswerTypeEnum2) => {
  CorrectAnswerShortAnswerTypeEnum2["SHORT_ANSWER_MULTIPLE_ANSWER"] = "SHORT_ANSWER_MULTIPLE_ANSWER";
  CorrectAnswerShortAnswerTypeEnum2["SHORT_ANSWER_SINGLE_ANSWER"] = "SHORT_ANSWER_SINGLE_ANSWER";
  return CorrectAnswerShortAnswerTypeEnum2;
})(CorrectAnswerShortAnswerTypeEnum || {});
var CreateStudyUnitOnStudyModuleRequestTypeEnum = /* @__PURE__ */ ((CreateStudyUnitOnStudyModuleRequestTypeEnum2) => {
  CreateStudyUnitOnStudyModuleRequestTypeEnum2["BLOCK"] = "BLOCK";
  CreateStudyUnitOnStudyModuleRequestTypeEnum2["STUDY_UNIT_GENERAL_VIEW"] = "STUDY_UNIT_GENERAL_VIEW";
  CreateStudyUnitOnStudyModuleRequestTypeEnum2["STUDY_UNIT_VIDEO_READINGS_VIEW"] = "STUDY_UNIT_VIDEO_READINGS_VIEW";
  CreateStudyUnitOnStudyModuleRequestTypeEnum2["TEST_UNIT"] = "TEST_UNIT";
  CreateStudyUnitOnStudyModuleRequestTypeEnum2["WORD_MEMORIZATION"] = "WORD_MEMORIZATION";
  CreateStudyUnitOnStudyModuleRequestTypeEnum2["WORD_TEST"] = "WORD_TEST";
  return CreateStudyUnitOnStudyModuleRequestTypeEnum2;
})(CreateStudyUnitOnStudyModuleRequestTypeEnum || {});
var CurriculumOrderFieldTypeEnum = /* @__PURE__ */ ((CurriculumOrderFieldTypeEnum2) => {
  CurriculumOrderFieldTypeEnum2["CREATED_AT"] = "CREATED_AT";
  CurriculumOrderFieldTypeEnum2["TITLE"] = "TITLE";
  return CurriculumOrderFieldTypeEnum2;
})(CurriculumOrderFieldTypeEnum || {});
var CurriculumSubjectEnum = /* @__PURE__ */ ((CurriculumSubjectEnum2) => {
  CurriculumSubjectEnum2["ENGLISH"] = "ENGLISH";
  CurriculumSubjectEnum2["KOREAN"] = "KOREAN";
  CurriculumSubjectEnum2["MATH"] = "MATH";
  CurriculumSubjectEnum2["MIXED"] = "MIXED";
  CurriculumSubjectEnum2["UNDEFINED"] = "UNDEFINED";
  return CurriculumSubjectEnum2;
})(CurriculumSubjectEnum || {});
var CurriculumTypeEnum = /* @__PURE__ */ ((CurriculumTypeEnum2) => {
  CurriculumTypeEnum2["BLOCK"] = "BLOCK";
  CurriculumTypeEnum2["GENERAL"] = "GENERAL";
  CurriculumTypeEnum2["WRONG"] = "WRONG";
  return CurriculumTypeEnum2;
})(CurriculumTypeEnum || {});
var CustomCurriculumCommentRecommendationTypeEnum = /* @__PURE__ */ ((CustomCurriculumCommentRecommendationTypeEnum2) => {
  CustomCurriculumCommentRecommendationTypeEnum2["KNOWLEDGE_TAG"] = "KNOWLEDGE_TAG";
  CustomCurriculumCommentRecommendationTypeEnum2["LOW_CORRECT_RATE"] = "LOW_CORRECT_RATE";
  CustomCurriculumCommentRecommendationTypeEnum2["LOW_PROGRESS_RATE"] = "LOW_PROGRESS_RATE";
  return CustomCurriculumCommentRecommendationTypeEnum2;
})(CustomCurriculumCommentRecommendationTypeEnum || {});
var CustomCurriculumEditingStatusEnum = /* @__PURE__ */ ((CustomCurriculumEditingStatusEnum2) => {
  CustomCurriculumEditingStatusEnum2["ADDED"] = "ADDED";
  CustomCurriculumEditingStatusEnum2["DELETED"] = "DELETED";
  CustomCurriculumEditingStatusEnum2["MOVED"] = "MOVED";
  return CustomCurriculumEditingStatusEnum2;
})(CustomCurriculumEditingStatusEnum || {});
var CustomCurriculumStatusEnum = /* @__PURE__ */ ((CustomCurriculumStatusEnum2) => {
  CustomCurriculumStatusEnum2["COMPLETE"] = "COMPLETE";
  CustomCurriculumStatusEnum2["EDITING"] = "EDITING";
  CustomCurriculumStatusEnum2["ERROR"] = "ERROR";
  CustomCurriculumStatusEnum2["LOADING"] = "LOADING";
  return CustomCurriculumStatusEnum2;
})(CustomCurriculumStatusEnum || {});
var CustomCurriculumSubTypeEnum = /* @__PURE__ */ ((CustomCurriculumSubTypeEnum2) => {
  CustomCurriculumSubTypeEnum2["ASSIGNMENT"] = "ASSIGNMENT";
  CustomCurriculumSubTypeEnum2["COMMON"] = "COMMON";
  CustomCurriculumSubTypeEnum2["INCORRECT_ANSWER_NOTE"] = "INCORRECT_ANSWER_NOTE";
  CustomCurriculumSubTypeEnum2["SELF_STUDY"] = "SELF_STUDY";
  return CustomCurriculumSubTypeEnum2;
})(CustomCurriculumSubTypeEnum || {});
var CustomCurriculumTypeEnum = /* @__PURE__ */ ((CustomCurriculumTypeEnum2) => {
  CustomCurriculumTypeEnum2["MAIN"] = "MAIN";
  CustomCurriculumTypeEnum2["SUB"] = "SUB";
  return CustomCurriculumTypeEnum2;
})(CustomCurriculumTypeEnum || {});
var CustomDailyCurriculumStatusEnum = /* @__PURE__ */ ((CustomDailyCurriculumStatusEnum2) => {
  CustomDailyCurriculumStatusEnum2["CLOSE"] = "CLOSE";
  CustomDailyCurriculumStatusEnum2["OPEN"] = "OPEN";
  CustomDailyCurriculumStatusEnum2["READ_ONLY"] = "READ_ONLY";
  return CustomDailyCurriculumStatusEnum2;
})(CustomDailyCurriculumStatusEnum || {});
var CustomStudyModuleStatusEnum = /* @__PURE__ */ ((CustomStudyModuleStatusEnum2) => {
  CustomStudyModuleStatusEnum2["CLOSE"] = "CLOSE";
  CustomStudyModuleStatusEnum2["OPEN"] = "OPEN";
  CustomStudyModuleStatusEnum2["READ_ONLY"] = "READ_ONLY";
  return CustomStudyModuleStatusEnum2;
})(CustomStudyModuleStatusEnum || {});
var CustomStudyModulesByUserAndCustomCurriculumInputGroupByEnum = /* @__PURE__ */ ((CustomStudyModulesByUserAndCustomCurriculumInputGroupByEnum2) => {
  CustomStudyModulesByUserAndCustomCurriculumInputGroupByEnum2["DATE"] = "DATE";
  return CustomStudyModulesByUserAndCustomCurriculumInputGroupByEnum2;
})(CustomStudyModulesByUserAndCustomCurriculumInputGroupByEnum || {});
var CustomStudyModulesByUserAndCustomCurriculumOrderByFieldEnumEnum = /* @__PURE__ */ ((CustomStudyModulesByUserAndCustomCurriculumOrderByFieldEnumEnum2) => {
  CustomStudyModulesByUserAndCustomCurriculumOrderByFieldEnumEnum2["CUSTOM_STUDY_MODULE_CREATED_AT"] = "CUSTOM_STUDY_MODULE_CREATED_AT";
  return CustomStudyModulesByUserAndCustomCurriculumOrderByFieldEnumEnum2;
})(CustomStudyModulesByUserAndCustomCurriculumOrderByFieldEnumEnum || {});
var CustomStudyUnitCommentRecommendationTypeEnum = /* @__PURE__ */ ((CustomStudyUnitCommentRecommendationTypeEnum2) => {
  CustomStudyUnitCommentRecommendationTypeEnum2["ACHIEVEMENT_ANALYSIS"] = "ACHIEVEMENT_ANALYSIS";
  CustomStudyUnitCommentRecommendationTypeEnum2["FAST_TIME_AND_LOW_CORRECT_RATE"] = "FAST_TIME_AND_LOW_CORRECT_RATE";
  CustomStudyUnitCommentRecommendationTypeEnum2["LOW_CORRECT_RATE"] = "LOW_CORRECT_RATE";
  return CustomStudyUnitCommentRecommendationTypeEnum2;
})(CustomStudyUnitCommentRecommendationTypeEnum || {});
var DashboardActivityLogTypeEnum = /* @__PURE__ */ ((DashboardActivityLogTypeEnum2) => {
  DashboardActivityLogTypeEnum2["ACTIVITY_EVENT_LOG"] = "ACTIVITY_EVENT_LOG";
  DashboardActivityLogTypeEnum2["LEGACY"] = "LEGACY";
  DashboardActivityLogTypeEnum2["STUDENT_CURRENT_PAGE"] = "STUDENT_CURRENT_PAGE";
  DashboardActivityLogTypeEnum2["TOTAL_ACTIVITY_TIME_LOG"] = "TOTAL_ACTIVITY_TIME_LOG";
  return DashboardActivityLogTypeEnum2;
})(DashboardActivityLogTypeEnum || {});
var DashboardSettingNameTypeEnum = /* @__PURE__ */ ((DashboardSettingNameTypeEnum2) => {
  DashboardSettingNameTypeEnum2["FEED_LEARNING_STATE_HOVER_TOGGLE"] = "FEED_LEARNING_STATE_HOVER_TOGGLE";
  DashboardSettingNameTypeEnum2["WATCHING_PAGE_HOVER_TOGGLE"] = "WATCHING_PAGE_HOVER_TOGGLE";
  return DashboardSettingNameTypeEnum2;
})(DashboardSettingNameTypeEnum || {});
var DashboardSettingTypeEnum = /* @__PURE__ */ ((DashboardSettingTypeEnum2) => {
  DashboardSettingTypeEnum2["OFF"] = "OFF";
  DashboardSettingTypeEnum2["ON"] = "ON";
  return DashboardSettingTypeEnum2;
})(DashboardSettingTypeEnum || {});
var DayOfTheWeekEnum = /* @__PURE__ */ ((DayOfTheWeekEnum2) => {
  DayOfTheWeekEnum2["FRI"] = "FRI";
  DayOfTheWeekEnum2["MON"] = "MON";
  DayOfTheWeekEnum2["SAT"] = "SAT";
  DayOfTheWeekEnum2["SUN"] = "SUN";
  DayOfTheWeekEnum2["THU"] = "THU";
  DayOfTheWeekEnum2["TUE"] = "TUE";
  DayOfTheWeekEnum2["WED"] = "WED";
  return DayOfTheWeekEnum2;
})(DayOfTheWeekEnum || {});
var DeviceTypeEnum = /* @__PURE__ */ ((DeviceTypeEnum2) => {
  DeviceTypeEnum2["ANDROID"] = "ANDROID";
  DeviceTypeEnum2["IOS"] = "IOS";
  DeviceTypeEnum2["WEB"] = "WEB";
  return DeviceTypeEnum2;
})(DeviceTypeEnum || {});
var DiagnosisReportOnStudyUnitInstanceStatusEnum = /* @__PURE__ */ ((DiagnosisReportOnStudyUnitInstanceStatusEnum2) => {
  DiagnosisReportOnStudyUnitInstanceStatusEnum2["COMPLETE"] = "COMPLETE";
  DiagnosisReportOnStudyUnitInstanceStatusEnum2["ERROR"] = "ERROR";
  DiagnosisReportOnStudyUnitInstanceStatusEnum2["LOADING"] = "LOADING";
  return DiagnosisReportOnStudyUnitInstanceStatusEnum2;
})(DiagnosisReportOnStudyUnitInstanceStatusEnum || {});
var DiagnosticOnboardingBatchStatusEnum = /* @__PURE__ */ ((DiagnosticOnboardingBatchStatusEnum2) => {
  DiagnosticOnboardingBatchStatusEnum2["COMPLETED"] = "COMPLETED";
  DiagnosticOnboardingBatchStatusEnum2["EXPIRED"] = "EXPIRED";
  DiagnosticOnboardingBatchStatusEnum2["FAILED"] = "FAILED";
  DiagnosticOnboardingBatchStatusEnum2["PROCESSING"] = "PROCESSING";
  DiagnosticOnboardingBatchStatusEnum2["QUEUED"] = "QUEUED";
  return DiagnosticOnboardingBatchStatusEnum2;
})(DiagnosticOnboardingBatchStatusEnum || {});
var DiagnosticOnboardingItemStatusEnum = /* @__PURE__ */ ((DiagnosticOnboardingItemStatusEnum2) => {
  DiagnosticOnboardingItemStatusEnum2["CHECK_REQUIRED"] = "CHECK_REQUIRED";
  DiagnosticOnboardingItemStatusEnum2["COMPLETE"] = "COMPLETE";
  DiagnosticOnboardingItemStatusEnum2["CREATING_GROUP"] = "CREATING_GROUP";
  DiagnosticOnboardingItemStatusEnum2["FAILED"] = "FAILED";
  DiagnosticOnboardingItemStatusEnum2["IMPORTING_CURRICULUM"] = "IMPORTING_CURRICULUM";
  DiagnosticOnboardingItemStatusEnum2["QUEUED"] = "QUEUED";
  DiagnosticOnboardingItemStatusEnum2["SENDING_FEED"] = "SENDING_FEED";
  return DiagnosticOnboardingItemStatusEnum2;
})(DiagnosticOnboardingItemStatusEnum || {});
var DomainEnum = /* @__PURE__ */ ((DomainEnum2) => {
  DomainEnum2["CMS"] = "CMS";
  DomainEnum2["CRM"] = "CRM";
  DomainEnum2["LMS"] = "LMS";
  DomainEnum2["STUDENT"] = "STUDENT";
  DomainEnum2["SUPERVISOR"] = "SUPERVISOR";
  return DomainEnum2;
})(DomainEnum || {});
var DrawGraphInteractionSubTypeEnum = /* @__PURE__ */ ((DrawGraphInteractionSubTypeEnum2) => {
  DrawGraphInteractionSubTypeEnum2["DRAW_DIRECT"] = "DRAW_DIRECT";
  DrawGraphInteractionSubTypeEnum2["DRAW_WITH_FUNCTION_EXPRESSION"] = "DRAW_WITH_FUNCTION_EXPRESSION";
  return DrawGraphInteractionSubTypeEnum2;
})(DrawGraphInteractionSubTypeEnum || {});
var EditTargetEntityTypeEnum = /* @__PURE__ */ ((EditTargetEntityTypeEnum2) => {
  EditTargetEntityTypeEnum2["ACTIVITY"] = "ACTIVITY";
  EditTargetEntityTypeEnum2["CURRICULUM"] = "CURRICULUM";
  EditTargetEntityTypeEnum2["CUSTOM_KNOWLEDGE_MAP"] = "CUSTOM_KNOWLEDGE_MAP";
  EditTargetEntityTypeEnum2["GROUP_HISOTRY"] = "GROUP_HISOTRY";
  EditTargetEntityTypeEnum2["KNOWLEDGE_MAP"] = "KNOWLEDGE_MAP";
  EditTargetEntityTypeEnum2["META_CONTENT"] = "META_CONTENT";
  EditTargetEntityTypeEnum2["META_CONTENT_MODULE"] = "META_CONTENT_MODULE";
  EditTargetEntityTypeEnum2["REPLICA_CURRICULUM"] = "REPLICA_CURRICULUM";
  EditTargetEntityTypeEnum2["REPLICA_DAILY_CURRICULUM"] = "REPLICA_DAILY_CURRICULUM";
  EditTargetEntityTypeEnum2["REPLICA_STUDY_ACTIVITY"] = "REPLICA_STUDY_ACTIVITY";
  EditTargetEntityTypeEnum2["REPLICA_STUDY_MODULE"] = "REPLICA_STUDY_MODULE";
  EditTargetEntityTypeEnum2["REPLICA_STUDY_UNIT"] = "REPLICA_STUDY_UNIT";
  EditTargetEntityTypeEnum2["STUDY_ACTIVITY"] = "STUDY_ACTIVITY";
  EditTargetEntityTypeEnum2["STUDY_MODULE"] = "STUDY_MODULE";
  EditTargetEntityTypeEnum2["STUDY_UNIT"] = "STUDY_UNIT";
  EditTargetEntityTypeEnum2["STUDY_UNIT_STUDY_ACTIVITY"] = "STUDY_UNIT_STUDY_ACTIVITY";
  EditTargetEntityTypeEnum2["USER_PRODUCT"] = "USER_PRODUCT";
  EditTargetEntityTypeEnum2["WORD"] = "WORD";
  return EditTargetEntityTypeEnum2;
})(EditTargetEntityTypeEnum || {});
var EditingStatusEnum = /* @__PURE__ */ ((EditingStatusEnum2) => {
  EditingStatusEnum2["EDITABLE"] = "EDITABLE";
  EditingStatusEnum2["PARTIAL_EDITABLE"] = "PARTIAL_EDITABLE";
  EditingStatusEnum2["READ_ONLY"] = "READ_ONLY";
  return EditingStatusEnum2;
})(EditingStatusEnum || {});
var ErrorCodeEnum = /* @__PURE__ */ ((ErrorCodeEnum2) => {
  ErrorCodeEnum2["AIDT_TEACHER_NOT_SETUP"] = "AIDT_TEACHER_NOT_SETUP";
  ErrorCodeEnum2["AI_FEEDBACK_NOT_NEEDED"] = "AI_FEEDBACK_NOT_NEEDED";
  ErrorCodeEnum2["AI_FEEDBACK_NOT_READY_STUDY_UNIT_NOT_DONE"] = "AI_FEEDBACK_NOT_READY_STUDY_UNIT_NOT_DONE";
  ErrorCodeEnum2["AI_FEEDBACK_REQUEST_FAILURE"] = "AI_FEEDBACK_REQUEST_FAILURE";
  ErrorCodeEnum2["AI_MESSAGE_RECOMMENDATION_DELIVERY_FAILED"] = "AI_MESSAGE_RECOMMENDATION_DELIVERY_FAILED";
  ErrorCodeEnum2["AI_REPORT_NOT_FOUND"] = "AI_REPORT_NOT_FOUND";
  ErrorCodeEnum2["ALREADY_EXISTING_META_CONTENT_MODULE_ON_META_CHATTER"] = "ALREADY_EXISTING_META_CONTENT_MODULE_ON_META_CHATTER";
  ErrorCodeEnum2["ALREADY_JOINED_EMAIL"] = "ALREADY_JOINED_EMAIL";
  ErrorCodeEnum2["ALREADY_MAPPED"] = "ALREADY_MAPPED";
  ErrorCodeEnum2["ALREADY_SUBMITTED"] = "ALREADY_SUBMITTED";
  ErrorCodeEnum2["AT_LEAST_ONE_SENTENCE_MUST_EXIST"] = "AT_LEAST_ONE_SENTENCE_MUST_EXIST";
  ErrorCodeEnum2["BAD_REQUEST"] = "BAD_REQUEST";
  ErrorCodeEnum2["BLOCK_STUDY_UNIT_ADD_ERROR"] = "BLOCK_STUDY_UNIT_ADD_ERROR";
  ErrorCodeEnum2["CANNOT_MAKE_WORD_TEST_TITLE"] = "CANNOT_MAKE_WORD_TEST_TITLE";
  ErrorCodeEnum2["CAN_NOT_CREATE_KNOWLEDGE_TAG_PLAN_OUT_OF_END_DATE"] = "CAN_NOT_CREATE_KNOWLEDGE_TAG_PLAN_OUT_OF_END_DATE";
  ErrorCodeEnum2["CAN_NOT_DELETE_PAST_KNOWLEDGE_TAG_PLAN"] = "CAN_NOT_DELETE_PAST_KNOWLEDGE_TAG_PLAN";
  ErrorCodeEnum2["CAN_NOT_DELETE_SENT_KNOWLEDGE_TAG_PLAN"] = "CAN_NOT_DELETE_SENT_KNOWLEDGE_TAG_PLAN";
  ErrorCodeEnum2["CAN_NOT_EDIT_KNOWLEDGE_TAG_PLAN"] = "CAN_NOT_EDIT_KNOWLEDGE_TAG_PLAN";
  ErrorCodeEnum2["CAN_NOT_MOVE_KNOWLEDGE_TAG_PLAN_NOT_WITHIN_PLAN"] = "CAN_NOT_MOVE_KNOWLEDGE_TAG_PLAN_NOT_WITHIN_PLAN";
  ErrorCodeEnum2["CAN_NOT_MOVE_PAST_KNOWLEDGE_TAG_PLAN"] = "CAN_NOT_MOVE_PAST_KNOWLEDGE_TAG_PLAN";
  ErrorCodeEnum2["CAN_NOT_MOVE_SENT_KNOWLEDGE_TAG_PLAN"] = "CAN_NOT_MOVE_SENT_KNOWLEDGE_TAG_PLAN";
  ErrorCodeEnum2["CHANGE_ANSWER_NOT_ALLOWED"] = "CHANGE_ANSWER_NOT_ALLOWED";
  ErrorCodeEnum2["CHANNEL_ALREADY_EXISTS"] = "CHANNEL_ALREADY_EXISTS";
  ErrorCodeEnum2["CHANNEL_TIMER_ALREADY_RUNNING"] = "CHANNEL_TIMER_ALREADY_RUNNING";
  ErrorCodeEnum2["CHANNEL_TIMER_INVALID_DURATION"] = "CHANNEL_TIMER_INVALID_DURATION";
  ErrorCodeEnum2["CHANNEL_TIMER_INVALID_STATE"] = "CHANNEL_TIMER_INVALID_STATE";
  ErrorCodeEnum2["CHANNEL_TIMER_NOT_FOUND"] = "CHANNEL_TIMER_NOT_FOUND";
  ErrorCodeEnum2["CHANNEL_TIMER_NOT_PAUSED"] = "CHANNEL_TIMER_NOT_PAUSED";
  ErrorCodeEnum2["CHANNEL_TIMER_NOT_RUNNING"] = "CHANNEL_TIMER_NOT_RUNNING";
  ErrorCodeEnum2["CHECK_BLOCK_POSITION_AND_RETRY"] = "CHECK_BLOCK_POSITION_AND_RETRY";
  ErrorCodeEnum2["CLASS_NOT_ONGOING"] = "CLASS_NOT_ONGOING";
  ErrorCodeEnum2["CLASS_WRAP_UP_ALREADY_STARTED"] = "CLASS_WRAP_UP_ALREADY_STARTED";
  ErrorCodeEnum2["CLASS_WRAP_UP_NOT_AVAILABLE_YET"] = "CLASS_WRAP_UP_NOT_AVAILABLE_YET";
  ErrorCodeEnum2["CLASS_WRAP_UP_NOT_STARTED"] = "CLASS_WRAP_UP_NOT_STARTED";
  ErrorCodeEnum2["CLASS_WRAP_UP_SESSION_DISABLED"] = "CLASS_WRAP_UP_SESSION_DISABLED";
  ErrorCodeEnum2["CONSTRUCTOR_VALIDATION_ERROR"] = "CONSTRUCTOR_VALIDATION_ERROR";
  ErrorCodeEnum2["CONTAINS_FORBIDDEN_WORD_ERROR"] = "CONTAINS_FORBIDDEN_WORD_ERROR";
  ErrorCodeEnum2["CREATE_ACTIVITY_SET_FAIL"] = "CREATE_ACTIVITY_SET_FAIL";
  ErrorCodeEnum2["CREATE_ACTIVITY_SET_UNIT_FAIL"] = "CREATE_ACTIVITY_SET_UNIT_FAIL";
  ErrorCodeEnum2["CREATE_DATA_ERROR"] = "CREATE_DATA_ERROR";
  ErrorCodeEnum2["CREATE_KNOWLEDGE_TAG_FAIL"] = "CREATE_KNOWLEDGE_TAG_FAIL";
  ErrorCodeEnum2["CREATE_SA_ON_DELETED_META_CHAPTER_NOT_ALLOWED"] = "CREATE_SA_ON_DELETED_META_CHAPTER_NOT_ALLOWED";
  ErrorCodeEnum2["CURRICULUM_FETCH_USER_ABORT"] = "CURRICULUM_FETCH_USER_ABORT";
  ErrorCodeEnum2["CURRICULUM_NOT_FOUND"] = "CURRICULUM_NOT_FOUND";
  ErrorCodeEnum2["DELETED"] = "DELETED";
  ErrorCodeEnum2["DISCONNECTED_STUDY_ACTIVITY"] = "DISCONNECTED_STUDY_ACTIVITY";
  ErrorCodeEnum2["DUPLICATE_CURRICULUM_NAME"] = "DUPLICATE_CURRICULUM_NAME";
  ErrorCodeEnum2["DUPLICATE_EXPERIENCE_PUBLISHER_NAME_IN_QR_URL"] = "DUPLICATE_EXPERIENCE_PUBLISHER_NAME_IN_QR_URL";
  ErrorCodeEnum2["DUPLICATE_KNOWLEDGE_NODE_AND_TAG_RELATION"] = "DUPLICATE_KNOWLEDGE_NODE_AND_TAG_RELATION";
  ErrorCodeEnum2["DUPLICATE_META_CONTENT_NAME"] = "DUPLICATE_META_CONTENT_NAME";
  ErrorCodeEnum2["DUPLICATE_TAG_NAME"] = "DUPLICATE_TAG_NAME";
  ErrorCodeEnum2["EMOTICON_FAVORITE_LIMIT_EXCEEDED"] = "EMOTICON_FAVORITE_LIMIT_EXCEEDED";
  ErrorCodeEnum2["EMPTY_GROUP"] = "EMPTY_GROUP";
  ErrorCodeEnum2["EMPTY_GROUP_USERS"] = "EMPTY_GROUP_USERS";
  ErrorCodeEnum2["EMPTY_STUDY_ACTIVITY_TYPES_NOT_ALLOWED"] = "EMPTY_STUDY_ACTIVITY_TYPES_NOT_ALLOWED";
  ErrorCodeEnum2["EMPTY_STUDY_UNIT"] = "EMPTY_STUDY_UNIT";
  ErrorCodeEnum2["EMPTY_WORD_TEST_TITLE"] = "EMPTY_WORD_TEST_TITLE";
  ErrorCodeEnum2["ENTITY_TYPE_OF_ACTIVITY_SET_IS_NOT_UNIT"] = "ENTITY_TYPE_OF_ACTIVITY_SET_IS_NOT_UNIT";
  ErrorCodeEnum2["EXPERIENCE_PUBLISHER_NOT_EXIST"] = "EXPERIENCE_PUBLISHER_NOT_EXIST";
  ErrorCodeEnum2["EXTERNAL_MESSAGE_FAILURE"] = "EXTERNAL_MESSAGE_FAILURE";
  ErrorCodeEnum2["FEED_RESERVATION_HAS_NO_RELATED_STUDENT"] = "FEED_RESERVATION_HAS_NO_RELATED_STUDENT";
  ErrorCodeEnum2["FEED_RESERVATION_NOT_EXIST"] = "FEED_RESERVATION_NOT_EXIST";
  ErrorCodeEnum2["FORBIDDEN"] = "FORBIDDEN";
  ErrorCodeEnum2["GENERATING_OVER_100_QR_URLS_NOT_ALLOWED"] = "GENERATING_OVER_100_QR_URLS_NOT_ALLOWED";
  ErrorCodeEnum2["GIVEN_QR_URL_NOT_EXIST"] = "GIVEN_QR_URL_NOT_EXIST";
  ErrorCodeEnum2["GLOBAL_MODUM_AND_GROUP_USER_NOT_IN_THE_SAME_GROUP"] = "GLOBAL_MODUM_AND_GROUP_USER_NOT_IN_THE_SAME_GROUP";
  ErrorCodeEnum2["GLOBAL_MODUM_COUNT_IS_LESS_THEN_TWO"] = "GLOBAL_MODUM_COUNT_IS_LESS_THEN_TWO";
  ErrorCodeEnum2["GLOBAL_MODUM_NAME_DUPLICATED"] = "GLOBAL_MODUM_NAME_DUPLICATED";
  ErrorCodeEnum2["GLOBAL_MODUM_NOT_FOUND"] = "GLOBAL_MODUM_NOT_FOUND";
  ErrorCodeEnum2["GOOGLE_NLP_ERROR"] = "GOOGLE_NLP_ERROR";
  ErrorCodeEnum2["GOOGLE_NLP_NOT_SUPPORT_LANGUAGE"] = "GOOGLE_NLP_NOT_SUPPORT_LANGUAGE";
  ErrorCodeEnum2["GROUP_NOT_FOUND"] = "GROUP_NOT_FOUND";
  ErrorCodeEnum2["GROUP_NOT_HAVE_GLOBAL_MODUM"] = "GROUP_NOT_HAVE_GLOBAL_MODUM";
  ErrorCodeEnum2["HAS_CHILD_ENTITY"] = "HAS_CHILD_ENTITY";
  ErrorCodeEnum2["HINT_GENERATION_FAILED"] = "HINT_GENERATION_FAILED";
  ErrorCodeEnum2["HINT_LIMIT_EXCEEDED"] = "HINT_LIMIT_EXCEEDED";
  ErrorCodeEnum2["HTTP_REQUEST_ERROR"] = "HTTP_REQUEST_ERROR";
  ErrorCodeEnum2["INSUFFICIENT_MESSAGES"] = "INSUFFICIENT_MESSAGES";
  ErrorCodeEnum2["INVALID_CLASS_INSTANCE"] = "INVALID_CLASS_INSTANCE";
  ErrorCodeEnum2["INVALID_CLASS_STATE"] = "INVALID_CLASS_STATE";
  ErrorCodeEnum2["INVALID_FILTER_RULE"] = "INVALID_FILTER_RULE";
  ErrorCodeEnum2["INVALID_KAFKA_BROKERS_CONFIGURATION"] = "INVALID_KAFKA_BROKERS_CONFIGURATION";
  ErrorCodeEnum2["INVALID_META_CHAPTER"] = "INVALID_META_CHAPTER";
  ErrorCodeEnum2["INVALID_PARAMETERS"] = "INVALID_PARAMETERS";
  ErrorCodeEnum2["INVALID_PASSWORD"] = "INVALID_PASSWORD";
  ErrorCodeEnum2["INVALID_RESOLVING_NODE_ITEM"] = "INVALID_RESOLVING_NODE_ITEM";
  ErrorCodeEnum2["INVALID_SCHEMA"] = "INVALID_SCHEMA";
  ErrorCodeEnum2["INVALID_STUDY_UNIT_VIEW_DATA_TYPE"] = "INVALID_STUDY_UNIT_VIEW_DATA_TYPE";
  ErrorCodeEnum2["INVALID_TOKEN"] = "INVALID_TOKEN";
  ErrorCodeEnum2["INVALID_VIEW_DATA_TYPE"] = "INVALID_VIEW_DATA_TYPE";
  ErrorCodeEnum2["IS_REQUIRED_FIELD_CHANGED_STUDY_ACTIVITY_NOT_EXIST"] = "IS_REQUIRED_FIELD_CHANGED_STUDY_ACTIVITY_NOT_EXIST";
  ErrorCodeEnum2["KAFKA_CONSUMER_DUPLICATE"] = "KAFKA_CONSUMER_DUPLICATE";
  ErrorCodeEnum2["KNOWLEDGE_TAG_NOT_FOUND"] = "KNOWLEDGE_TAG_NOT_FOUND";
  ErrorCodeEnum2["KT_PLAN_TO_FEED_GRCC_NOT_SUPPORTED"] = "KT_PLAN_TO_FEED_GRCC_NOT_SUPPORTED";
  ErrorCodeEnum2["KT_TO_FEED_GRCC_NOT_SUPPORTED"] = "KT_TO_FEED_GRCC_NOT_SUPPORTED";
  ErrorCodeEnum2["MASTER_PASSWORD_EXPIRED"] = "MASTER_PASSWORD_EXPIRED";
  ErrorCodeEnum2["MASTER_PASSWORD_NOT_EXIST"] = "MASTER_PASSWORD_NOT_EXIST";
  ErrorCodeEnum2["MATH_AI_TUTOR_CHANNEL_NOT_FOUND"] = "MATH_AI_TUTOR_CHANNEL_NOT_FOUND";
  ErrorCodeEnum2["META_CHAPTERS_WITH_META_CONTENT_MODULES_ARE_NOT_ALLOWED_TO_HAVE_CHILD_META_CHAPTERS"] = "META_CHAPTERS_WITH_META_CONTENT_MODULES_ARE_NOT_ALLOWED_TO_HAVE_CHILD_META_CHAPTERS";
  ErrorCodeEnum2["MOCK_EXAM_RESULT_NOT_FOUND"] = "MOCK_EXAM_RESULT_NOT_FOUND";
  ErrorCodeEnum2["MODIFICATION_OF_IS_MARKED_ON_AUTO_CREATED_STUDY_ACTIVITY_NOT_ALLOWED"] = "MODIFICATION_OF_IS_MARKED_ON_AUTO_CREATED_STUDY_ACTIVITY_NOT_ALLOWED";
  ErrorCodeEnum2["MONTHLY_REPORT_BATCH_EDIT_FAILED"] = "MONTHLY_REPORT_BATCH_EDIT_FAILED";
  ErrorCodeEnum2["MONTHLY_REPORT_BATCH_NAME_DUPLICATE"] = "MONTHLY_REPORT_BATCH_NAME_DUPLICATE";
  ErrorCodeEnum2["MONTHLY_REPORT_BATCH_STUDENT_DUPLICATE"] = "MONTHLY_REPORT_BATCH_STUDENT_DUPLICATE";
  ErrorCodeEnum2["MONTHLY_REPORT_BATCH_STUDENT_REPORT_DUPLICATE"] = "MONTHLY_REPORT_BATCH_STUDENT_REPORT_DUPLICATE";
  ErrorCodeEnum2["MONTHLY_REPORT_CANNOT_DELETE_BATCH_OR_STUDENT_AFTER_REPORT_SENT"] = "MONTHLY_REPORT_CANNOT_DELETE_BATCH_OR_STUDENT_AFTER_REPORT_SENT";
  ErrorCodeEnum2["MONTHLY_REPORT_PRESET_CAN_NOT_UNSET_REPRESENTATIVE"] = "MONTHLY_REPORT_PRESET_CAN_NOT_UNSET_REPRESENTATIVE";
  ErrorCodeEnum2["MONTHLY_REPORT_PRESET_INITIAL_DATA_INVALID_PARTIAL_STATUS"] = "MONTHLY_REPORT_PRESET_INITIAL_DATA_INVALID_PARTIAL_STATUS";
  ErrorCodeEnum2["MONTHLY_REPORT_PRESET_INIT_FAILED_OR_PARTIAL_DATA"] = "MONTHLY_REPORT_PRESET_INIT_FAILED_OR_PARTIAL_DATA";
  ErrorCodeEnum2["MONTHLY_REPORT_PRESET_LIMIT_FULL"] = "MONTHLY_REPORT_PRESET_LIMIT_FULL";
  ErrorCodeEnum2["MONTHLY_REPORT_PRESET_UNAVAILABLE_OPERATION"] = "MONTHLY_REPORT_PRESET_UNAVAILABLE_OPERATION";
  ErrorCodeEnum2["MPD_CHANNEL_NOT_FOUND"] = "MPD_CHANNEL_NOT_FOUND";
  ErrorCodeEnum2["MPD_SESSION_CREATION_FAILED"] = "MPD_SESSION_CREATION_FAILED";
  ErrorCodeEnum2["MULTIPLE_VIDEO_STUDY_ACTIVITY_NOT_ALLOWED"] = "MULTIPLE_VIDEO_STUDY_ACTIVITY_NOT_ALLOWED";
  ErrorCodeEnum2["NOT_CONTAIN_KEY"] = "NOT_CONTAIN_KEY";
  ErrorCodeEnum2["NOT_FOUND"] = "NOT_FOUND";
  ErrorCodeEnum2["NOT_FOUND_ANY_STUDY_ACTIVITY"] = "NOT_FOUND_ANY_STUDY_ACTIVITY";
  ErrorCodeEnum2["NOT_FOUND_ENV"] = "NOT_FOUND_ENV";
  ErrorCodeEnum2["NOT_FOUND_GROUP_USER"] = "NOT_FOUND_GROUP_USER";
  ErrorCodeEnum2["NOT_FOUND_USABLE_STUDY_ACTIVITY"] = "NOT_FOUND_USABLE_STUDY_ACTIVITY";
  ErrorCodeEnum2["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
  ErrorCodeEnum2["NOT_SAME"] = "NOT_SAME";
  ErrorCodeEnum2["NOT_SUPPORTED_STUDY_UNIT_VIEW_TYPE"] = "NOT_SUPPORTED_STUDY_UNIT_VIEW_TYPE";
  ErrorCodeEnum2["NOT_SUPPORTED_TYPE_OF_STUDY_ACTIVITY_INSTANCE_ISSUE_REPORT"] = "NOT_SUPPORTED_TYPE_OF_STUDY_ACTIVITY_INSTANCE_ISSUE_REPORT";
  ErrorCodeEnum2["NO_FEED_USER_FOR_INACTIVE_USER"] = "NO_FEED_USER_FOR_INACTIVE_USER";
  ErrorCodeEnum2["NO_SENTENCE"] = "NO_SENTENCE";
  ErrorCodeEnum2["NO_STUDENT_IN_GROUP"] = "NO_STUDENT_IN_GROUP";
  ErrorCodeEnum2["PERMISSION_DENIED"] = "PERMISSION_DENIED";
  ErrorCodeEnum2["PERSONA_GENERATION_FAILED"] = "PERSONA_GENERATION_FAILED";
  ErrorCodeEnum2["PLAN_NOT_FOUND"] = "PLAN_NOT_FOUND";
  ErrorCodeEnum2["QUESTION_BLOCK_MUST_BE_UNDER_NUMBER_BLOCK"] = "QUESTION_BLOCK_MUST_BE_UNDER_NUMBER_BLOCK";
  ErrorCodeEnum2["READING_SA_GRADING_FAILED"] = "READING_SA_GRADING_FAILED";
  ErrorCodeEnum2["RECOMMEND_GRCC_NOT_SUPPORTED"] = "RECOMMEND_GRCC_NOT_SUPPORTED";
  ErrorCodeEnum2["REDIS_NOT_READY"] = "REDIS_NOT_READY";
  ErrorCodeEnum2["REFERENCE_INFORMATION_CHANNEL_NOT_FOUND"] = "REFERENCE_INFORMATION_CHANNEL_NOT_FOUND";
  ErrorCodeEnum2["REFERENCE_INFORMATION_EMPTY"] = "REFERENCE_INFORMATION_EMPTY";
  ErrorCodeEnum2["REFERENCE_INFORMATION_NOT_FOUND"] = "REFERENCE_INFORMATION_NOT_FOUND";
  ErrorCodeEnum2["REFERENCE_INFORMATION_TOO_LARGE"] = "REFERENCE_INFORMATION_TOO_LARGE";
  ErrorCodeEnum2["REPLICA_DAILY_CURRICULUM_NOT_EXIST"] = "REPLICA_DAILY_CURRICULUM_NOT_EXIST";
  ErrorCodeEnum2["REPLICA_STUDY_MODULE_NOT_FOUND"] = "REPLICA_STUDY_MODULE_NOT_FOUND";
  ErrorCodeEnum2["REQUIRED_KAFKA_USERNAME_AND_PASSWORD"] = "REQUIRED_KAFKA_USERNAME_AND_PASSWORD";
  ErrorCodeEnum2["REQUIRED_STUDY_SETTING_IS_NOT_SUPPORTED_FOR_THIS_FEED_RESERVATION_ITEM_TYPE"] = "REQUIRED_STUDY_SETTING_IS_NOT_SUPPORTED_FOR_THIS_FEED_RESERVATION_ITEM_TYPE";
  ErrorCodeEnum2["RSM_ID_OF_FEED_CANNOT_BE_FOUND"] = "RSM_ID_OF_FEED_CANNOT_BE_FOUND";
  ErrorCodeEnum2["SEND_MESSAGE_TIMEOUT"] = "SEND_MESSAGE_TIMEOUT";
  ErrorCodeEnum2["SENTENCE_DO_NOT_MATCH"] = "SENTENCE_DO_NOT_MATCH";
  ErrorCodeEnum2["SESSION_CLASSIFICATION_FAILED"] = "SESSION_CLASSIFICATION_FAILED";
  ErrorCodeEnum2["SOME_STUDY_ACTIVITY_ID_DUPLICATE"] = "SOME_STUDY_ACTIVITY_ID_DUPLICATE";
  ErrorCodeEnum2["SOME_STUDY_ACTIVITY_NOT_EXIST"] = "SOME_STUDY_ACTIVITY_NOT_EXIST";
  ErrorCodeEnum2["SOURCE_RCC_OF_FEED_CANNOT_BE_FOUND"] = "SOURCE_RCC_OF_FEED_CANNOT_BE_FOUND";
  ErrorCodeEnum2["STUDENT_IS_NOT_FOUND"] = "STUDENT_IS_NOT_FOUND";
  ErrorCodeEnum2["STUDY_ACTIVITY_ID_FROM_STUDY_ACTIVITY_INSTANCE_NOT_FOUND"] = "STUDY_ACTIVITY_ID_FROM_STUDY_ACTIVITY_INSTANCE_NOT_FOUND";
  ErrorCodeEnum2["STUDY_ACTIVITY_INSTANCE_NOT_FOUND"] = "STUDY_ACTIVITY_INSTANCE_NOT_FOUND";
  ErrorCodeEnum2["STUDY_OPTION_PRESET_NOT_CREATED"] = "STUDY_OPTION_PRESET_NOT_CREATED";
  ErrorCodeEnum2["STUDY_UNIT_TYPE_CANNOT_BE_SET"] = "STUDY_UNIT_TYPE_CANNOT_BE_SET";
  ErrorCodeEnum2["SUBMIT_MATH_QUESTION_ONLY_ALLOWED_FOR_MATH_QUESTION_TYPE_STUDY_ACTIVITY"] = "SUBMIT_MATH_QUESTION_ONLY_ALLOWED_FOR_MATH_QUESTION_TYPE_STUDY_ACTIVITY";
  ErrorCodeEnum2["SUBMIT_QUESTION_ONLY_ALLOWED_FOR_QUESTION_TYPE_STUDY_ACTIVITY"] = "SUBMIT_QUESTION_ONLY_ALLOWED_FOR_QUESTION_TYPE_STUDY_ACTIVITY";
  ErrorCodeEnum2["SUBMIT_QUESTION_WITHOUT_ANSWER_NOT_ALLOWED"] = "SUBMIT_QUESTION_WITHOUT_ANSWER_NOT_ALLOWED";
  ErrorCodeEnum2["TAG_RELATION_ID_NOT_FOUND"] = "TAG_RELATION_ID_NOT_FOUND";
  ErrorCodeEnum2["TEXTBOOK_DELETED_CAN_NOT_PROCESSED"] = "TEXTBOOK_DELETED_CAN_NOT_PROCESSED";
  ErrorCodeEnum2["TEXT_SENTENCE_DO_NOT_MATCH"] = "TEXT_SENTENCE_DO_NOT_MATCH";
  ErrorCodeEnum2["TOO_MANY_MESSAGES"] = "TOO_MANY_MESSAGES";
  ErrorCodeEnum2["UNAUTHORIZED"] = "UNAUTHORIZED";
  ErrorCodeEnum2["UNKNOWN"] = "UNKNOWN";
  ErrorCodeEnum2["UPDATE_ACTIVITY_SET_FAIL"] = "UPDATE_ACTIVITY_SET_FAIL";
  ErrorCodeEnum2["UPDATE_ACTIVITY_SET_UNIT_FAIL"] = "UPDATE_ACTIVITY_SET_UNIT_FAIL";
  ErrorCodeEnum2["UPDATE_DATA_ERROR"] = "UPDATE_DATA_ERROR";
  ErrorCodeEnum2["UPDATE_KNOWLEDGE_TAG_FAIL"] = "UPDATE_KNOWLEDGE_TAG_FAIL";
  ErrorCodeEnum2["USER_NOT_FOUND"] = "USER_NOT_FOUND";
  ErrorCodeEnum2["USER_NOT_JOINED_ON_ORGANIZATION"] = "USER_NOT_JOINED_ON_ORGANIZATION";
  ErrorCodeEnum2["VALIDATION_ARGS_NOT_FOUND"] = "VALIDATION_ARGS_NOT_FOUND";
  ErrorCodeEnum2["VERIFICATION_FAIL"] = "VERIFICATION_FAIL";
  ErrorCodeEnum2["VIDEO_READINGS_GROUP_VIEW_HAS_NO_OTHER_SA"] = "VIDEO_READINGS_GROUP_VIEW_HAS_NO_OTHER_SA";
  ErrorCodeEnum2["VIDEO_READINGS_GROUP_VIEW_HAS_NO_VIDEO"] = "VIDEO_READINGS_GROUP_VIEW_HAS_NO_VIDEO";
  ErrorCodeEnum2["VIEW_DATA_CONVERTING_ERROR"] = "VIEW_DATA_CONVERTING_ERROR";
  ErrorCodeEnum2["WORD_TEST_TITLE_PARSING_NOT_SUPPORTED"] = "WORD_TEST_TITLE_PARSING_NOT_SUPPORTED";
  return ErrorCodeEnum2;
})(ErrorCodeEnum || {});
var EstimationAnswerResultEnum = /* @__PURE__ */ ((EstimationAnswerResultEnum2) => {
  EstimationAnswerResultEnum2["CORRECT"] = "CORRECT";
  EstimationAnswerResultEnum2["IN_CORRECT"] = "IN_CORRECT";
  EstimationAnswerResultEnum2["PARTIAL_CORRECT"] = "PARTIAL_CORRECT";
  return EstimationAnswerResultEnum2;
})(EstimationAnswerResultEnum || {});
var EstimationLearningStatusEnum = /* @__PURE__ */ ((EstimationLearningStatusEnum2) => {
  EstimationLearningStatusEnum2["COMPLETED"] = "COMPLETED";
  EstimationLearningStatusEnum2["IN_PROGRESS"] = "IN_PROGRESS";
  EstimationLearningStatusEnum2["PENDING"] = "PENDING";
  return EstimationLearningStatusEnum2;
})(EstimationLearningStatusEnum || {});
var EstimationTypeEnum = /* @__PURE__ */ ((EstimationTypeEnum2) => {
  EstimationTypeEnum2["ACTIVITY"] = "ACTIVITY";
  EstimationTypeEnum2["ATTACHMENT_BLOCK"] = "ATTACHMENT_BLOCK";
  EstimationTypeEnum2["BLANK_QUIZ_BLOCK"] = "BLANK_QUIZ_BLOCK";
  EstimationTypeEnum2["BLANK_QUIZ_V2_BLOCK"] = "BLANK_QUIZ_V2_BLOCK";
  EstimationTypeEnum2["CHART_ANSWER_BLOCK"] = "CHART_ANSWER_BLOCK";
  EstimationTypeEnum2["DRAWING_BLOCK"] = "DRAWING_BLOCK";
  EstimationTypeEnum2["EXPLANATION_BLOCK"] = "EXPLANATION_BLOCK";
  EstimationTypeEnum2["EXTERNAL_EMBEDDED_BLOCK"] = "EXTERNAL_EMBEDDED_BLOCK";
  EstimationTypeEnum2["GENERAL_TEACHER_EMBEDDED_BLOCK"] = "GENERAL_TEACHER_EMBEDDED_BLOCK";
  EstimationTypeEnum2["GRAPH_ANSWER_BLOCK"] = "GRAPH_ANSWER_BLOCK";
  EstimationTypeEnum2["H1_SECTION"] = "H1_SECTION";
  EstimationTypeEnum2["H2_SECTION"] = "H2_SECTION";
  EstimationTypeEnum2["IMAGE_BLOCK"] = "IMAGE_BLOCK";
  EstimationTypeEnum2["LINE_MATCHING_BLOCK"] = "LINE_MATCHING_BLOCK";
  EstimationTypeEnum2["LINK_SHARE_BLOCK"] = "LINK_SHARE_BLOCK";
  EstimationTypeEnum2["LISTENING_BLOCK"] = "LISTENING_BLOCK";
  EstimationTypeEnum2["MATCHING_QUIZ_BLOCK"] = "MATCHING_QUIZ_BLOCK";
  EstimationTypeEnum2["MODUM_TEACHER_EMBEDDED_BLOCK"] = "MODUM_TEACHER_EMBEDDED_BLOCK";
  EstimationTypeEnum2["MULTIPLE_CHOICE_ANSWER_BLOCK"] = "MULTIPLE_CHOICE_ANSWER_BLOCK";
  EstimationTypeEnum2["MULTIPLE_CHOICE_ANSWER_WITHOUT_GRADING_BLOCK"] = "MULTIPLE_CHOICE_ANSWER_WITHOUT_GRADING_BLOCK";
  EstimationTypeEnum2["PARAGRAPH_BLOCK"] = "PARAGRAPH_BLOCK";
  EstimationTypeEnum2["SELECTION_QUIZ_BLOCK"] = "SELECTION_QUIZ_BLOCK";
  EstimationTypeEnum2["SHORT_ANSWER_BLOCK"] = "SHORT_ANSWER_BLOCK";
  EstimationTypeEnum2["SHORT_ANSWER_WITHOUT_GRADING_BLOCK"] = "SHORT_ANSWER_WITHOUT_GRADING_BLOCK";
  EstimationTypeEnum2["SPEAKING_BLOCK"] = "SPEAKING_BLOCK";
  EstimationTypeEnum2["TABLE_ANSWER_BLOCK"] = "TABLE_ANSWER_BLOCK";
  EstimationTypeEnum2["TABLE_BLOCK"] = "TABLE_BLOCK";
  EstimationTypeEnum2["TARGETING_QUIZ_BLOCK"] = "TARGETING_QUIZ_BLOCK";
  EstimationTypeEnum2["VIDEO_BLOCK"] = "VIDEO_BLOCK";
  EstimationTypeEnum2["WEB_CONTENT_CONTAINER_BLOCK"] = "WEB_CONTENT_CONTAINER_BLOCK";
  EstimationTypeEnum2["WEB_CONTENT_MULTIPLE_CHOICE_ANSWER_BLOCK"] = "WEB_CONTENT_MULTIPLE_CHOICE_ANSWER_BLOCK";
  EstimationTypeEnum2["WEB_CONTENT_NON_ANSWER_BLOCK"] = "WEB_CONTENT_NON_ANSWER_BLOCK";
  EstimationTypeEnum2["WEB_CONTENT_SHORT_ANSWER_BLOCK"] = "WEB_CONTENT_SHORT_ANSWER_BLOCK";
  EstimationTypeEnum2["WEB_CONTENT_SPEAKING_BLOCK"] = "WEB_CONTENT_SPEAKING_BLOCK";
  return EstimationTypeEnum2;
})(EstimationTypeEnum || {});
var EventLogTypeEnum = /* @__PURE__ */ ((EventLogTypeEnum2) => {
  EventLogTypeEnum2["AI_AGENT"] = "AI_AGENT";
  EventLogTypeEnum2["CLASS_ABSENCE"] = "CLASS_ABSENCE";
  EventLogTypeEnum2["CLASS_ENDED"] = "CLASS_ENDED";
  EventLogTypeEnum2["CLASS_STARTED"] = "CLASS_STARTED";
  EventLogTypeEnum2["CONSECUTIVE_WRONG_ANSWERS"] = "CONSECUTIVE_WRONG_ANSWERS";
  EventLogTypeEnum2["FEED_COMPLETED"] = "FEED_COMPLETED";
  EventLogTypeEnum2["FEED_ENTERED"] = "FEED_ENTERED";
  EventLogTypeEnum2["STUDY_TIME_EXCEEDED"] = "STUDY_TIME_EXCEEDED";
  EventLogTypeEnum2["TIMER"] = "TIMER";
  EventLogTypeEnum2["UNIT_COMPLETED"] = "UNIT_COMPLETED";
  EventLogTypeEnum2["UNIT_ENTERED"] = "UNIT_ENTERED";
  return EventLogTypeEnum2;
})(EventLogTypeEnum || {});
var ExamDifficultyTypeEnum = /* @__PURE__ */ ((ExamDifficultyTypeEnum2) => {
  ExamDifficultyTypeEnum2["A"] = "A";
  ExamDifficultyTypeEnum2["B"] = "B";
  ExamDifficultyTypeEnum2["C"] = "C";
  ExamDifficultyTypeEnum2["D"] = "D";
  ExamDifficultyTypeEnum2["E"] = "E";
  return ExamDifficultyTypeEnum2;
})(ExamDifficultyTypeEnum || {});
var ExamGoalTypeEnum = /* @__PURE__ */ ((ExamGoalTypeEnum2) => {
  ExamGoalTypeEnum2["HIGH_SCHOOL"] = "HIGH_SCHOOL";
  ExamGoalTypeEnum2["MIDDLE_SCHOOL"] = "MIDDLE_SCHOOL";
  ExamGoalTypeEnum2["SCORE"] = "SCORE";
  ExamGoalTypeEnum2["UNIVERSITY"] = "UNIVERSITY";
  return ExamGoalTypeEnum2;
})(ExamGoalTypeEnum || {});
var ExamSatisfactionLevelTypeEnum = /* @__PURE__ */ ((ExamSatisfactionLevelTypeEnum2) => {
  ExamSatisfactionLevelTypeEnum2["SATISFIED"] = "SATISFIED";
  ExamSatisfactionLevelTypeEnum2["UNCERTAIN"] = "UNCERTAIN";
  ExamSatisfactionLevelTypeEnum2["UNSATISFIED"] = "UNSATISFIED";
  return ExamSatisfactionLevelTypeEnum2;
})(ExamSatisfactionLevelTypeEnum || {});
var ExternalCompanyNameEnum = /* @__PURE__ */ ((ExternalCompanyNameEnum2) => {
  ExternalCompanyNameEnum2["ETOOS"] = "ETOOS";
  ExternalCompanyNameEnum2["MEGASTUDY"] = "MEGASTUDY";
  return ExternalCompanyNameEnum2;
})(ExternalCompanyNameEnum || {});
var FeedChangeReasonTypeEnum = /* @__PURE__ */ ((FeedChangeReasonTypeEnum2) => {
  FeedChangeReasonTypeEnum2["DIFFICULTY_AND_QUANTITY_CONTROL"] = "DIFFICULTY_AND_QUANTITY_CONTROL";
  FeedChangeReasonTypeEnum2["ETC"] = "ETC";
  FeedChangeReasonTypeEnum2["SYSTEM_ERROR_HANDLING"] = "SYSTEM_ERROR_HANDLING";
  FeedChangeReasonTypeEnum2["TEST_COVERAGE_CHANGES"] = "TEST_COVERAGE_CHANGES";
  return FeedChangeReasonTypeEnum2;
})(FeedChangeReasonTypeEnum || {});
var FeedCompleteStatusEnum = /* @__PURE__ */ ((FeedCompleteStatusEnum2) => {
  FeedCompleteStatusEnum2["COMPLETED"] = "COMPLETED";
  FeedCompleteStatusEnum2["NOT_STARTED"] = "NOT_STARTED";
  FeedCompleteStatusEnum2["STARTED"] = "STARTED";
  return FeedCompleteStatusEnum2;
})(FeedCompleteStatusEnum || {});
var FeedLearningStateEnum = /* @__PURE__ */ ((FeedLearningStateEnum2) => {
  FeedLearningStateEnum2["FINISHED"] = "FINISHED";
  FeedLearningStateEnum2["PARTLY_LEARNED"] = "PARTLY_LEARNED";
  FeedLearningStateEnum2["UNLEARNED"] = "UNLEARNED";
  return FeedLearningStateEnum2;
})(FeedLearningStateEnum || {});
var FeedReservationTypeEnum = /* @__PURE__ */ ((FeedReservationTypeEnum2) => {
  FeedReservationTypeEnum2["ADVERTISEMENT"] = "ADVERTISEMENT";
  FeedReservationTypeEnum2["AUTO_REVIEW_QUESTION"] = "AUTO_REVIEW_QUESTION";
  FeedReservationTypeEnum2["ENGLISH_QUESTION"] = "ENGLISH_QUESTION";
  FeedReservationTypeEnum2["GRAMMAR_QUESTION"] = "GRAMMAR_QUESTION";
  FeedReservationTypeEnum2["GROUP_DAILY_STUDY"] = "GROUP_DAILY_STUDY";
  FeedReservationTypeEnum2["GROUP_WEKKLY_TEST"] = "GROUP_WEKKLY_TEST";
  FeedReservationTypeEnum2["IMPORTANT_SENTENCE"] = "IMPORTANT_SENTENCE";
  FeedReservationTypeEnum2["KNOWLEDGE_TAG"] = "KNOWLEDGE_TAG";
  FeedReservationTypeEnum2["LECTURE"] = "LECTURE";
  FeedReservationTypeEnum2["MATH_QUESTION"] = "MATH_QUESTION";
  FeedReservationTypeEnum2["MONTHLY_REPOORT"] = "MONTHLY_REPOORT";
  FeedReservationTypeEnum2["NOTICE"] = "NOTICE";
  FeedReservationTypeEnum2["NOTICE_AND_EVENT"] = "NOTICE_AND_EVENT";
  FeedReservationTypeEnum2["RECOMMENDATION_GRAMMAR_QUESTION"] = "RECOMMENDATION_GRAMMAR_QUESTION";
  FeedReservationTypeEnum2["RECOMMENDATION_QUESTION"] = "RECOMMENDATION_QUESTION";
  FeedReservationTypeEnum2["STUDY_MODULE"] = "STUDY_MODULE";
  FeedReservationTypeEnum2["TEXT"] = "TEXT";
  FeedReservationTypeEnum2["WORDBOOK"] = "WORDBOOK";
  FeedReservationTypeEnum2["WORD_REVIEW"] = "WORD_REVIEW";
  FeedReservationTypeEnum2["WORD_TEST"] = "WORD_TEST";
  FeedReservationTypeEnum2["WRONG_ANSWER"] = "WRONG_ANSWER";
  FeedReservationTypeEnum2["WRONG_RECOMMENDATION_QUESTION"] = "WRONG_RECOMMENDATION_QUESTION";
  FeedReservationTypeEnum2["WRONG_WORD_TEST"] = "WRONG_WORD_TEST";
  return FeedReservationTypeEnum2;
})(FeedReservationTypeEnum || {});
var FeedSendPresetTypeEnum = /* @__PURE__ */ ((FeedSendPresetTypeEnum2) => {
  FeedSendPresetTypeEnum2["COLLECTION"] = "COLLECTION";
  FeedSendPresetTypeEnum2["GENERAL"] = "GENERAL";
  return FeedSendPresetTypeEnum2;
})(FeedSendPresetTypeEnum || {});
var FeedTypeEnum = /* @__PURE__ */ ((FeedTypeEnum2) => {
  FeedTypeEnum2["ADVERTISEMENT"] = "ADVERTISEMENT";
  FeedTypeEnum2["AUTO_REVIEW_QUESTION"] = "AUTO_REVIEW_QUESTION";
  FeedTypeEnum2["ENGLISH_QUESTION"] = "ENGLISH_QUESTION";
  FeedTypeEnum2["GRAMMAR_QUESTION"] = "GRAMMAR_QUESTION";
  FeedTypeEnum2["GROUP_DAILY_STUDY"] = "GROUP_DAILY_STUDY";
  FeedTypeEnum2["GROUP_WEKKLY_TEST"] = "GROUP_WEKKLY_TEST";
  FeedTypeEnum2["IMPORTANT_SENTENCE"] = "IMPORTANT_SENTENCE";
  FeedTypeEnum2["KNOWLEDGE_TAG"] = "KNOWLEDGE_TAG";
  FeedTypeEnum2["LECTURE"] = "LECTURE";
  FeedTypeEnum2["MATH_QUESTION"] = "MATH_QUESTION";
  FeedTypeEnum2["MONTHLY_REPOORT"] = "MONTHLY_REPOORT";
  FeedTypeEnum2["NOTICE"] = "NOTICE";
  FeedTypeEnum2["NOTICE_AND_EVENT"] = "NOTICE_AND_EVENT";
  FeedTypeEnum2["PROGRESS"] = "PROGRESS";
  FeedTypeEnum2["RECOMMENDATION_GRAMMAR_QUESTION"] = "RECOMMENDATION_GRAMMAR_QUESTION";
  FeedTypeEnum2["RECOMMENDATION_QUESTION"] = "RECOMMENDATION_QUESTION";
  FeedTypeEnum2["STUDY_MODULE"] = "STUDY_MODULE";
  FeedTypeEnum2["TEXT"] = "TEXT";
  FeedTypeEnum2["WORDBOOK"] = "WORDBOOK";
  FeedTypeEnum2["WORD_REVIEW"] = "WORD_REVIEW";
  FeedTypeEnum2["WORD_TEST"] = "WORD_TEST";
  FeedTypeEnum2["WRONG_ANSWER"] = "WRONG_ANSWER";
  FeedTypeEnum2["WRONG_RECOMMENDATION_QUESTION"] = "WRONG_RECOMMENDATION_QUESTION";
  FeedTypeEnum2["WRONG_WORD_TEST"] = "WRONG_WORD_TEST";
  return FeedTypeEnum2;
})(FeedTypeEnum || {});
var FeedbackReactionEnum = /* @__PURE__ */ ((FeedbackReactionEnum2) => {
  FeedbackReactionEnum2["DISLIKE"] = "DISLIKE";
  FeedbackReactionEnum2["LIKE"] = "LIKE";
  return FeedbackReactionEnum2;
})(FeedbackReactionEnum || {});
var FeedbackRequestStatusEnum = /* @__PURE__ */ ((FeedbackRequestStatusEnum2) => {
  FeedbackRequestStatusEnum2["IDLE"] = "IDLE";
  FeedbackRequestStatusEnum2["REQUESTED"] = "REQUESTED";
  FeedbackRequestStatusEnum2["RESOLVED"] = "RESOLVED";
  return FeedbackRequestStatusEnum2;
})(FeedbackRequestStatusEnum || {});
var FileTypeEnum = /* @__PURE__ */ ((FileTypeEnum2) => {
  FileTypeEnum2["AUDIO"] = "AUDIO";
  FileTypeEnum2["FILE"] = "FILE";
  FileTypeEnum2["IMAGE"] = "IMAGE";
  FileTypeEnum2["SUBTITLE"] = "SUBTITLE";
  FileTypeEnum2["TEXT"] = "TEXT";
  FileTypeEnum2["VIDEO"] = "VIDEO";
  return FileTypeEnum2;
})(FileTypeEnum || {});
var FileUsageEnum = /* @__PURE__ */ ((FileUsageEnum2) => {
  FileUsageEnum2["HANDWRITING"] = "HANDWRITING";
  FileUsageEnum2["USER_PROFILE"] = "USER_PROFILE";
  return FileUsageEnum2;
})(FileUsageEnum || {});
var FilterRuleCategoryEnum = /* @__PURE__ */ ((FilterRuleCategoryEnum2) => {
  FilterRuleCategoryEnum2["CONTENT_BUILDER"] = "CONTENT_BUILDER";
  FilterRuleCategoryEnum2["FILTER_RULE"] = "FILTER_RULE";
  return FilterRuleCategoryEnum2;
})(FilterRuleCategoryEnum || {});
var FinalStateEnum = /* @__PURE__ */ ((FinalStateEnum2) => {
  FinalStateEnum2["ACQUIRED"] = "ACQUIRED";
  FinalStateEnum2["CANNOT_BE_ACQUIRED"] = "CANNOT_BE_ACQUIRED";
  FinalStateEnum2["NEED_ACQUIRED"] = "NEED_ACQUIRED";
  FinalStateEnum2["NOT_SET"] = "NOT_SET";
  FinalStateEnum2["START_LEARNING"] = "START_LEARNING";
  return FinalStateEnum2;
})(FinalStateEnum || {});
var FirstIntegratedActivityTypeEnum = /* @__PURE__ */ ((FirstIntegratedActivityTypeEnum2) => {
  FirstIntegratedActivityTypeEnum2["LearningActivity"] = "LearningActivity";
  FirstIntegratedActivityTypeEnum2["StudyActivityInstance"] = "StudyActivityInstance";
  return FirstIntegratedActivityTypeEnum2;
})(FirstIntegratedActivityTypeEnum || {});
var GradientColorTypeEnum = /* @__PURE__ */ ((GradientColorTypeEnum2) => {
  GradientColorTypeEnum2["LINEAR"] = "LINEAR";
  return GradientColorTypeEnum2;
})(GradientColorTypeEnum || {});
var GrammarOrderFieldTypeEnum = /* @__PURE__ */ ((GrammarOrderFieldTypeEnum2) => {
  GrammarOrderFieldTypeEnum2["CREATED_AT"] = "CREATED_AT";
  GrammarOrderFieldTypeEnum2["TITLE"] = "TITLE";
  return GrammarOrderFieldTypeEnum2;
})(GrammarOrderFieldTypeEnum || {});
var GraphDotInteractionActionEnum = /* @__PURE__ */ ((GraphDotInteractionActionEnum2) => {
  GraphDotInteractionActionEnum2["GRAPH"] = "GRAPH";
  GraphDotInteractionActionEnum2["UNLIMITED"] = "UNLIMITED";
  return GraphDotInteractionActionEnum2;
})(GraphDotInteractionActionEnum || {});
var GraphDotInteractionExposureOptionEnum = /* @__PURE__ */ ((GraphDotInteractionExposureOptionEnum2) => {
  GraphDotInteractionExposureOptionEnum2["COORDINATE"] = "COORDINATE";
  return GraphDotInteractionExposureOptionEnum2;
})(GraphDotInteractionExposureOptionEnum || {});
var GraphInteractionSubTypeEnum = /* @__PURE__ */ ((GraphInteractionSubTypeEnum2) => {
  GraphInteractionSubTypeEnum2["DOT_POINT"] = "DOT_POINT";
  GraphInteractionSubTypeEnum2["DRAG_POINT"] = "DRAG_POINT";
  return GraphInteractionSubTypeEnum2;
})(GraphInteractionSubTypeEnum || {});
var GraphInteractionTypeEnum = /* @__PURE__ */ ((GraphInteractionTypeEnum2) => {
  GraphInteractionTypeEnum2["DRAW_GRAPH"] = "DRAW_GRAPH";
  GraphInteractionTypeEnum2["FIND_COORDINATE"] = "FIND_COORDINATE";
  return GraphInteractionTypeEnum2;
})(GraphInteractionTypeEnum || {});
var GraphObjectTypeEnum = /* @__PURE__ */ ((GraphObjectTypeEnum2) => {
  GraphObjectTypeEnum2["GRAPH"] = "GRAPH";
  GraphObjectTypeEnum2["LABEL"] = "LABEL";
  GraphObjectTypeEnum2["POINT"] = "POINT";
  return GraphObjectTypeEnum2;
})(GraphObjectTypeEnum || {});
var GraphShapeTypeEnum = /* @__PURE__ */ ((GraphShapeTypeEnum2) => {
  GraphShapeTypeEnum2["LINEAR_FUNCTION"] = "LINEAR_FUNCTION";
  GraphShapeTypeEnum2["QUADRATIC_FUNCTION"] = "QUADRATIC_FUNCTION";
  return GraphShapeTypeEnum2;
})(GraphShapeTypeEnum || {});
var GroupHistoryActionTypesEnum = /* @__PURE__ */ ((GroupHistoryActionTypesEnum2) => {
  GroupHistoryActionTypesEnum2["JOIN"] = "JOIN";
  GroupHistoryActionTypesEnum2["LEAVE"] = "LEAVE";
  return GroupHistoryActionTypesEnum2;
})(GroupHistoryActionTypesEnum || {});
var GroupPauseTargetEnum = /* @__PURE__ */ ((GroupPauseTargetEnum2) => {
  GroupPauseTargetEnum2["AUTO_SEND_FEED"] = "AUTO_SEND_FEED";
  GroupPauseTargetEnum2["NOTIFICATION"] = "NOTIFICATION";
  GroupPauseTargetEnum2["RESERVATION_FEED"] = "RESERVATION_FEED";
  GroupPauseTargetEnum2["WEEKLY_REPORT"] = "WEEKLY_REPORT";
  return GroupPauseTargetEnum2;
})(GroupPauseTargetEnum || {});
var GroupPostKindEnum = /* @__PURE__ */ ((GroupPostKindEnum2) => {
  GroupPostKindEnum2["MEMO"] = "MEMO";
  GroupPostKindEnum2["NOTICE"] = "NOTICE";
  return GroupPostKindEnum2;
})(GroupPostKindEnum || {});
var GroupReplicaCurriculumStatusEnum = /* @__PURE__ */ ((GroupReplicaCurriculumStatusEnum2) => {
  GroupReplicaCurriculumStatusEnum2["COMPLETE"] = "COMPLETE";
  GroupReplicaCurriculumStatusEnum2["ERROR"] = "ERROR";
  GroupReplicaCurriculumStatusEnum2["LOADING"] = "LOADING";
  return GroupReplicaCurriculumStatusEnum2;
})(GroupReplicaCurriculumStatusEnum || {});
var GroupReplicaCurriculumTypeEnum = /* @__PURE__ */ ((GroupReplicaCurriculumTypeEnum2) => {
  GroupReplicaCurriculumTypeEnum2["GENERAL"] = "GENERAL";
  GroupReplicaCurriculumTypeEnum2["KT_PLAN_TO_FEED"] = "KT_PLAN_TO_FEED";
  GroupReplicaCurriculumTypeEnum2["KT_TO_FEED"] = "KT_TO_FEED";
  GroupReplicaCurriculumTypeEnum2["RECOMMEND"] = "RECOMMEND";
  GroupReplicaCurriculumTypeEnum2["WRONG"] = "WRONG";
  return GroupReplicaCurriculumTypeEnum2;
})(GroupReplicaCurriculumTypeEnum || {});
var GroupThemeTypeEnum = /* @__PURE__ */ ((GroupThemeTypeEnum2) => {
  GroupThemeTypeEnum2["COLOR"] = "COLOR";
  GroupThemeTypeEnum2["IMAGE"] = "IMAGE";
  return GroupThemeTypeEnum2;
})(GroupThemeTypeEnum || {});
var GroupUserAttendanceStatusTypeEnum = /* @__PURE__ */ ((GroupUserAttendanceStatusTypeEnum2) => {
  GroupUserAttendanceStatusTypeEnum2["ABSENCE"] = "ABSENCE";
  GroupUserAttendanceStatusTypeEnum2["ATTENDANCE"] = "ATTENDANCE";
  GroupUserAttendanceStatusTypeEnum2["NONE"] = "NONE";
  return GroupUserAttendanceStatusTypeEnum2;
})(GroupUserAttendanceStatusTypeEnum || {});
var GroupUserStateEnum = /* @__PURE__ */ ((GroupUserStateEnum2) => {
  GroupUserStateEnum2["JOINED"] = "JOINED";
  GroupUserStateEnum2["READY"] = "READY";
  GroupUserStateEnum2["REJECTED"] = "REJECTED";
  return GroupUserStateEnum2;
})(GroupUserStateEnum || {});
var GroupUserTypeInGroupEnum = /* @__PURE__ */ ((GroupUserTypeInGroupEnum2) => {
  GroupUserTypeInGroupEnum2["ADMIN"] = "ADMIN";
  GroupUserTypeInGroupEnum2["NORMAL"] = "NORMAL";
  return GroupUserTypeInGroupEnum2;
})(GroupUserTypeInGroupEnum || {});
var GroupUserTypesEnum = /* @__PURE__ */ ((GroupUserTypesEnum2) => {
  GroupUserTypesEnum2["MANAGER"] = "MANAGER";
  GroupUserTypesEnum2["STUDENT"] = "STUDENT";
  return GroupUserTypesEnum2;
})(GroupUserTypesEnum || {});
var HandwritingCategoryEnum = /* @__PURE__ */ ((HandwritingCategoryEnum2) => {
  HandwritingCategoryEnum2["DRAWING_BLOCK"] = "DRAWING_BLOCK";
  HandwritingCategoryEnum2["LEARNING_ACTIVITY"] = "LEARNING_ACTIVITY";
  HandwritingCategoryEnum2["LEARNING_ACTIVITY_MODUM"] = "LEARNING_ACTIVITY_MODUM";
  HandwritingCategoryEnum2["LEARNING_ACTIVITY_PRESENTATION"] = "LEARNING_ACTIVITY_PRESENTATION";
  return HandwritingCategoryEnum2;
})(HandwritingCategoryEnum || {});
var HandwritingSenderTypeEnum = /* @__PURE__ */ ((HandwritingSenderTypeEnum2) => {
  HandwritingSenderTypeEnum2["MANAGER"] = "MANAGER";
  HandwritingSenderTypeEnum2["STUDENT"] = "STUDENT";
  HandwritingSenderTypeEnum2["SYSTEM"] = "SYSTEM";
  return HandwritingSenderTypeEnum2;
})(HandwritingSenderTypeEnum || {});
var HandwritingStateEnum = /* @__PURE__ */ ((HandwritingStateEnum2) => {
  HandwritingStateEnum2["ACTIVE"] = "ACTIVE";
  HandwritingStateEnum2["INACTIVE"] = "INACTIVE";
  return HandwritingStateEnum2;
})(HandwritingStateEnum || {});
var KnowledgeTagsOrderFieldEnum = /* @__PURE__ */ ((KnowledgeTagsOrderFieldEnum2) => {
  KnowledgeTagsOrderFieldEnum2["LABEL"] = "LABEL";
  return KnowledgeTagsOrderFieldEnum2;
})(KnowledgeTagsOrderFieldEnum || {});
var LearningActivityModumExistenceStatusEnum = /* @__PURE__ */ ((LearningActivityModumExistenceStatusEnum2) => {
  LearningActivityModumExistenceStatusEnum2["EXIST"] = "EXIST";
  LearningActivityModumExistenceStatusEnum2["NONE"] = "NONE";
  LearningActivityModumExistenceStatusEnum2["NOT_EXIST"] = "NOT_EXIST";
  return LearningActivityModumExistenceStatusEnum2;
})(LearningActivityModumExistenceStatusEnum || {});
var LearningPlanItemTypeEnum = /* @__PURE__ */ ((LearningPlanItemTypeEnum2) => {
  LearningPlanItemTypeEnum2["DEFAULT"] = "DEFAULT";
  LearningPlanItemTypeEnum2["EVALUATION"] = "EVALUATION";
  return LearningPlanItemTypeEnum2;
})(LearningPlanItemTypeEnum || {});
var LearningPlanStateEnum = /* @__PURE__ */ ((LearningPlanStateEnum2) => {
  LearningPlanStateEnum2["DISABLE"] = "DISABLE";
  LearningPlanStateEnum2["ENABLE"] = "ENABLE";
  return LearningPlanStateEnum2;
})(LearningPlanStateEnum || {});
var LearningStateEnum = /* @__PURE__ */ ((LearningStateEnum2) => {
  LearningStateEnum2["FINISHED"] = "FINISHED";
  LearningStateEnum2["PARTLY_LEARNED"] = "PARTLY_LEARNED";
  LearningStateEnum2["UNLEARNED"] = "UNLEARNED";
  return LearningStateEnum2;
})(LearningStateEnum || {});
var LectureFeedbackSelectEnum = /* @__PURE__ */ ((LectureFeedbackSelectEnum2) => {
  LectureFeedbackSelectEnum2["LECTURE_GOOD"] = "LECTURE_GOOD";
  LectureFeedbackSelectEnum2["LECTURE_NOT_GOOD"] = "LECTURE_NOT_GOOD";
  return LectureFeedbackSelectEnum2;
})(LectureFeedbackSelectEnum || {});
var LinkInTeacherEmbeddedBlockExistenceStatusEnum = /* @__PURE__ */ ((LinkInTeacherEmbeddedBlockExistenceStatusEnum2) => {
  LinkInTeacherEmbeddedBlockExistenceStatusEnum2["EXIST"] = "EXIST";
  LinkInTeacherEmbeddedBlockExistenceStatusEnum2["NONE"] = "NONE";
  LinkInTeacherEmbeddedBlockExistenceStatusEnum2["NOT_EXIST"] = "NOT_EXIST";
  return LinkInTeacherEmbeddedBlockExistenceStatusEnum2;
})(LinkInTeacherEmbeddedBlockExistenceStatusEnum || {});
var LinkableTagTargetEnum = /* @__PURE__ */ ((LinkableTagTargetEnum2) => {
  LinkableTagTargetEnum2["STUDY_ACTIVITY"] = "STUDY_ACTIVITY";
  return LinkableTagTargetEnum2;
})(LinkableTagTargetEnum || {});
var MRPresetCommentInitStatusEnum = /* @__PURE__ */ ((MRPresetCommentInitStatusEnum2) => {
  MRPresetCommentInitStatusEnum2["ALREADY_CREATED"] = "ALREADY_CREATED";
  MRPresetCommentInitStatusEnum2["CREATED"] = "CREATED";
  return MRPresetCommentInitStatusEnum2;
})(MRPresetCommentInitStatusEnum || {});
var ManagedTagSubjectEnum = /* @__PURE__ */ ((ManagedTagSubjectEnum2) => {
  ManagedTagSubjectEnum2["ENGLISH"] = "ENGLISH";
  ManagedTagSubjectEnum2["KOREAN"] = "KOREAN";
  ManagedTagSubjectEnum2["MATH"] = "MATH";
  ManagedTagSubjectEnum2["NONE"] = "NONE";
  return ManagedTagSubjectEnum2;
})(ManagedTagSubjectEnum || {});
var ManagerCompleteStudyStateOrderFieldEnum = /* @__PURE__ */ ((ManagerCompleteStudyStateOrderFieldEnum2) => {
  ManagerCompleteStudyStateOrderFieldEnum2["CLASS_STATE"] = "CLASS_STATE";
  ManagerCompleteStudyStateOrderFieldEnum2["COMPLETE_RATE"] = "COMPLETE_RATE";
  ManagerCompleteStudyStateOrderFieldEnum2["GROUP_NAME"] = "GROUP_NAME";
  ManagerCompleteStudyStateOrderFieldEnum2["MANGER_NAME"] = "MANGER_NAME";
  ManagerCompleteStudyStateOrderFieldEnum2["STUDENT_NAME"] = "STUDENT_NAME";
  return ManagerCompleteStudyStateOrderFieldEnum2;
})(ManagerCompleteStudyStateOrderFieldEnum || {});
var MarkableStudyActivityTypesEnum = /* @__PURE__ */ ((MarkableStudyActivityTypesEnum2) => {
  MarkableStudyActivityTypesEnum2["READING"] = "READING";
  MarkableStudyActivityTypesEnum2["SENTENCE_COMPLETE_BLOCKS"] = "SENTENCE_COMPLETE_BLOCKS";
  MarkableStudyActivityTypesEnum2["SENTENCE_COMPLETE_WHOLE_BLOCKS"] = "SENTENCE_COMPLETE_WHOLE_BLOCKS";
  MarkableStudyActivityTypesEnum2["SENTENCE_GRAMMAR_STUDY"] = "SENTENCE_GRAMMAR_STUDY";
  MarkableStudyActivityTypesEnum2["SENTENCE_MATCH_BLANK_BLOCKS"] = "SENTENCE_MATCH_BLANK_BLOCKS";
  MarkableStudyActivityTypesEnum2["SENTENCE_MATCH_WHOLE_BLOCKS"] = "SENTENCE_MATCH_WHOLE_BLOCKS";
  return MarkableStudyActivityTypesEnum2;
})(MarkableStudyActivityTypesEnum || {});
var MathAiTutorStateEnum = /* @__PURE__ */ ((MathAiTutorStateEnum2) => {
  MathAiTutorStateEnum2["ACTIVE"] = "ACTIVE";
  MathAiTutorStateEnum2["INACTIVE"] = "INACTIVE";
  return MathAiTutorStateEnum2;
})(MathAiTutorStateEnum || {});
var MessageEventTypeEnum = /* @__PURE__ */ ((MessageEventTypeEnum2) => {
  MessageEventTypeEnum2["MESSAGE_DELETED"] = "MESSAGE_DELETED";
  MessageEventTypeEnum2["MESSAGE_RECEIVED"] = "MESSAGE_RECEIVED";
  MessageEventTypeEnum2["MESSAGE_UPDATED"] = "MESSAGE_UPDATED";
  MessageEventTypeEnum2["REACTION_ADDED"] = "REACTION_ADDED";
  MessageEventTypeEnum2["REACTION_DELETED"] = "REACTION_DELETED";
  return MessageEventTypeEnum2;
})(MessageEventTypeEnum || {});
var MessageTypeEnum = /* @__PURE__ */ ((MessageTypeEnum2) => {
  MessageTypeEnum2["LOG"] = "LOG";
  MessageTypeEnum2["NORMAL"] = "NORMAL";
  return MessageTypeEnum2;
})(MessageTypeEnum || {});
var MetaChapterStatusTypeEnum = /* @__PURE__ */ ((MetaChapterStatusTypeEnum2) => {
  MetaChapterStatusTypeEnum2["COMPLETE"] = "COMPLETE";
  MetaChapterStatusTypeEnum2["INCOMPLETE"] = "INCOMPLETE";
  return MetaChapterStatusTypeEnum2;
})(MetaChapterStatusTypeEnum || {});
var MetaContentContentTypeEnum = /* @__PURE__ */ ((MetaContentContentTypeEnum2) => {
  MetaContentContentTypeEnum2["GRAMMAR"] = "GRAMMAR";
  return MetaContentContentTypeEnum2;
})(MetaContentContentTypeEnum || {});
var MetaContentDifficultyEnum = /* @__PURE__ */ ((MetaContentDifficultyEnum2) => {
  MetaContentDifficultyEnum2["COMMON"] = "COMMON";
  MetaContentDifficultyEnum2["EASY"] = "EASY";
  MetaContentDifficultyEnum2["HARD"] = "HARD";
  MetaContentDifficultyEnum2["NORMAL"] = "NORMAL";
  return MetaContentDifficultyEnum2;
})(MetaContentDifficultyEnum || {});
var MetaContentLearningPurposeEnum = /* @__PURE__ */ ((MetaContentLearningPurposeEnum2) => {
  MetaContentLearningPurposeEnum2["NAESIN"] = "NAESIN";
  MetaContentLearningPurposeEnum2["NORMAL"] = "NORMAL";
  MetaContentLearningPurposeEnum2["SUNEUNG"] = "SUNEUNG";
  return MetaContentLearningPurposeEnum2;
})(MetaContentLearningPurposeEnum || {});
var MetaContentModuleContentTypeEnum = /* @__PURE__ */ ((MetaContentModuleContentTypeEnum2) => {
  MetaContentModuleContentTypeEnum2["GRAMMAR"] = "GRAMMAR";
  return MetaContentModuleContentTypeEnum2;
})(MetaContentModuleContentTypeEnum || {});
var MetaContentModuleImportanceTypeEnum = /* @__PURE__ */ ((MetaContentModuleImportanceTypeEnum2) => {
  MetaContentModuleImportanceTypeEnum2["A"] = "A";
  MetaContentModuleImportanceTypeEnum2["B"] = "B";
  MetaContentModuleImportanceTypeEnum2["C"] = "C";
  MetaContentModuleImportanceTypeEnum2["D"] = "D";
  MetaContentModuleImportanceTypeEnum2["E"] = "E";
  return MetaContentModuleImportanceTypeEnum2;
})(MetaContentModuleImportanceTypeEnum || {});
var MetaContentModuleTypeEnum = /* @__PURE__ */ ((MetaContentModuleTypeEnum2) => {
  MetaContentModuleTypeEnum2["BLOCK"] = "BLOCK";
  MetaContentModuleTypeEnum2["NORMAL"] = "NORMAL";
  MetaContentModuleTypeEnum2["TEXT"] = "TEXT";
  MetaContentModuleTypeEnum2["WORD_BOOK"] = "WORD_BOOK";
  return MetaContentModuleTypeEnum2;
})(MetaContentModuleTypeEnum || {});
var MetaContentOrderFieldTypeEnum = /* @__PURE__ */ ((MetaContentOrderFieldTypeEnum2) => {
  MetaContentOrderFieldTypeEnum2["CREATED_AT"] = "CREATED_AT";
  MetaContentOrderFieldTypeEnum2["TITLE"] = "TITLE";
  return MetaContentOrderFieldTypeEnum2;
})(MetaContentOrderFieldTypeEnum || {});
var MetaContentSubjectEnum = /* @__PURE__ */ ((MetaContentSubjectEnum2) => {
  MetaContentSubjectEnum2["ENGLISH"] = "ENGLISH";
  MetaContentSubjectEnum2["KOREAN"] = "KOREAN";
  MetaContentSubjectEnum2["MATH"] = "MATH";
  return MetaContentSubjectEnum2;
})(MetaContentSubjectEnum || {});
var MetaContentTargetGroupEnum = /* @__PURE__ */ ((MetaContentTargetGroupEnum2) => {
  MetaContentTargetGroupEnum2["HIGHSCHOOL"] = "HIGHSCHOOL";
  MetaContentTargetGroupEnum2["MIDDLESCHOOL"] = "MIDDLESCHOOL";
  MetaContentTargetGroupEnum2["TOTAL"] = "TOTAL";
  return MetaContentTargetGroupEnum2;
})(MetaContentTargetGroupEnum || {});
var MetaContentTypeEnum = /* @__PURE__ */ ((MetaContentTypeEnum2) => {
  MetaContentTypeEnum2["BLOCK"] = "BLOCK";
  MetaContentTypeEnum2["QUESTIONBANK"] = "QUESTIONBANK";
  MetaContentTypeEnum2["TEXTBOOK"] = "TEXTBOOK";
  MetaContentTypeEnum2["WORDBOOK"] = "WORDBOOK";
  return MetaContentTypeEnum2;
})(MetaContentTypeEnum || {});
var MonthlyReportPresetTypeEnum = /* @__PURE__ */ ((MonthlyReportPresetTypeEnum2) => {
  MonthlyReportPresetTypeEnum2["RATE"] = "RATE";
  MonthlyReportPresetTypeEnum2["TEXT"] = "TEXT";
  return MonthlyReportPresetTypeEnum2;
})(MonthlyReportPresetTypeEnum || {});
var MonthlyReportSubjectTypeEnum = /* @__PURE__ */ ((MonthlyReportSubjectTypeEnum2) => {
  MonthlyReportSubjectTypeEnum2["ENGLISH"] = "ENGLISH";
  MonthlyReportSubjectTypeEnum2["MATH"] = "MATH";
  return MonthlyReportSubjectTypeEnum2;
})(MonthlyReportSubjectTypeEnum || {});
var MpdStatusEnum = /* @__PURE__ */ ((MpdStatusEnum2) => {
  MpdStatusEnum2["LINK_CREATED"] = "LINK_CREATED";
  MpdStatusEnum2["NONE"] = "NONE";
  MpdStatusEnum2["REPORT_READY"] = "REPORT_READY";
  MpdStatusEnum2["SUBMITTED"] = "SUBMITTED";
  return MpdStatusEnum2;
})(MpdStatusEnum || {});
var MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum = /* @__PURE__ */ ((MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2) => {
  MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2["ANSWER_RATE"] = "ANSWER_RATE";
  MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2["CHOICE_1"] = "CHOICE_1";
  MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2["CHOICE_2"] = "CHOICE_2";
  MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2["CHOICE_3"] = "CHOICE_3";
  MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2["CHOICE_4"] = "CHOICE_4";
  MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2["CHOICE_5"] = "CHOICE_5";
  MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2["CHOICE_6"] = "CHOICE_6";
  MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2["SUBMIT_COUNT"] = "SUBMIT_COUNT";
  return MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum2;
})(MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum || {});
var OperationEnum = /* @__PURE__ */ ((OperationEnum2) => {
  OperationEnum2["AB_TEST_AI_FEEDBACK_B2C"] = "AB_TEST_AI_FEEDBACK_B2C";
  OperationEnum2["AB_TEST_AI_FEEDBACK_LMS"] = "AB_TEST_AI_FEEDBACK_LMS";
  OperationEnum2["AB_TEST_READING_HINT_B2C"] = "AB_TEST_READING_HINT_B2C";
  OperationEnum2["AB_TEST_READING_HINT_LMS"] = "AB_TEST_READING_HINT_LMS";
  OperationEnum2["AI_SULLIVAN"] = "AI_SULLIVAN";
  OperationEnum2["CMS"] = "CMS";
  OperationEnum2["CRM"] = "CRM";
  OperationEnum2["KNOWLEDGE_MAP"] = "KNOWLEDGE_MAP";
  OperationEnum2["KNOWLEDGE_TAG"] = "KNOWLEDGE_TAG";
  OperationEnum2["LMS"] = "LMS";
  OperationEnum2["RESOURCE_PERMISSION"] = "RESOURCE_PERMISSION";
  OperationEnum2["STUDENT"] = "STUDENT";
  OperationEnum2["TUTOR"] = "TUTOR";
  return OperationEnum2;
})(OperationEnum || {});
var OrderDirectionTypeEnum = /* @__PURE__ */ ((OrderDirectionTypeEnum2) => {
  OrderDirectionTypeEnum2["ASC"] = "ASC";
  OrderDirectionTypeEnum2["DESC"] = "DESC";
  return OrderDirectionTypeEnum2;
})(OrderDirectionTypeEnum || {});
var PartOfSpeechEnum = /* @__PURE__ */ ((PartOfSpeechEnum2) => {
  PartOfSpeechEnum2["ADJ"] = "ADJ";
  PartOfSpeechEnum2["ADP"] = "ADP";
  PartOfSpeechEnum2["ADV"] = "ADV";
  PartOfSpeechEnum2["ADVERB"] = "ADVERB";
  PartOfSpeechEnum2["AFFIX"] = "AFFIX";
  PartOfSpeechEnum2["CONJ"] = "CONJ";
  PartOfSpeechEnum2["DET"] = "DET";
  PartOfSpeechEnum2["INTERJ"] = "INTERJ";
  PartOfSpeechEnum2["NOUN"] = "NOUN";
  PartOfSpeechEnum2["NUM"] = "NUM";
  PartOfSpeechEnum2["PHRASE"] = "PHRASE";
  PartOfSpeechEnum2["PREP"] = "PREP";
  PartOfSpeechEnum2["PRON"] = "PRON";
  PartOfSpeechEnum2["PROPER"] = "PROPER";
  PartOfSpeechEnum2["PRT"] = "PRT";
  PartOfSpeechEnum2["PUNCT"] = "PUNCT";
  PartOfSpeechEnum2["UNKNOWN"] = "UNKNOWN";
  PartOfSpeechEnum2["VERB"] = "VERB";
  PartOfSpeechEnum2["X"] = "X";
  return PartOfSpeechEnum2;
})(PartOfSpeechEnum || {});
var PhonicsCommentEnum = /* @__PURE__ */ ((PhonicsCommentEnum2) => {
  PhonicsCommentEnum2["EXCELLENT"] = "EXCELLENT";
  PhonicsCommentEnum2["GOOD"] = "GOOD";
  PhonicsCommentEnum2["NOT_BAD"] = "NOT_BAD";
  PhonicsCommentEnum2["RECORD_HAS_NOISE"] = "RECORD_HAS_NOISE";
  PhonicsCommentEnum2["RECORD_HAS_ONLY_SILENCE"] = "RECORD_HAS_ONLY_SILENCE";
  PhonicsCommentEnum2["YOU_ARE_SPEAKING_IN_KOREAN"] = "YOU_ARE_SPEAKING_IN_KOREAN";
  return PhonicsCommentEnum2;
})(PhonicsCommentEnum || {});
var PlatformAdoptionStatusTypeEnum = /* @__PURE__ */ ((PlatformAdoptionStatusTypeEnum2) => {
  PlatformAdoptionStatusTypeEnum2["COMPLETED"] = "COMPLETED";
  PlatformAdoptionStatusTypeEnum2["ETC"] = "ETC";
  PlatformAdoptionStatusTypeEnum2["NEW"] = "NEW";
  PlatformAdoptionStatusTypeEnum2["ONBOARDING"] = "ONBOARDING";
  return PlatformAdoptionStatusTypeEnum2;
})(PlatformAdoptionStatusTypeEnum || {});
var PostFilterTypeEnum = /* @__PURE__ */ ((PostFilterTypeEnum2) => {
  PostFilterTypeEnum2["ALL"] = "ALL";
  PostFilterTypeEnum2["NOTICE"] = "NOTICE";
  PostFilterTypeEnum2["QNA"] = "QNA";
  return PostFilterTypeEnum2;
})(PostFilterTypeEnum || {});
var PostTypeEnum = /* @__PURE__ */ ((PostTypeEnum2) => {
  PostTypeEnum2["NOTICE"] = "NOTICE";
  PostTypeEnum2["QNA"] = "QNA";
  return PostTypeEnum2;
})(PostTypeEnum || {});
var ProductExpireStateEnum = /* @__PURE__ */ ((ProductExpireStateEnum2) => {
  ProductExpireStateEnum2["EXPIRED"] = "EXPIRED";
  ProductExpireStateEnum2["EXPIRING_SOON"] = "EXPIRING_SOON";
  ProductExpireStateEnum2["NONE"] = "NONE";
  return ProductExpireStateEnum2;
})(ProductExpireStateEnum || {});
var ProficiencyNameEnum = /* @__PURE__ */ ((ProficiencyNameEnum2) => {
  ProficiencyNameEnum2["ACOUSTIC"] = "ACOUSTIC";
  ProficiencyNameEnum2["EN_HOLISTIC"] = "EN_HOLISTIC";
  ProficiencyNameEnum2["EN_INTONATION"] = "EN_INTONATION";
  ProficiencyNameEnum2["EN_PITCH"] = "EN_PITCH";
  ProficiencyNameEnum2["EN_RATE"] = "EN_RATE";
  ProficiencyNameEnum2["EN_SEGMENT"] = "EN_SEGMENT";
  return ProficiencyNameEnum2;
})(ProficiencyNameEnum || {});
var ProgressFeedStatusEnum = /* @__PURE__ */ ((ProgressFeedStatusEnum2) => {
  ProgressFeedStatusEnum2["COMPLETED"] = "COMPLETED";
  ProgressFeedStatusEnum2["INCOMPLETE"] = "INCOMPLETE";
  ProgressFeedStatusEnum2["SCHEDULED"] = "SCHEDULED";
  return ProgressFeedStatusEnum2;
})(ProgressFeedStatusEnum || {});
var ProgressTypesEnum = /* @__PURE__ */ ((ProgressTypesEnum2) => {
  ProgressTypesEnum2["COMPLETE"] = "COMPLETE";
  ProgressTypesEnum2["DISCONNECTED"] = "DISCONNECTED";
  ProgressTypesEnum2["INCOMPLETE"] = "INCOMPLETE";
  return ProgressTypesEnum2;
})(ProgressTypesEnum || {});
var PublisherEnum = /* @__PURE__ */ ((PublisherEnum2) => {
  PublisherEnum2["DIDIMDOL"] = "DIDIMDOL";
  PublisherEnum2["JIHAK"] = "JIHAK";
  PublisherEnum2["KYOHAK"] = "KYOHAK";
  PublisherEnum2["MIRAEN"] = "MIRAEN";
  PublisherEnum2["NE"] = "NE";
  PublisherEnum2["TRAINING"] = "TRAINING";
  return PublisherEnum2;
})(PublisherEnum || {});
var QuestionStudyActivitySubTypeEnum = /* @__PURE__ */ ((QuestionStudyActivitySubTypeEnum2) => {
  QuestionStudyActivitySubTypeEnum2["CHART"] = "CHART";
  QuestionStudyActivitySubTypeEnum2["COMMON"] = "COMMON";
  QuestionStudyActivitySubTypeEnum2["FILLING_BLANK_CHOICE"] = "FILLING_BLANK_CHOICE";
  QuestionStudyActivitySubTypeEnum2["FILLING_BLANK_TYPING"] = "FILLING_BLANK_TYPING";
  QuestionStudyActivitySubTypeEnum2["FINDING_REFERRAL_TARGET"] = "FINDING_REFERRAL_TARGET";
  QuestionStudyActivitySubTypeEnum2["GRAPH"] = "GRAPH";
  QuestionStudyActivitySubTypeEnum2["SELECTING_GRAMMAR_OR_VOCABULARY"] = "SELECTING_GRAMMAR_OR_VOCABULARY";
  return QuestionStudyActivitySubTypeEnum2;
})(QuestionStudyActivitySubTypeEnum || {});
var RESTORE_STATUSEnum = /* @__PURE__ */ ((RESTORE_STATUSEnum2) => {
  RESTORE_STATUSEnum2["COMPLETED"] = "COMPLETED";
  RESTORE_STATUSEnum2["READY"] = "READY";
  RESTORE_STATUSEnum2["RESTORING"] = "RESTORING";
  return RESTORE_STATUSEnum2;
})(RESTORE_STATUSEnum || {});
var RecommendationCommentTypeEnum = /* @__PURE__ */ ((RecommendationCommentTypeEnum2) => {
  RecommendationCommentTypeEnum2["ACTIVITY_LINK"] = "ACTIVITY_LINK";
  RecommendationCommentTypeEnum2["ERROR_TEXT"] = "ERROR_TEXT";
  RecommendationCommentTypeEnum2["INFO_TEXT"] = "INFO_TEXT";
  RecommendationCommentTypeEnum2["PLAIN_TEXT"] = "PLAIN_TEXT";
  RecommendationCommentTypeEnum2["STUDENT_LINK"] = "STUDENT_LINK";
  RecommendationCommentTypeEnum2["WARNING_TEXT"] = "WARNING_TEXT";
  return RecommendationCommentTypeEnum2;
})(RecommendationCommentTypeEnum || {});
var RecommendationStrategyCategoryEnum = /* @__PURE__ */ ((RecommendationStrategyCategoryEnum2) => {
  RecommendationStrategyCategoryEnum2["AI_ASSISTANT"] = "AI_ASSISTANT";
  RecommendationStrategyCategoryEnum2["AI_TUTOR"] = "AI_TUTOR";
  return RecommendationStrategyCategoryEnum2;
})(RecommendationStrategyCategoryEnum || {});
var RecommendationStrategyManagedTagConditionEnum = /* @__PURE__ */ ((RecommendationStrategyManagedTagConditionEnum2) => {
  RecommendationStrategyManagedTagConditionEnum2["ALL"] = "ALL";
  RecommendationStrategyManagedTagConditionEnum2["CORRECT"] = "CORRECT";
  RecommendationStrategyManagedTagConditionEnum2["INCORRECT"] = "INCORRECT";
  return RecommendationStrategyManagedTagConditionEnum2;
})(RecommendationStrategyManagedTagConditionEnum || {});
var RecommendationTypeEnum = /* @__PURE__ */ ((RecommendationTypeEnum2) => {
  RecommendationTypeEnum2["ADVANCED"] = "ADVANCED";
  RecommendationTypeEnum2["ADVANCED_A"] = "ADVANCED_A";
  RecommendationTypeEnum2["ADVANCED_B"] = "ADVANCED_B";
  RecommendationTypeEnum2["ADVANCED_LEARNING"] = "ADVANCED_LEARNING";
  RecommendationTypeEnum2["ADVANCED_QUESTION"] = "ADVANCED_QUESTION";
  RecommendationTypeEnum2["BASIC"] = "BASIC";
  RecommendationTypeEnum2["BASIC_1"] = "BASIC_1";
  RecommendationTypeEnum2["BASIC_2"] = "BASIC_2";
  RecommendationTypeEnum2["BASIC_FOUNDATION_A"] = "BASIC_FOUNDATION_A";
  RecommendationTypeEnum2["BASIC_FOUNDATION_B"] = "BASIC_FOUNDATION_B";
  RecommendationTypeEnum2["BASIC_LEARNING"] = "BASIC_LEARNING";
  RecommendationTypeEnum2["BASIS"] = "BASIS";
  RecommendationTypeEnum2["CHALLENGE_QUESTION"] = "CHALLENGE_QUESTION";
  RecommendationTypeEnum2["CLINIC_BASIC"] = "CLINIC_BASIC";
  RecommendationTypeEnum2["CLINIC_ELEMENTARY"] = "CLINIC_ELEMENTARY";
  RecommendationTypeEnum2["COMMENTARY_VIDEO"] = "COMMENTARY_VIDEO";
  RecommendationTypeEnum2["COMPLEMENTARIO"] = "COMPLEMENTARIO";
  RecommendationTypeEnum2["CONCEPT"] = "CONCEPT";
  RecommendationTypeEnum2["CONCEPT_CARD"] = "CONCEPT_CARD";
  RecommendationTypeEnum2["CONCEPT_CHECK"] = "CONCEPT_CHECK";
  RecommendationTypeEnum2["CONCEPT_MEDIA"] = "CONCEPT_MEDIA";
  RecommendationTypeEnum2["CONCEPT_VIDEO"] = "CONCEPT_VIDEO";
  RecommendationTypeEnum2["CUSTOM_CONCEPT"] = "CUSTOM_CONCEPT";
  RecommendationTypeEnum2["CUSTOM_ENHANCEMENT"] = "CUSTOM_ENHANCEMENT";
  RecommendationTypeEnum2["CUSTOM_SUPPLEMENT"] = "CUSTOM_SUPPLEMENT";
  RecommendationTypeEnum2["ELEMENTARY_CONCEPT_VIDEO"] = "ELEMENTARY_CONCEPT_VIDEO";
  RecommendationTypeEnum2["ELEMENTARY_LEARNING"] = "ELEMENTARY_LEARNING";
  RecommendationTypeEnum2["ELEMENTARY_QUESTION"] = "ELEMENTARY_QUESTION";
  RecommendationTypeEnum2["GAME"] = "GAME";
  RecommendationTypeEnum2["LINKED_A"] = "LINKED_A";
  RecommendationTypeEnum2["LINKED_B"] = "LINKED_B";
  RecommendationTypeEnum2["RESEND"] = "RESEND";
  RecommendationTypeEnum2["SELF"] = "SELF";
  RecommendationTypeEnum2["SIMILARITY"] = "SIMILARITY";
  RecommendationTypeEnum2["SIMILARITY_QUESTION"] = "SIMILARITY_QUESTION";
  RecommendationTypeEnum2["SIMILARITY_QUESTION_TEACHER"] = "SIMILARITY_QUESTION_TEACHER";
  RecommendationTypeEnum2["SKILLED"] = "SKILLED";
  RecommendationTypeEnum2["SKILL_CHECK"] = "SKILL_CHECK";
  RecommendationTypeEnum2["SKILL_UP"] = "SKILL_UP";
  RecommendationTypeEnum2["SUPPLEMENT"] = "SUPPLEMENT";
  RecommendationTypeEnum2["SUPPLEMENT_LEARNING"] = "SUPPLEMENT_LEARNING";
  RecommendationTypeEnum2["SUPPLEMENT_QUESTION"] = "SUPPLEMENT_QUESTION";
  RecommendationTypeEnum2["TWIN"] = "TWIN";
  RecommendationTypeEnum2["TWINS"] = "TWINS";
  RecommendationTypeEnum2["TWIN_A"] = "TWIN_A";
  RecommendationTypeEnum2["TWIN_B"] = "TWIN_B";
  RecommendationTypeEnum2["TWIN_QUESTION"] = "TWIN_QUESTION";
  RecommendationTypeEnum2["TWIN_QUESTION_TEACHER"] = "TWIN_QUESTION_TEACHER";
  RecommendationTypeEnum2["UNKNOWN"] = "UNKNOWN";
  RecommendationTypeEnum2["WRONG_ANSWER"] = "WRONG_ANSWER";
  return RecommendationTypeEnum2;
})(RecommendationTypeEnum || {});
var ReferenceInformationCategoryEnum = /* @__PURE__ */ ((ReferenceInformationCategoryEnum2) => {
  ReferenceInformationCategoryEnum2["AI_RECOMMENDED_QUESTION"] = "AI_RECOMMENDED_QUESTION";
  ReferenceInformationCategoryEnum2["ANSWER"] = "ANSWER";
  ReferenceInformationCategoryEnum2["CORE_CONCEPT_EXPLANATION"] = "CORE_CONCEPT_EXPLANATION";
  ReferenceInformationCategoryEnum2["FEEDBACK_BY_EXAMPLE"] = "FEEDBACK_BY_EXAMPLE";
  ReferenceInformationCategoryEnum2["FREQUENTLY_ASKED_QUESTION"] = "FREQUENTLY_ASKED_QUESTION";
  ReferenceInformationCategoryEnum2["FREQUENTLY_ASKED_QUESTION_ANSWER"] = "FREQUENTLY_ASKED_QUESTION_ANSWER";
  ReferenceInformationCategoryEnum2["HOMEWORK"] = "HOMEWORK";
  ReferenceInformationCategoryEnum2["LEANING_MATERIAL"] = "LEANING_MATERIAL";
  ReferenceInformationCategoryEnum2["OTHER"] = "OTHER";
  ReferenceInformationCategoryEnum2["QUESTION"] = "QUESTION";
  ReferenceInformationCategoryEnum2["REPEATED_COMMENT"] = "REPEATED_COMMENT";
  ReferenceInformationCategoryEnum2["WRONG_ANSWER_CAUSE"] = "WRONG_ANSWER_CAUSE";
  return ReferenceInformationCategoryEnum2;
})(ReferenceInformationCategoryEnum || {});
var ReferenceInformationFieldEnum = /* @__PURE__ */ ((ReferenceInformationFieldEnum2) => {
  ReferenceInformationFieldEnum2["CITATION_COUNT"] = "CITATION_COUNT";
  ReferenceInformationFieldEnum2["CREATED_AT"] = "CREATED_AT";
  return ReferenceInformationFieldEnum2;
})(ReferenceInformationFieldEnum || {});
var ReferenceInformationFindTypeEnum = /* @__PURE__ */ ((ReferenceInformationFindTypeEnum2) => {
  ReferenceInformationFindTypeEnum2["STUDY_ACTIVITY"] = "STUDY_ACTIVITY";
  ReferenceInformationFindTypeEnum2["STUDY_ACTIVITY_INSTANCE"] = "STUDY_ACTIVITY_INSTANCE";
  ReferenceInformationFindTypeEnum2["STUDY_ACTIVITY_WORD"] = "STUDY_ACTIVITY_WORD";
  ReferenceInformationFindTypeEnum2["STUDY_MODULE"] = "STUDY_MODULE";
  ReferenceInformationFindTypeEnum2["STUDY_MODULE_INSTANCE"] = "STUDY_MODULE_INSTANCE";
  ReferenceInformationFindTypeEnum2["STUDY_UNIT"] = "STUDY_UNIT";
  ReferenceInformationFindTypeEnum2["STUDY_UNIT_INSTANCE"] = "STUDY_UNIT_INSTANCE";
  ReferenceInformationFindTypeEnum2["WORD"] = "WORD";
  return ReferenceInformationFindTypeEnum2;
})(ReferenceInformationFindTypeEnum || {});
var ReferenceInformationOrderEnum = /* @__PURE__ */ ((ReferenceInformationOrderEnum2) => {
  ReferenceInformationOrderEnum2["CITATION_COUNT_DESC"] = "CITATION_COUNT_DESC";
  ReferenceInformationOrderEnum2["CREATED_AT_ASC"] = "CREATED_AT_ASC";
  ReferenceInformationOrderEnum2["CREATED_AT_DESC"] = "CREATED_AT_DESC";
  return ReferenceInformationOrderEnum2;
})(ReferenceInformationOrderEnum || {});
var ReferenceInformationSourceEnum = /* @__PURE__ */ ((ReferenceInformationSourceEnum2) => {
  ReferenceInformationSourceEnum2["NORMAL"] = "NORMAL";
  ReferenceInformationSourceEnum2["OFFICIAL"] = "OFFICIAL";
  return ReferenceInformationSourceEnum2;
})(ReferenceInformationSourceEnum || {});
var ReferenceInformationTargetEnum = /* @__PURE__ */ ((ReferenceInformationTargetEnum2) => {
  ReferenceInformationTargetEnum2["ACTIVITY"] = "ACTIVITY";
  ReferenceInformationTargetEnum2["STUDY_ACTIVITY"] = "STUDY_ACTIVITY";
  ReferenceInformationTargetEnum2["STUDY_MODULE"] = "STUDY_MODULE";
  ReferenceInformationTargetEnum2["STUDY_UNIT"] = "STUDY_UNIT";
  ReferenceInformationTargetEnum2["WORD"] = "WORD";
  return ReferenceInformationTargetEnum2;
})(ReferenceInformationTargetEnum || {});
var ReferenceInformationTypeEnum = /* @__PURE__ */ ((ReferenceInformationTypeEnum2) => {
  ReferenceInformationTypeEnum2["AFTER_STUDY"] = "AFTER_STUDY";
  ReferenceInformationTypeEnum2["BEFORE_STUDY"] = "BEFORE_STUDY";
  return ReferenceInformationTypeEnum2;
})(ReferenceInformationTypeEnum || {});
var ReportTypeEnum = /* @__PURE__ */ ((ReportTypeEnum2) => {
  ReportTypeEnum2["LevelTestReport"] = "LevelTestReport";
  ReportTypeEnum2["WeeklyReport"] = "WeeklyReport";
  return ReportTypeEnum2;
})(ReportTypeEnum || {});
var ResourcePermissionEnum = /* @__PURE__ */ ((ResourcePermissionEnum2) => {
  ResourcePermissionEnum2["READ"] = "READ";
  return ResourcePermissionEnum2;
})(ResourcePermissionEnum || {});
var ResultViewOptionEnum = /* @__PURE__ */ ((ResultViewOptionEnum2) => {
  ResultViewOptionEnum2["ALWAYS_AVAILABLE"] = "ALWAYS_AVAILABLE";
  ResultViewOptionEnum2["CORRECT_ONLY"] = "CORRECT_ONLY";
  ResultViewOptionEnum2["NOT_AVAILABLE"] = "NOT_AVAILABLE";
  return ResultViewOptionEnum2;
})(ResultViewOptionEnum || {});
var ReviewSettingContentTypeEnum = /* @__PURE__ */ ((ReviewSettingContentTypeEnum2) => {
  ReviewSettingContentTypeEnum2["ALL"] = "ALL";
  ReviewSettingContentTypeEnum2["ONLY_INCOMPLETE"] = "ONLY_INCOMPLETE";
  ReviewSettingContentTypeEnum2["ONLY_INCORRECT"] = "ONLY_INCORRECT";
  return ReviewSettingContentTypeEnum2;
})(ReviewSettingContentTypeEnum || {});
var ScheduledMessageEventTypeEnum = /* @__PURE__ */ ((ScheduledMessageEventTypeEnum2) => {
  ScheduledMessageEventTypeEnum2["SCHEDULED_MESSAGE_CANCELLED"] = "SCHEDULED_MESSAGE_CANCELLED";
  ScheduledMessageEventTypeEnum2["SCHEDULED_MESSAGE_CREATED"] = "SCHEDULED_MESSAGE_CREATED";
  ScheduledMessageEventTypeEnum2["SCHEDULED_MESSAGE_RESCHEDULED"] = "SCHEDULED_MESSAGE_RESCHEDULED";
  ScheduledMessageEventTypeEnum2["SCHEDULED_MESSAGE_SENT"] = "SCHEDULED_MESSAGE_SENT";
  return ScheduledMessageEventTypeEnum2;
})(ScheduledMessageEventTypeEnum || {});
var ScheduledMessageStatusEnum = /* @__PURE__ */ ((ScheduledMessageStatusEnum2) => {
  ScheduledMessageStatusEnum2["CANCELLED"] = "CANCELLED";
  ScheduledMessageStatusEnum2["FAILED"] = "FAILED";
  ScheduledMessageStatusEnum2["PENDING"] = "PENDING";
  ScheduledMessageStatusEnum2["SENT"] = "SENT";
  return ScheduledMessageStatusEnum2;
})(ScheduledMessageStatusEnum || {});
var SchoolTypeEnum = /* @__PURE__ */ ((SchoolTypeEnum2) => {
  SchoolTypeEnum2["ELEMENTARY"] = "ELEMENTARY";
  SchoolTypeEnum2["HIGH"] = "HIGH";
  SchoolTypeEnum2["MIDDLE"] = "MIDDLE";
  return SchoolTypeEnum2;
})(SchoolTypeEnum || {});
var SelectionQuizOptionEnum = /* @__PURE__ */ ((SelectionQuizOptionEnum2) => {
  SelectionQuizOptionEnum2["PROOF_READING"] = "PROOF_READING";
  SelectionQuizOptionEnum2["SHUFFLE_ON"] = "SHUFFLE_ON";
  return SelectionQuizOptionEnum2;
})(SelectionQuizOptionEnum || {});
var SelfStudyAssignmentTransactionStatusEnum = /* @__PURE__ */ ((SelfStudyAssignmentTransactionStatusEnum2) => {
  SelfStudyAssignmentTransactionStatusEnum2["CANCELLED"] = "CANCELLED";
  SelfStudyAssignmentTransactionStatusEnum2["COMMITTED"] = "COMMITTED";
  SelfStudyAssignmentTransactionStatusEnum2["ERROR"] = "ERROR";
  SelfStudyAssignmentTransactionStatusEnum2["INITIALIZED"] = "INITIALIZED";
  SelfStudyAssignmentTransactionStatusEnum2["PROGRESSING"] = "PROGRESSING";
  return SelfStudyAssignmentTransactionStatusEnum2;
})(SelfStudyAssignmentTransactionStatusEnum || {});
var SelfStudyAssignmentTypeEnum = /* @__PURE__ */ ((SelfStudyAssignmentTypeEnum2) => {
  SelfStudyAssignmentTypeEnum2["INCORRECT_ANSWER_NOTE"] = "INCORRECT_ANSWER_NOTE";
  SelfStudyAssignmentTypeEnum2["SELF_STUDY"] = "SELF_STUDY";
  return SelfStudyAssignmentTypeEnum2;
})(SelfStudyAssignmentTypeEnum || {});
var SendRuleTypeEnum = /* @__PURE__ */ ((SendRuleTypeEnum2) => {
  SendRuleTypeEnum2["NEXT_WEEK"] = "NEXT_WEEK";
  SendRuleTypeEnum2["THIS_WEEK"] = "THIS_WEEK";
  return SendRuleTypeEnum2;
})(SendRuleTypeEnum || {});
var SendingStateEnum = /* @__PURE__ */ ((SendingStateEnum2) => {
  SendingStateEnum2["NOT_SENT"] = "NOT_SENT";
  SendingStateEnum2["PARTLY_SENT"] = "PARTLY_SENT";
  SendingStateEnum2["SENT"] = "SENT";
  return SendingStateEnum2;
})(SendingStateEnum || {});
var SentenceAmendReasonTypeEnum = /* @__PURE__ */ ((SentenceAmendReasonTypeEnum2) => {
  SentenceAmendReasonTypeEnum2["ERROR"] = "ERROR";
  SentenceAmendReasonTypeEnum2["ETC"] = "ETC";
  SentenceAmendReasonTypeEnum2["IMPROVE"] = "IMPROVE";
  SentenceAmendReasonTypeEnum2["MARK"] = "MARK";
  SentenceAmendReasonTypeEnum2["SENTENCE"] = "SENTENCE";
  SentenceAmendReasonTypeEnum2["SPACING"] = "SPACING";
  SentenceAmendReasonTypeEnum2["SPELLING"] = "SPELLING";
  SentenceAmendReasonTypeEnum2["WORD"] = "WORD";
  return SentenceAmendReasonTypeEnum2;
})(SentenceAmendReasonTypeEnum || {});
var SentencePublishTypeEnum = /* @__PURE__ */ ((SentencePublishTypeEnum2) => {
  SentencePublishTypeEnum2["PUBLISH"] = "PUBLISH";
  SentencePublishTypeEnum2["UNPUBLISHED"] = "UNPUBLISHED";
  return SentencePublishTypeEnum2;
})(SentencePublishTypeEnum || {});
var SentenceStudyActivityTypesEnum = /* @__PURE__ */ ((SentenceStudyActivityTypesEnum2) => {
  SentenceStudyActivityTypesEnum2["READING"] = "READING";
  SentenceStudyActivityTypesEnum2["SENTENCE_COMPLETE_BLOCKS"] = "SENTENCE_COMPLETE_BLOCKS";
  SentenceStudyActivityTypesEnum2["SENTENCE_COMPLETE_WHOLE_BLOCKS"] = "SENTENCE_COMPLETE_WHOLE_BLOCKS";
  SentenceStudyActivityTypesEnum2["SENTENCE_GRAMMAR_STUDY"] = "SENTENCE_GRAMMAR_STUDY";
  SentenceStudyActivityTypesEnum2["SENTENCE_MATCH_BLANK_BLOCKS"] = "SENTENCE_MATCH_BLANK_BLOCKS";
  SentenceStudyActivityTypesEnum2["SENTENCE_MATCH_WHOLE_BLOCKS"] = "SENTENCE_MATCH_WHOLE_BLOCKS";
  SentenceStudyActivityTypesEnum2["SENTENCE_ORDER"] = "SENTENCE_ORDER";
  return SentenceStudyActivityTypesEnum2;
})(SentenceStudyActivityTypesEnum || {});
var SentenceStudyGradeResultLabelEnum = /* @__PURE__ */ ((SentenceStudyGradeResultLabelEnum2) => {
  SentenceStudyGradeResultLabelEnum2["CORRECT_ADVERB"] = "CORRECT_ADVERB";
  SentenceStudyGradeResultLabelEnum2["CORRECT_CONJUNCTION"] = "CORRECT_CONJUNCTION";
  SentenceStudyGradeResultLabelEnum2["CORRECT_CONJUNCTIONPHRASE"] = "CORRECT_CONJUNCTIONPHRASE";
  SentenceStudyGradeResultLabelEnum2["CORRECT_IDIOM"] = "CORRECT_IDIOM";
  SentenceStudyGradeResultLabelEnum2["CORRECT_NOUNPHRASE"] = "CORRECT_NOUNPHRASE";
  SentenceStudyGradeResultLabelEnum2["CORRECT_PREPOSITION"] = "CORRECT_PREPOSITION";
  SentenceStudyGradeResultLabelEnum2["CORRECT_THAT"] = "CORRECT_THAT";
  SentenceStudyGradeResultLabelEnum2["PRIORITY_CLAUSE"] = "PRIORITY_CLAUSE";
  SentenceStudyGradeResultLabelEnum2["PRIORITY_COMMA"] = "PRIORITY_COMMA";
  SentenceStudyGradeResultLabelEnum2["UNKNOWN"] = "UNKNOWN";
  SentenceStudyGradeResultLabelEnum2["WRONG_APOSTROPHE"] = "WRONG_APOSTROPHE";
  SentenceStudyGradeResultLabelEnum2["WRONG_DETERMINER"] = "WRONG_DETERMINER";
  SentenceStudyGradeResultLabelEnum2["WRONG_INVERSION"] = "WRONG_INVERSION";
  SentenceStudyGradeResultLabelEnum2["WRONG_MODIFIER"] = "WRONG_MODIFIER";
  SentenceStudyGradeResultLabelEnum2["WRONG_NEGATIVE"] = "WRONG_NEGATIVE";
  SentenceStudyGradeResultLabelEnum2["WRONG_PHRASAL_VERB"] = "WRONG_PHRASAL_VERB";
  SentenceStudyGradeResultLabelEnum2["WRONG_PREPOSITION"] = "WRONG_PREPOSITION";
  SentenceStudyGradeResultLabelEnum2["WRONG_PRE_NOUN"] = "WRONG_PRE_NOUN";
  SentenceStudyGradeResultLabelEnum2["WRONG_PST_INVERSION"] = "WRONG_PST_INVERSION";
  SentenceStudyGradeResultLabelEnum2["WRONG_VERB"] = "WRONG_VERB";
  SentenceStudyGradeResultLabelEnum2["WRONG_WH"] = "WRONG_WH";
  return SentenceStudyGradeResultLabelEnum2;
})(SentenceStudyGradeResultLabelEnum || {});
var SentenceStudyHintCategoryEnum = /* @__PURE__ */ ((SentenceStudyHintCategoryEnum2) => {
  SentenceStudyHintCategoryEnum2["CHUNKING"] = "CHUNKING";
  SentenceStudyHintCategoryEnum2["CONNECTION"] = "CONNECTION";
  SentenceStudyHintCategoryEnum2["FABRICATION"] = "FABRICATION";
  SentenceStudyHintCategoryEnum2["SYNTAX"] = "SYNTAX";
  SentenceStudyHintCategoryEnum2["VOCAB"] = "VOCAB";
  return SentenceStudyHintCategoryEnum2;
})(SentenceStudyHintCategoryEnum || {});
var SentenceStudyHintFalseReasonEnum = /* @__PURE__ */ ((SentenceStudyHintFalseReasonEnum2) => {
  SentenceStudyHintFalseReasonEnum2["NO_CHANGE"] = "NO_CHANGE";
  SentenceStudyHintFalseReasonEnum2["TRIVIAL_CHANGE"] = "TRIVIAL_CHANGE";
  return SentenceStudyHintFalseReasonEnum2;
})(SentenceStudyHintFalseReasonEnum || {});
var SentenceStudyHistoryStatusEnum = /* @__PURE__ */ ((SentenceStudyHistoryStatusEnum2) => {
  SentenceStudyHistoryStatusEnum2["CORRECT"] = "CORRECT";
  SentenceStudyHistoryStatusEnum2["NOT_GRADED"] = "NOT_GRADED";
  SentenceStudyHistoryStatusEnum2["PARTIALLY_CORRECT"] = "PARTIALLY_CORRECT";
  SentenceStudyHistoryStatusEnum2["WRONG"] = "WRONG";
  return SentenceStudyHistoryStatusEnum2;
})(SentenceStudyHistoryStatusEnum || {});
var SentenceStudyTranslationGradingErrorTypeEnum = /* @__PURE__ */ ((SentenceStudyTranslationGradingErrorTypeEnum2) => {
  SentenceStudyTranslationGradingErrorTypeEnum2["CHUNKING"] = "CHUNKING";
  SentenceStudyTranslationGradingErrorTypeEnum2["FABRICATION"] = "FABRICATION";
  SentenceStudyTranslationGradingErrorTypeEnum2["SYNTAX"] = "SYNTAX";
  SentenceStudyTranslationGradingErrorTypeEnum2["VOCAB"] = "VOCAB";
  return SentenceStudyTranslationGradingErrorTypeEnum2;
})(SentenceStudyTranslationGradingErrorTypeEnum || {});
var SentenceStudyTranslationGradingFeedbackReasonEnum = /* @__PURE__ */ ((SentenceStudyTranslationGradingFeedbackReasonEnum2) => {
  SentenceStudyTranslationGradingFeedbackReasonEnum2["CORRECT_MISGRADED"] = "CORRECT_MISGRADED";
  SentenceStudyTranslationGradingFeedbackReasonEnum2["ETC"] = "ETC";
  SentenceStudyTranslationGradingFeedbackReasonEnum2["SEVERITY_MISCLASSIFIED"] = "SEVERITY_MISCLASSIFIED";
  SentenceStudyTranslationGradingFeedbackReasonEnum2["WRONG_FEEDBACK"] = "WRONG_FEEDBACK";
  return SentenceStudyTranslationGradingFeedbackReasonEnum2;
})(SentenceStudyTranslationGradingFeedbackReasonEnum || {});
var SentenceStudyTranslationGradingSeverityEnum = /* @__PURE__ */ ((SentenceStudyTranslationGradingSeverityEnum2) => {
  SentenceStudyTranslationGradingSeverityEnum2["CRITICAL"] = "CRITICAL";
  SentenceStudyTranslationGradingSeverityEnum2["MINOR"] = "MINOR";
  SentenceStudyTranslationGradingSeverityEnum2["MODERATE"] = "MODERATE";
  return SentenceStudyTranslationGradingSeverityEnum2;
})(SentenceStudyTranslationGradingSeverityEnum || {});
var SentenceStudyTranslationGradingStatusEnum = /* @__PURE__ */ ((SentenceStudyTranslationGradingStatusEnum2) => {
  SentenceStudyTranslationGradingStatusEnum2["COMPLETED"] = "COMPLETED";
  SentenceStudyTranslationGradingStatusEnum2["FAILED"] = "FAILED";
  SentenceStudyTranslationGradingStatusEnum2["GRADING"] = "GRADING";
  return SentenceStudyTranslationGradingStatusEnum2;
})(SentenceStudyTranslationGradingStatusEnum || {});
var SentenceStudyTranslationGradingVerdictEnum = /* @__PURE__ */ ((SentenceStudyTranslationGradingVerdictEnum2) => {
  SentenceStudyTranslationGradingVerdictEnum2["BLANK"] = "BLANK";
  SentenceStudyTranslationGradingVerdictEnum2["CORRECT"] = "CORRECT";
  SentenceStudyTranslationGradingVerdictEnum2["INSUFFICIENT"] = "INSUFFICIENT";
  SentenceStudyTranslationGradingVerdictEnum2["WRONG"] = "WRONG";
  return SentenceStudyTranslationGradingVerdictEnum2;
})(SentenceStudyTranslationGradingVerdictEnum || {});
var SessionClassificationPhaseEnum = /* @__PURE__ */ ((SessionClassificationPhaseEnum2) => {
  SessionClassificationPhaseEnum2["CLASSIFYING"] = "CLASSIFYING";
  SessionClassificationPhaseEnum2["NONE"] = "NONE";
  SessionClassificationPhaseEnum2["SETTLED"] = "SETTLED";
  return SessionClassificationPhaseEnum2;
})(SessionClassificationPhaseEnum || {});
var SessionInstanceStatusEnum = /* @__PURE__ */ ((SessionInstanceStatusEnum2) => {
  SessionInstanceStatusEnum2["ACTIVE"] = "ACTIVE";
  SessionInstanceStatusEnum2["CLOSE"] = "CLOSE";
  return SessionInstanceStatusEnum2;
})(SessionInstanceStatusEnum || {});
var SessionSendModeEnum = /* @__PURE__ */ ((SessionSendModeEnum2) => {
  SessionSendModeEnum2["AUTO"] = "AUTO";
  SessionSendModeEnum2["DISABLED"] = "DISABLED";
  SessionSendModeEnum2["MANUAL"] = "MANUAL";
  SessionSendModeEnum2["UNAVAILABLE"] = "UNAVAILABLE";
  return SessionSendModeEnum2;
})(SessionSendModeEnum || {});
var ShortAnswerBlockEstimationAnswerResultTypeEnum = /* @__PURE__ */ ((ShortAnswerBlockEstimationAnswerResultTypeEnum2) => {
  ShortAnswerBlockEstimationAnswerResultTypeEnum2["FORMULA_EDITOR"] = "FORMULA_EDITOR";
  ShortAnswerBlockEstimationAnswerResultTypeEnum2["TEXT"] = "TEXT";
  return ShortAnswerBlockEstimationAnswerResultTypeEnum2;
})(ShortAnswerBlockEstimationAnswerResultTypeEnum || {});
var ShortAnswerWordHintEnum = /* @__PURE__ */ ((ShortAnswerWordHintEnum2) => {
  ShortAnswerWordHintEnum2["SHOW_WORD_COUNT"] = "SHOW_WORD_COUNT";
  ShortAnswerWordHintEnum2["SHOW_WRONG_WORD"] = "SHOW_WRONG_WORD";
  return ShortAnswerWordHintEnum2;
})(ShortAnswerWordHintEnum || {});
var SpeakingBlockCategoryEnum = /* @__PURE__ */ ((SpeakingBlockCategoryEnum2) => {
  SpeakingBlockCategoryEnum2["PHONICS_SENTENCE"] = "PHONICS_SENTENCE";
  SpeakingBlockCategoryEnum2["PHONICS_WORD"] = "PHONICS_WORD";
  SpeakingBlockCategoryEnum2["PRONUNCIATION"] = "PRONUNCIATION";
  SpeakingBlockCategoryEnum2["STT_ONLY"] = "STT_ONLY";
  return SpeakingBlockCategoryEnum2;
})(SpeakingBlockCategoryEnum || {});
var SpeakingOverallCommentEnum = /* @__PURE__ */ ((SpeakingOverallCommentEnum2) => {
  SpeakingOverallCommentEnum2["EXCELLENT"] = "EXCELLENT";
  SpeakingOverallCommentEnum2["GOOD"] = "GOOD";
  SpeakingOverallCommentEnum2["NICE_TRY"] = "NICE_TRY";
  return SpeakingOverallCommentEnum2;
})(SpeakingOverallCommentEnum || {});
var StatsActivityTypeEnum = /* @__PURE__ */ ((StatsActivityTypeEnum2) => {
  StatsActivityTypeEnum2["MATH_QUESTION"] = "MATH_QUESTION";
  StatsActivityTypeEnum2["QUESTION"] = "QUESTION";
  return StatsActivityTypeEnum2;
})(StatsActivityTypeEnum || {});
var StatsCategoryEnum = /* @__PURE__ */ ((StatsCategoryEnum2) => {
  StatsCategoryEnum2["ANSWER_RATE"] = "ANSWER_RATE";
  StatsCategoryEnum2["MEAN_STUDY_TIME"] = "MEAN_STUDY_TIME";
  StatsCategoryEnum2["TEST_TAKER_COUNT"] = "TEST_TAKER_COUNT";
  return StatsCategoryEnum2;
})(StatsCategoryEnum || {});
var StatsGradeEnum = /* @__PURE__ */ ((StatsGradeEnum2) => {
  StatsGradeEnum2["ADULT"] = "ADULT";
  StatsGradeEnum2["ELEMENT_1"] = "ELEMENT_1";
  StatsGradeEnum2["ELEMENT_2"] = "ELEMENT_2";
  StatsGradeEnum2["ELEMENT_3"] = "ELEMENT_3";
  StatsGradeEnum2["ELEMENT_4"] = "ELEMENT_4";
  StatsGradeEnum2["ELEMENT_5"] = "ELEMENT_5";
  StatsGradeEnum2["ELEMENT_6"] = "ELEMENT_6";
  StatsGradeEnum2["HIGH_1"] = "HIGH_1";
  StatsGradeEnum2["HIGH_2"] = "HIGH_2";
  StatsGradeEnum2["HIGH_3"] = "HIGH_3";
  StatsGradeEnum2["MIDDLE_1"] = "MIDDLE_1";
  StatsGradeEnum2["MIDDLE_2"] = "MIDDLE_2";
  StatsGradeEnum2["MIDDLE_3"] = "MIDDLE_3";
  StatsGradeEnum2["TOTAL"] = "TOTAL";
  return StatsGradeEnum2;
})(StatsGradeEnum || {});
var StatsViewTypeEnum = /* @__PURE__ */ ((StatsViewTypeEnum2) => {
  StatsViewTypeEnum2["META_CHAPTER"] = "META_CHAPTER";
  StatsViewTypeEnum2["META_CONTENT_MODULE"] = "META_CONTENT_MODULE";
  StatsViewTypeEnum2["STUDY_ACTIVITY"] = "STUDY_ACTIVITY";
  return StatsViewTypeEnum2;
})(StatsViewTypeEnum || {});
var SttAlignmentByWordErrorTypeEnum = /* @__PURE__ */ ((SttAlignmentByWordErrorTypeEnum2) => {
  SttAlignmentByWordErrorTypeEnum2["CORRECT"] = "CORRECT";
  SttAlignmentByWordErrorTypeEnum2["DELETION"] = "DELETION";
  SttAlignmentByWordErrorTypeEnum2["INSERTION"] = "INSERTION";
  SttAlignmentByWordErrorTypeEnum2["SUBSTITUTION"] = "SUBSTITUTION";
  return SttAlignmentByWordErrorTypeEnum2;
})(SttAlignmentByWordErrorTypeEnum || {});
var SttStatusEnum = /* @__PURE__ */ ((SttStatusEnum2) => {
  SttStatusEnum2["COMPLETED"] = "COMPLETED";
  SttStatusEnum2["FAIL"] = "FAIL";
  SttStatusEnum2["PENDING"] = "PENDING";
  return SttStatusEnum2;
})(SttStatusEnum || {});
var StudentAuthorityExpireStateEnum = /* @__PURE__ */ ((StudentAuthorityExpireStateEnum2) => {
  StudentAuthorityExpireStateEnum2["EXPIRED"] = "EXPIRED";
  StudentAuthorityExpireStateEnum2["EXPIRING_SOON"] = "EXPIRING_SOON";
  StudentAuthorityExpireStateEnum2["NONE"] = "NONE";
  return StudentAuthorityExpireStateEnum2;
})(StudentAuthorityExpireStateEnum || {});
var StudentCustomIntegratedActivityLearningStatusTypeEnum = /* @__PURE__ */ ((StudentCustomIntegratedActivityLearningStatusTypeEnum2) => {
  StudentCustomIntegratedActivityLearningStatusTypeEnum2["COMPLETE"] = "COMPLETE";
  StudentCustomIntegratedActivityLearningStatusTypeEnum2["CORRECT"] = "CORRECT";
  StudentCustomIntegratedActivityLearningStatusTypeEnum2["INCOMPLETE"] = "INCOMPLETE";
  StudentCustomIntegratedActivityLearningStatusTypeEnum2["INCORRECT"] = "INCORRECT";
  return StudentCustomIntegratedActivityLearningStatusTypeEnum2;
})(StudentCustomIntegratedActivityLearningStatusTypeEnum || {});
var StudentCustomStudyStatsOrderFieldEnum = /* @__PURE__ */ ((StudentCustomStudyStatsOrderFieldEnum2) => {
  StudentCustomStudyStatsOrderFieldEnum2["CORRECT_RATE"] = "CORRECT_RATE";
  StudentCustomStudyStatsOrderFieldEnum2["CREATED_AT_BY_CDC_AND_CSM"] = "CREATED_AT_BY_CDC_AND_CSM";
  StudentCustomStudyStatsOrderFieldEnum2["PROGRESS_RATE"] = "PROGRESS_RATE";
  StudentCustomStudyStatsOrderFieldEnum2["TITLE"] = "TITLE";
  return StudentCustomStudyStatsOrderFieldEnum2;
})(StudentCustomStudyStatsOrderFieldEnum || {});
var StudentCustomStudyUnitCommentTypeEnum = /* @__PURE__ */ ((StudentCustomStudyUnitCommentTypeEnum2) => {
  StudentCustomStudyUnitCommentTypeEnum2["CORRECT_RATE"] = "CORRECT_RATE";
  StudentCustomStudyUnitCommentTypeEnum2["KNOWLEDGE_TAG"] = "KNOWLEDGE_TAG";
  StudentCustomStudyUnitCommentTypeEnum2["RECOMMEND_MANAGED_TAG"] = "RECOMMEND_MANAGED_TAG";
  StudentCustomStudyUnitCommentTypeEnum2["SUMMARY"] = "SUMMARY";
  return StudentCustomStudyUnitCommentTypeEnum2;
})(StudentCustomStudyUnitCommentTypeEnum || {});
var StudentLearningProgressStatusEnum = /* @__PURE__ */ ((StudentLearningProgressStatusEnum2) => {
  StudentLearningProgressStatusEnum2["COMPLETED"] = "COMPLETED";
  StudentLearningProgressStatusEnum2["PROGRESSING"] = "PROGRESSING";
  StudentLearningProgressStatusEnum2["STARTED"] = "STARTED";
  return StudentLearningProgressStatusEnum2;
})(StudentLearningProgressStatusEnum || {});
var StudyActivityDifficultyTypesEnum = /* @__PURE__ */ ((StudyActivityDifficultyTypesEnum2) => {
  StudyActivityDifficultyTypesEnum2["ADVANCED"] = "ADVANCED";
  StudyActivityDifficultyTypesEnum2["BASIC"] = "BASIC";
  StudyActivityDifficultyTypesEnum2["NORMAL"] = "NORMAL";
  return StudyActivityDifficultyTypesEnum2;
})(StudyActivityDifficultyTypesEnum || {});
var StudyActivityEvaluatableTypesEnum = /* @__PURE__ */ ((StudyActivityEvaluatableTypesEnum2) => {
  StudyActivityEvaluatableTypesEnum2["MATH_QUESTION"] = "MATH_QUESTION";
  StudyActivityEvaluatableTypesEnum2["QUESTION"] = "QUESTION";
  StudyActivityEvaluatableTypesEnum2["WORD_TEST"] = "WORD_TEST";
  return StudyActivityEvaluatableTypesEnum2;
})(StudyActivityEvaluatableTypesEnum || {});
var StudyActivityHistoryLearningStateEnum = /* @__PURE__ */ ((StudyActivityHistoryLearningStateEnum2) => {
  StudyActivityHistoryLearningStateEnum2["CORRECT"] = "CORRECT";
  StudyActivityHistoryLearningStateEnum2["FINISHED"] = "FINISHED";
  StudyActivityHistoryLearningStateEnum2["INCORRECT"] = "INCORRECT";
  StudyActivityHistoryLearningStateEnum2["UNLEARNED"] = "UNLEARNED";
  return StudyActivityHistoryLearningStateEnum2;
})(StudyActivityHistoryLearningStateEnum || {});
var StudyActivityInstanceLearningStateTypeEnum = /* @__PURE__ */ ((StudyActivityInstanceLearningStateTypeEnum2) => {
  StudyActivityInstanceLearningStateTypeEnum2["FINISHED"] = "FINISHED";
  StudyActivityInstanceLearningStateTypeEnum2["PARTLY_LEARNED"] = "PARTLY_LEARNED";
  StudyActivityInstanceLearningStateTypeEnum2["UNLEARNED"] = "UNLEARNED";
  return StudyActivityInstanceLearningStateTypeEnum2;
})(StudyActivityInstanceLearningStateTypeEnum || {});
var StudyActivityOrderFieldTypeEnum = /* @__PURE__ */ ((StudyActivityOrderFieldTypeEnum2) => {
  StudyActivityOrderFieldTypeEnum2["CREATED_AT"] = "CREATED_AT";
  StudyActivityOrderFieldTypeEnum2["ORDER_ID"] = "ORDER_ID";
  StudyActivityOrderFieldTypeEnum2["TITLE"] = "TITLE";
  return StudyActivityOrderFieldTypeEnum2;
})(StudyActivityOrderFieldTypeEnum || {});
var StudyActivityQuestionSubTypeFilterEnum = /* @__PURE__ */ ((StudyActivityQuestionSubTypeFilterEnum2) => {
  StudyActivityQuestionSubTypeFilterEnum2["ALL_EXCEPT_COMMON"] = "ALL_EXCEPT_COMMON";
  StudyActivityQuestionSubTypeFilterEnum2["CHART"] = "CHART";
  StudyActivityQuestionSubTypeFilterEnum2["COMMON"] = "COMMON";
  StudyActivityQuestionSubTypeFilterEnum2["FILLING_BLANK_CHOICE_ALL"] = "FILLING_BLANK_CHOICE_ALL";
  StudyActivityQuestionSubTypeFilterEnum2["FILLING_BLANK_CHOICE_BASIC"] = "FILLING_BLANK_CHOICE_BASIC";
  StudyActivityQuestionSubTypeFilterEnum2["FILLING_BLANK_CHOICE_WITHOUT_TRANSLATION"] = "FILLING_BLANK_CHOICE_WITHOUT_TRANSLATION";
  StudyActivityQuestionSubTypeFilterEnum2["FILLING_BLANK_TYPING_ALL"] = "FILLING_BLANK_TYPING_ALL";
  StudyActivityQuestionSubTypeFilterEnum2["FILLING_BLANK_TYPING_BASIC"] = "FILLING_BLANK_TYPING_BASIC";
  StudyActivityQuestionSubTypeFilterEnum2["FILLING_BLANK_TYPING_SHOW_WORD_COUNT"] = "FILLING_BLANK_TYPING_SHOW_WORD_COUNT";
  StudyActivityQuestionSubTypeFilterEnum2["FILLING_BLANK_TYPING_SHOW_WRONG_WORD"] = "FILLING_BLANK_TYPING_SHOW_WRONG_WORD";
  StudyActivityQuestionSubTypeFilterEnum2["FILLING_BLANK_TYPING_WITHOUT_TRANSLATION"] = "FILLING_BLANK_TYPING_WITHOUT_TRANSLATION";
  StudyActivityQuestionSubTypeFilterEnum2["FINDING_REFERRAL_TARGET_ALL"] = "FINDING_REFERRAL_TARGET_ALL";
  StudyActivityQuestionSubTypeFilterEnum2["FINDING_REFERRAL_TARGET_BASIC"] = "FINDING_REFERRAL_TARGET_BASIC";
  StudyActivityQuestionSubTypeFilterEnum2["FINDING_REFERRAL_TARGET_WITHOUT_TRANSLATION"] = "FINDING_REFERRAL_TARGET_WITHOUT_TRANSLATION";
  StudyActivityQuestionSubTypeFilterEnum2["GRAPH"] = "GRAPH";
  StudyActivityQuestionSubTypeFilterEnum2["SELECTING_GRAMMAR_OR_VOCABULARY_ALL"] = "SELECTING_GRAMMAR_OR_VOCABULARY_ALL";
  StudyActivityQuestionSubTypeFilterEnum2["SELECTING_GRAMMAR_OR_VOCABULARY_BASIC"] = "SELECTING_GRAMMAR_OR_VOCABULARY_BASIC";
  StudyActivityQuestionSubTypeFilterEnum2["SELECTING_GRAMMAR_OR_VOCABULARY_WITHOUT_SELECT"] = "SELECTING_GRAMMAR_OR_VOCABULARY_WITHOUT_SELECT";
  StudyActivityQuestionSubTypeFilterEnum2["SELECTING_GRAMMAR_OR_VOCABULARY_WITHOUT_TRANSLATION"] = "SELECTING_GRAMMAR_OR_VOCABULARY_WITHOUT_TRANSLATION";
  return StudyActivityQuestionSubTypeFilterEnum2;
})(StudyActivityQuestionSubTypeFilterEnum || {});
var StudyActivitySubTypeOptionEnum = /* @__PURE__ */ ((StudyActivitySubTypeOptionEnum2) => {
  StudyActivitySubTypeOptionEnum2["ALL_CHECK"] = "ALL_CHECK";
  StudyActivitySubTypeOptionEnum2["BASIC"] = "BASIC";
  StudyActivitySubTypeOptionEnum2["PARTIAL_CHECK"] = "PARTIAL_CHECK";
  StudyActivitySubTypeOptionEnum2["SHOW_WORD_COUNT"] = "SHOW_WORD_COUNT";
  StudyActivitySubTypeOptionEnum2["SHOW_WRONG_WORD"] = "SHOW_WRONG_WORD";
  StudyActivitySubTypeOptionEnum2["WITHOUT_SELECT"] = "WITHOUT_SELECT";
  StudyActivitySubTypeOptionEnum2["WITHOUT_TRANSLATION"] = "WITHOUT_TRANSLATION";
  return StudyActivitySubTypeOptionEnum2;
})(StudyActivitySubTypeOptionEnum || {});
var StudyActivityTypesEnum = /* @__PURE__ */ ((StudyActivityTypesEnum2) => {
  StudyActivityTypesEnum2["ARTICLE"] = "ARTICLE";
  StudyActivityTypesEnum2["ENGLISH_SPEAKING"] = "ENGLISH_SPEAKING";
  StudyActivityTypesEnum2["MATH_QUESTION"] = "MATH_QUESTION";
  StudyActivityTypesEnum2["MEGASTUDY_VIDEO"] = "MEGASTUDY_VIDEO";
  StudyActivityTypesEnum2["QUESTION"] = "QUESTION";
  StudyActivityTypesEnum2["READING"] = "READING";
  StudyActivityTypesEnum2["SENTENCE_COMPLETE_BLOCKS"] = "SENTENCE_COMPLETE_BLOCKS";
  StudyActivityTypesEnum2["SENTENCE_COMPLETE_WHOLE_BLOCKS"] = "SENTENCE_COMPLETE_WHOLE_BLOCKS";
  StudyActivityTypesEnum2["SENTENCE_GRAMMAR_STUDY"] = "SENTENCE_GRAMMAR_STUDY";
  StudyActivityTypesEnum2["SENTENCE_MATCH_BLANK_BLOCKS"] = "SENTENCE_MATCH_BLANK_BLOCKS";
  StudyActivityTypesEnum2["SENTENCE_MATCH_WHOLE_BLOCKS"] = "SENTENCE_MATCH_WHOLE_BLOCKS";
  StudyActivityTypesEnum2["SENTENCE_ORDER"] = "SENTENCE_ORDER";
  StudyActivityTypesEnum2["TODO_LIST"] = "TODO_LIST";
  StudyActivityTypesEnum2["VIDEO"] = "VIDEO";
  StudyActivityTypesEnum2["WORD_MEMORY"] = "WORD_MEMORY";
  StudyActivityTypesEnum2["WORD_TEST"] = "WORD_TEST";
  return StudyActivityTypesEnum2;
})(StudyActivityTypesEnum || {});
var StudyActivityViewerTypeEnum = /* @__PURE__ */ ((StudyActivityViewerTypeEnum2) => {
  StudyActivityViewerTypeEnum2["MANAGER"] = "MANAGER";
  StudyActivityViewerTypeEnum2["STUDENT"] = "STUDENT";
  return StudyActivityViewerTypeEnum2;
})(StudyActivityViewerTypeEnum || {});
var StudyModuleGenerateTemplateTypeEnum = /* @__PURE__ */ ((StudyModuleGenerateTemplateTypeEnum2) => {
  StudyModuleGenerateTemplateTypeEnum2["MULTIPLE_STUDY_MODULES"] = "MULTIPLE_STUDY_MODULES";
  StudyModuleGenerateTemplateTypeEnum2["SINGLE_STUDY_MODULE"] = "SINGLE_STUDY_MODULE";
  return StudyModuleGenerateTemplateTypeEnum2;
})(StudyModuleGenerateTemplateTypeEnum || {});
var StudyModuleOrderFieldTypeEnum = /* @__PURE__ */ ((StudyModuleOrderFieldTypeEnum2) => {
  StudyModuleOrderFieldTypeEnum2["CREATED_AT"] = "CREATED_AT";
  StudyModuleOrderFieldTypeEnum2["TITLE"] = "TITLE";
  return StudyModuleOrderFieldTypeEnum2;
})(StudyModuleOrderFieldTypeEnum || {});
var StudyModuleReferenceInformationCategoryEnum = /* @__PURE__ */ ((StudyModuleReferenceInformationCategoryEnum2) => {
  StudyModuleReferenceInformationCategoryEnum2["ANSWER"] = "ANSWER";
  StudyModuleReferenceInformationCategoryEnum2["CORE_CONCEPT_EXPLANATION"] = "CORE_CONCEPT_EXPLANATION";
  StudyModuleReferenceInformationCategoryEnum2["FREQUENTLY_ASKED_QUESTION"] = "FREQUENTLY_ASKED_QUESTION";
  StudyModuleReferenceInformationCategoryEnum2["FREQUENTLY_ASKED_QUESTION_ANSWER"] = "FREQUENTLY_ASKED_QUESTION_ANSWER";
  StudyModuleReferenceInformationCategoryEnum2["HOMEWORK"] = "HOMEWORK";
  StudyModuleReferenceInformationCategoryEnum2["LEANING_MATERIAL"] = "LEANING_MATERIAL";
  StudyModuleReferenceInformationCategoryEnum2["OTHER"] = "OTHER";
  StudyModuleReferenceInformationCategoryEnum2["QUESTION"] = "QUESTION";
  StudyModuleReferenceInformationCategoryEnum2["REPEATED_COMMENT"] = "REPEATED_COMMENT";
  return StudyModuleReferenceInformationCategoryEnum2;
})(StudyModuleReferenceInformationCategoryEnum || {});
var StudyOptionEnum = /* @__PURE__ */ ((StudyOptionEnum2) => {
  StudyOptionEnum2["COMMON_ACTIVITY"] = "COMMON_ACTIVITY";
  StudyOptionEnum2["MODUM_ACTIVITY"] = "MODUM_ACTIVITY";
  return StudyOptionEnum2;
})(StudyOptionEnum || {});
var StudyUnitCategoryEnum = /* @__PURE__ */ ((StudyUnitCategoryEnum2) => {
  StudyUnitCategoryEnum2["BLOCK"] = "BLOCK";
  StudyUnitCategoryEnum2["ETC"] = "ETC";
  StudyUnitCategoryEnum2["PROBLEM_SOLVING"] = "PROBLEM_SOLVING";
  StudyUnitCategoryEnum2["WITH_VIDEO_LECTURE"] = "WITH_VIDEO_LECTURE";
  StudyUnitCategoryEnum2["WORD_BOOK"] = "WORD_BOOK";
  StudyUnitCategoryEnum2["WORD_TEST"] = "WORD_TEST";
  return StudyUnitCategoryEnum2;
})(StudyUnitCategoryEnum || {});
var StudyUnitGradingUnitEnum = /* @__PURE__ */ ((StudyUnitGradingUnitEnum2) => {
  StudyUnitGradingUnitEnum2["BLOCK_ACTIVITY"] = "BLOCK_ACTIVITY";
  StudyUnitGradingUnitEnum2["BLOCK_STUDY_UNIT"] = "BLOCK_STUDY_UNIT";
  StudyUnitGradingUnitEnum2["NO_GRADING"] = "NO_GRADING";
  StudyUnitGradingUnitEnum2["STUDY_ACTIVITY"] = "STUDY_ACTIVITY";
  StudyUnitGradingUnitEnum2["STUDY_UNIT"] = "STUDY_UNIT";
  return StudyUnitGradingUnitEnum2;
})(StudyUnitGradingUnitEnum || {});
var StudyUnitInstanceTypeEnum = /* @__PURE__ */ ((StudyUnitInstanceTypeEnum2) => {
  StudyUnitInstanceTypeEnum2["LESSON"] = "LESSON";
  StudyUnitInstanceTypeEnum2["TEST"] = "TEST";
  return StudyUnitInstanceTypeEnum2;
})(StudyUnitInstanceTypeEnum || {});
var StudyUnitReferenceInformationCategoryEnum = /* @__PURE__ */ ((StudyUnitReferenceInformationCategoryEnum2) => {
  StudyUnitReferenceInformationCategoryEnum2["ANSWER"] = "ANSWER";
  StudyUnitReferenceInformationCategoryEnum2["CORE_CONCEPT_EXPLANATION"] = "CORE_CONCEPT_EXPLANATION";
  StudyUnitReferenceInformationCategoryEnum2["FREQUENTLY_ASKED_QUESTION"] = "FREQUENTLY_ASKED_QUESTION";
  StudyUnitReferenceInformationCategoryEnum2["FREQUENTLY_ASKED_QUESTION_ANSWER"] = "FREQUENTLY_ASKED_QUESTION_ANSWER";
  StudyUnitReferenceInformationCategoryEnum2["HOMEWORK"] = "HOMEWORK";
  StudyUnitReferenceInformationCategoryEnum2["LEANING_MATERIAL"] = "LEANING_MATERIAL";
  StudyUnitReferenceInformationCategoryEnum2["OTHER"] = "OTHER";
  StudyUnitReferenceInformationCategoryEnum2["QUESTION"] = "QUESTION";
  StudyUnitReferenceInformationCategoryEnum2["REPEATED_COMMENT"] = "REPEATED_COMMENT";
  return StudyUnitReferenceInformationCategoryEnum2;
})(StudyUnitReferenceInformationCategoryEnum || {});
var StudyUnitTypeEnum = /* @__PURE__ */ ((StudyUnitTypeEnum2) => {
  StudyUnitTypeEnum2["BLOCK"] = "BLOCK";
  StudyUnitTypeEnum2["ESTIMATIVE"] = "ESTIMATIVE";
  StudyUnitTypeEnum2["LEARNING_NORMAL"] = "LEARNING_NORMAL";
  StudyUnitTypeEnum2["LEARNING_VIDEO_FIXED"] = "LEARNING_VIDEO_FIXED";
  StudyUnitTypeEnum2["WORD_MEMORIZATION"] = "WORD_MEMORIZATION";
  StudyUnitTypeEnum2["WORD_TEST"] = "WORD_TEST";
  return StudyUnitTypeEnum2;
})(StudyUnitTypeEnum || {});
var StudyUnitViewTypeEnum = /* @__PURE__ */ ((StudyUnitViewTypeEnum2) => {
  StudyUnitViewTypeEnum2["PAGINATED"] = "PAGINATED";
  StudyUnitViewTypeEnum2["SINGLE_PAGE_VERTICAL"] = "SINGLE_PAGE_VERTICAL";
  return StudyUnitViewTypeEnum2;
})(StudyUnitViewTypeEnum || {});
var SubjectEnum = /* @__PURE__ */ ((SubjectEnum2) => {
  SubjectEnum2["ENGLISH"] = "ENGLISH";
  SubjectEnum2["KOREAN"] = "KOREAN";
  SubjectEnum2["MATH"] = "MATH";
  return SubjectEnum2;
})(SubjectEnum || {});
var SubmissionPolicyEnum = /* @__PURE__ */ ((SubmissionPolicyEnum2) => {
  SubmissionPolicyEnum2["GRADING"] = "GRADING";
  SubmissionPolicyEnum2["HAND_OUT"] = "HAND_OUT";
  SubmissionPolicyEnum2["WITHOUT_GRADING"] = "WITHOUT_GRADING";
  return SubmissionPolicyEnum2;
})(SubmissionPolicyEnum || {});
var SyncStudyViewTypeEnum = /* @__PURE__ */ ((SyncStudyViewTypeEnum2) => {
  SyncStudyViewTypeEnum2["LA"] = "LA";
  SyncStudyViewTypeEnum2["SAI"] = "SAI";
  SyncStudyViewTypeEnum2["SUI_SUMMARY"] = "SUI_SUMMARY";
  return SyncStudyViewTypeEnum2;
})(SyncStudyViewTypeEnum || {});
var SyntaxTypeEnum = /* @__PURE__ */ ((SyntaxTypeEnum2) => {
  SyntaxTypeEnum2["COMPLEMENT"] = "COMPLEMENT";
  SyntaxTypeEnum2["OBJECT"] = "OBJECT";
  SyntaxTypeEnum2["SUBJECT"] = "SUBJECT";
  SyntaxTypeEnum2["VERB"] = "VERB";
  return SyntaxTypeEnum2;
})(SyntaxTypeEnum || {});
var TagTargetEntityEnum = /* @__PURE__ */ ((TagTargetEntityEnum2) => {
  TagTargetEntityEnum2["META_CONTENT"] = "META_CONTENT";
  TagTargetEntityEnum2["META_CONTENT_MODULE"] = "META_CONTENT_MODULE";
  TagTargetEntityEnum2["REFERENCE_INFORMATION"] = "REFERENCE_INFORMATION";
  TagTargetEntityEnum2["STUDY_ACTIVITY"] = "STUDY_ACTIVITY";
  return TagTargetEntityEnum2;
})(TagTargetEntityEnum || {});
var TeacherAiSettingApplyScopeEnum = /* @__PURE__ */ ((TeacherAiSettingApplyScopeEnum2) => {
  TeacherAiSettingApplyScopeEnum2["ALL_CHANNELS"] = "ALL_CHANNELS";
  TeacherAiSettingApplyScopeEnum2["NEW_CHANNELS_ONLY"] = "NEW_CHANNELS_ONLY";
  return TeacherAiSettingApplyScopeEnum2;
})(TeacherAiSettingApplyScopeEnum || {});
var TeacherAiSettingOptionEnum = /* @__PURE__ */ ((TeacherAiSettingOptionEnum2) => {
  TeacherAiSettingOptionEnum2["IS_ACTIVE"] = "IS_ACTIVE";
  TeacherAiSettingOptionEnum2["IS_AUTO_SEND"] = "IS_AUTO_SEND";
  return TeacherAiSettingOptionEnum2;
})(TeacherAiSettingOptionEnum || {});
var TeacherAiSettingTargetEnum = /* @__PURE__ */ ((TeacherAiSettingTargetEnum2) => {
  TeacherAiSettingTargetEnum2["REPLY_TEMPLATE"] = "REPLY_TEMPLATE";
  TeacherAiSettingTargetEnum2["SESSION"] = "SESSION";
  return TeacherAiSettingTargetEnum2;
})(TeacherAiSettingTargetEnum || {});
var TimerInstanceStatusEnum = /* @__PURE__ */ ((TimerInstanceStatusEnum2) => {
  TimerInstanceStatusEnum2["ENDED"] = "ENDED";
  TimerInstanceStatusEnum2["IDLE"] = "IDLE";
  TimerInstanceStatusEnum2["PAUSED"] = "PAUSED";
  TimerInstanceStatusEnum2["RUNNING"] = "RUNNING";
  TimerInstanceStatusEnum2["STOPPED"] = "STOPPED";
  return TimerInstanceStatusEnum2;
})(TimerInstanceStatusEnum || {});
var TimerNotificationEnum = /* @__PURE__ */ ((TimerNotificationEnum2) => {
  TimerNotificationEnum2["ALL"] = "ALL";
  TimerNotificationEnum2["MANAGER_ONLY"] = "MANAGER_ONLY";
  TimerNotificationEnum2["NONE"] = "NONE";
  return TimerNotificationEnum2;
})(TimerNotificationEnum || {});
var UnusedFeatureTypeEnum = /* @__PURE__ */ ((UnusedFeatureTypeEnum2) => {
  UnusedFeatureTypeEnum2["ATTENDANCE_CHECK"] = "ATTENDANCE_CHECK";
  UnusedFeatureTypeEnum2["FULLSCREEN"] = "FULLSCREEN";
  UnusedFeatureTypeEnum2["LIVE_CLASS_MODE"] = "LIVE_CLASS_MODE";
  UnusedFeatureTypeEnum2["PUBLIC_CLASS"] = "PUBLIC_CLASS";
  UnusedFeatureTypeEnum2["REFERENCE_MATERIAL"] = "REFERENCE_MATERIAL";
  UnusedFeatureTypeEnum2["RETRY"] = "RETRY";
  UnusedFeatureTypeEnum2["SCREEN_LOCK"] = "SCREEN_LOCK";
  UnusedFeatureTypeEnum2["SCREEN_SYNC"] = "SCREEN_SYNC";
  UnusedFeatureTypeEnum2["STUDENT_LIST"] = "STUDENT_LIST";
  UnusedFeatureTypeEnum2["ZOOM"] = "ZOOM";
  return UnusedFeatureTypeEnum2;
})(UnusedFeatureTypeEnum || {});
var UserOrderByFieldEnum = /* @__PURE__ */ ((UserOrderByFieldEnum2) => {
  UserOrderByFieldEnum2["BIRTH"] = "BIRTH";
  UserOrderByFieldEnum2["CREATED_AT"] = "CREATED_AT";
  UserOrderByFieldEnum2["NAME"] = "NAME";
  return UserOrderByFieldEnum2;
})(UserOrderByFieldEnum || {});
var UserRoleEnum = /* @__PURE__ */ ((UserRoleEnum2) => {
  UserRoleEnum2["CMS"] = "CMS";
  UserRoleEnum2["CRM"] = "CRM";
  UserRoleEnum2["LMS"] = "LMS";
  UserRoleEnum2["STUDENT"] = "STUDENT";
  return UserRoleEnum2;
})(UserRoleEnum || {});
var ValidStatusTypesEnum = /* @__PURE__ */ ((ValidStatusTypesEnum2) => {
  ValidStatusTypesEnum2["INVALID"] = "INVALID";
  ValidStatusTypesEnum2["VALID"] = "VALID";
  return ValidStatusTypesEnum2;
})(ValidStatusTypesEnum || {});
var VerticalDirectionEnum = /* @__PURE__ */ ((VerticalDirectionEnum2) => {
  VerticalDirectionEnum2["DOWN"] = "DOWN";
  VerticalDirectionEnum2["UP"] = "UP";
  return VerticalDirectionEnum2;
})(VerticalDirectionEnum || {});
var WebContentSpeakingBlockCategoryEnum = /* @__PURE__ */ ((WebContentSpeakingBlockCategoryEnum2) => {
  WebContentSpeakingBlockCategoryEnum2["PHONICS"] = "PHONICS";
  WebContentSpeakingBlockCategoryEnum2["PRONUNCIATION"] = "PRONUNCIATION";
  WebContentSpeakingBlockCategoryEnum2["STT_ONLY"] = "STT_ONLY";
  return WebContentSpeakingBlockCategoryEnum2;
})(WebContentSpeakingBlockCategoryEnum || {});
var WeekDayEnum = /* @__PURE__ */ ((WeekDayEnum2) => {
  WeekDayEnum2["friday"] = "friday";
  WeekDayEnum2["monday"] = "monday";
  WeekDayEnum2["saturday"] = "saturday";
  WeekDayEnum2["sunday"] = "sunday";
  WeekDayEnum2["thursday"] = "thursday";
  WeekDayEnum2["tuesday"] = "tuesday";
  WeekDayEnum2["wednesday"] = "wednesday";
  return WeekDayEnum2;
})(WeekDayEnum || {});
var WordLearningStateEnum = /* @__PURE__ */ ((WordLearningStateEnum2) => {
  WordLearningStateEnum2["KNOW"] = "KNOW";
  WordLearningStateEnum2["NEW"] = "NEW";
  WordLearningStateEnum2["UNKNOWN"] = "UNKNOWN";
  return WordLearningStateEnum2;
})(WordLearningStateEnum || {});
var WordOrderFieldTypeEnum = /* @__PURE__ */ ((WordOrderFieldTypeEnum2) => {
  WordOrderFieldTypeEnum2["CREATED_AT"] = "CREATED_AT";
  WordOrderFieldTypeEnum2["WORD"] = "WORD";
  return WordOrderFieldTypeEnum2;
})(WordOrderFieldTypeEnum || {});
var WordReferenceInformationCategoryEnum = /* @__PURE__ */ ((WordReferenceInformationCategoryEnum2) => {
  WordReferenceInformationCategoryEnum2["ANSWER"] = "ANSWER";
  WordReferenceInformationCategoryEnum2["CORE_CONCEPT_EXPLANATION"] = "CORE_CONCEPT_EXPLANATION";
  WordReferenceInformationCategoryEnum2["FREQUENTLY_ASKED_QUESTION"] = "FREQUENTLY_ASKED_QUESTION";
  WordReferenceInformationCategoryEnum2["FREQUENTLY_ASKED_QUESTION_ANSWER"] = "FREQUENTLY_ASKED_QUESTION_ANSWER";
  WordReferenceInformationCategoryEnum2["HOMEWORK"] = "HOMEWORK";
  WordReferenceInformationCategoryEnum2["LEANING_MATERIAL"] = "LEANING_MATERIAL";
  WordReferenceInformationCategoryEnum2["OTHER"] = "OTHER";
  WordReferenceInformationCategoryEnum2["QUESTION"] = "QUESTION";
  WordReferenceInformationCategoryEnum2["REPEATED_COMMENT"] = "REPEATED_COMMENT";
  return WordReferenceInformationCategoryEnum2;
})(WordReferenceInformationCategoryEnum || {});
var WrongAnswerGroupReplicaCurriculumTypeEnum = /* @__PURE__ */ ((WrongAnswerGroupReplicaCurriculumTypeEnum2) => {
  WrongAnswerGroupReplicaCurriculumTypeEnum2["FIRST_DAY"] = "FIRST_DAY";
  WrongAnswerGroupReplicaCurriculumTypeEnum2["LAST_DAY"] = "LAST_DAY";
  return WrongAnswerGroupReplicaCurriculumTypeEnum2;
})(WrongAnswerGroupReplicaCurriculumTypeEnum || {});
var __DirectiveLocationEnum = /* @__PURE__ */ ((__DirectiveLocationEnum2) => {
  __DirectiveLocationEnum2["QUERY"] = "QUERY";
  __DirectiveLocationEnum2["MUTATION"] = "MUTATION";
  __DirectiveLocationEnum2["SUBSCRIPTION"] = "SUBSCRIPTION";
  __DirectiveLocationEnum2["FIELD"] = "FIELD";
  __DirectiveLocationEnum2["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
  __DirectiveLocationEnum2["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
  __DirectiveLocationEnum2["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
  __DirectiveLocationEnum2["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
  __DirectiveLocationEnum2["SCHEMA"] = "SCHEMA";
  __DirectiveLocationEnum2["SCALAR"] = "SCALAR";
  __DirectiveLocationEnum2["OBJECT"] = "OBJECT";
  __DirectiveLocationEnum2["FIELD_DEFINITION"] = "FIELD_DEFINITION";
  __DirectiveLocationEnum2["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
  __DirectiveLocationEnum2["INTERFACE"] = "INTERFACE";
  __DirectiveLocationEnum2["UNION"] = "UNION";
  __DirectiveLocationEnum2["ENUM"] = "ENUM";
  __DirectiveLocationEnum2["ENUM_VALUE"] = "ENUM_VALUE";
  __DirectiveLocationEnum2["INPUT_OBJECT"] = "INPUT_OBJECT";
  __DirectiveLocationEnum2["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
  return __DirectiveLocationEnum2;
})(__DirectiveLocationEnum || {});
var __TypeKindEnum = /* @__PURE__ */ ((__TypeKindEnum2) => {
  __TypeKindEnum2["SCALAR"] = "SCALAR";
  __TypeKindEnum2["OBJECT"] = "OBJECT";
  __TypeKindEnum2["INTERFACE"] = "INTERFACE";
  __TypeKindEnum2["UNION"] = "UNION";
  __TypeKindEnum2["ENUM"] = "ENUM";
  __TypeKindEnum2["INPUT_OBJECT"] = "INPUT_OBJECT";
  __TypeKindEnum2["LIST"] = "LIST";
  __TypeKindEnum2["NON_NULL"] = "NON_NULL";
  return __TypeKindEnum2;
})(__TypeKindEnum || {});
var replicaCurriculumOnGroupAnalysisOrderFieldTypeEnum = /* @__PURE__ */ ((replicaCurriculumOnGroupAnalysisOrderFieldTypeEnum2) => {
  replicaCurriculumOnGroupAnalysisOrderFieldTypeEnum2["CORRECT_ANSWER_RATE"] = "CORRECT_ANSWER_RATE";
  replicaCurriculumOnGroupAnalysisOrderFieldTypeEnum2["ORDER_ID"] = "ORDER_ID";
  return replicaCurriculumOnGroupAnalysisOrderFieldTypeEnum2;
})(replicaCurriculumOnGroupAnalysisOrderFieldTypeEnum || {});
var studyModuleInstanceAnalysisOrderFieldTypeEnum = /* @__PURE__ */ ((studyModuleInstanceAnalysisOrderFieldTypeEnum2) => {
  studyModuleInstanceAnalysisOrderFieldTypeEnum2["CORRECT_ANSWER_RATE"] = "CORRECT_ANSWER_RATE";
  studyModuleInstanceAnalysisOrderFieldTypeEnum2["CORRECT_ANSWER_RATE_DIFF_WITH_AVERAGE"] = "CORRECT_ANSWER_RATE_DIFF_WITH_AVERAGE";
  return studyModuleInstanceAnalysisOrderFieldTypeEnum2;
})(studyModuleInstanceAnalysisOrderFieldTypeEnum || {});
var studyUnitInstanceAnalysisOrderFieldTypeEnum = /* @__PURE__ */ ((studyUnitInstanceAnalysisOrderFieldTypeEnum2) => {
  studyUnitInstanceAnalysisOrderFieldTypeEnum2["CORRECT_ANSWER_RATE"] = "CORRECT_ANSWER_RATE";
  studyUnitInstanceAnalysisOrderFieldTypeEnum2["CORRECT_ANSWER_RATE_DIFF_WITH_AVERAGE"] = "CORRECT_ANSWER_RATE_DIFF_WITH_AVERAGE";
  return studyUnitInstanceAnalysisOrderFieldTypeEnum2;
})(studyUnitInstanceAnalysisOrderFieldTypeEnum || {});
export {
  AICommentViewTypeEnum,
  AIFeedbackResultStatusEnum,
  AchievementLevelEnum,
  AcquireStatusEnum,
  AcquisitionLevelEnum,
  ActivityCategoryEnum,
  ActivityPageWidthEnum,
  ActivitySetTypeEnum,
  ActivityStateEnum,
  ActivityStatusEnum,
  AiStatusEnum,
  AiTutorMessageSenderTypeEnum,
  AiTutorMessageTypeEnum,
  AidtExternalUserDigitalTextBookTypeEnum,
  AidtExternalUserPublisherTypeEnum,
  AidtExternalUserTypeEnum,
  AidtUserSettingStatusEnum,
  AmendReasonTypeEnum,
  AnswerSymbolTypeEnum,
  AssignmentBaseContentTypeEnum,
  AssignmentStatusEnum,
  AssignmentTypeEnum,
  AssignmentUserStatusEnum,
  AttributeCategoryTypeEnum,
  AuthenticationTypesEnum,
  AuthorityTypesEnum,
  AutoSendFeedRuleEntityTypeEnum,
  AutoSendFeedRuleTypeEnum,
  AutoSendStatusEnum,
  B2BVideoLectureTypeEnum,
  BlankQuizOptionEnumEnum,
  BoardTypeEnum,
  BookmarkTargetTypeEnum,
  BookmarkTypesEnum,
  BookmarksOrderFieldTypeEnum,
  ChannelMemberTypeEnum,
  ChannelMemoEventTypeEnum,
  ChannelTypeEnum,
  ChatBotMessageTypeEnum,
  CheckPolicyEnum,
  ClassStateEnum,
  ClassTimeRecordStatusEnum,
  ClassTimeStateEnum,
  ClientChatMessageUploadStatusEnum,
  ColorOfLetterEnum,
  ConnectionStateEnum,
  ContentScopeEnum,
  ContentTypeEnum,
  CorrectAnswerMultipleChoiceTypeEnum,
  CorrectAnswerReferralTargetTypeEnum,
  CorrectAnswerShortAnswerTypeEnum,
  CreateStudyUnitOnStudyModuleRequestTypeEnum,
  CurriculumOrderFieldTypeEnum,
  CurriculumSubjectEnum,
  CurriculumTypeEnum,
  CustomCurriculumCommentRecommendationTypeEnum,
  CustomCurriculumEditingStatusEnum,
  CustomCurriculumStatusEnum,
  CustomCurriculumSubTypeEnum,
  CustomCurriculumTypeEnum,
  CustomDailyCurriculumStatusEnum,
  CustomStudyModuleStatusEnum,
  CustomStudyModulesByUserAndCustomCurriculumInputGroupByEnum,
  CustomStudyModulesByUserAndCustomCurriculumOrderByFieldEnumEnum,
  CustomStudyUnitCommentRecommendationTypeEnum,
  DashboardActivityLogTypeEnum,
  DashboardSettingNameTypeEnum,
  DashboardSettingTypeEnum,
  DayOfTheWeekEnum,
  DeviceTypeEnum,
  DiagnosisReportOnStudyUnitInstanceStatusEnum,
  DiagnosticOnboardingBatchStatusEnum,
  DiagnosticOnboardingItemStatusEnum,
  DomainEnum,
  DrawGraphInteractionSubTypeEnum,
  EditTargetEntityTypeEnum,
  EditingStatusEnum,
  ErrorCodeEnum,
  EstimationAnswerResultEnum,
  EstimationLearningStatusEnum,
  EstimationTypeEnum,
  EventLogTypeEnum,
  ExamDifficultyTypeEnum,
  ExamGoalTypeEnum,
  ExamSatisfactionLevelTypeEnum,
  ExternalCompanyNameEnum,
  FeedChangeReasonTypeEnum,
  FeedCompleteStatusEnum,
  FeedLearningStateEnum,
  FeedReservationTypeEnum,
  FeedSendPresetTypeEnum,
  FeedTypeEnum,
  FeedbackReactionEnum,
  FeedbackRequestStatusEnum,
  FileTypeEnum,
  FileUsageEnum,
  FilterRuleCategoryEnum,
  FinalStateEnum,
  FirstIntegratedActivityTypeEnum,
  GradientColorTypeEnum,
  GrammarOrderFieldTypeEnum,
  GraphDotInteractionActionEnum,
  GraphDotInteractionExposureOptionEnum,
  GraphInteractionSubTypeEnum,
  GraphInteractionTypeEnum,
  GraphObjectTypeEnum,
  GraphShapeTypeEnum,
  GroupHistoryActionTypesEnum,
  GroupPauseTargetEnum,
  GroupPostKindEnum,
  GroupReplicaCurriculumStatusEnum,
  GroupReplicaCurriculumTypeEnum,
  GroupThemeTypeEnum,
  GroupUserAttendanceStatusTypeEnum,
  GroupUserStateEnum,
  GroupUserTypeInGroupEnum,
  GroupUserTypesEnum,
  HandwritingCategoryEnum,
  HandwritingSenderTypeEnum,
  HandwritingStateEnum,
  KnowledgeTagsOrderFieldEnum,
  LearningActivityModumExistenceStatusEnum,
  LearningPlanItemTypeEnum,
  LearningPlanStateEnum,
  LearningStateEnum,
  LectureFeedbackSelectEnum,
  LinkInTeacherEmbeddedBlockExistenceStatusEnum,
  LinkableTagTargetEnum,
  MRPresetCommentInitStatusEnum,
  ManagedTagSubjectEnum,
  ManagerCompleteStudyStateOrderFieldEnum,
  MarkableStudyActivityTypesEnum,
  MathAiTutorStateEnum,
  MessageEventTypeEnum,
  MessageTypeEnum,
  MetaChapterStatusTypeEnum,
  MetaContentContentTypeEnum,
  MetaContentDifficultyEnum,
  MetaContentLearningPurposeEnum,
  MetaContentModuleContentTypeEnum,
  MetaContentModuleImportanceTypeEnum,
  MetaContentModuleTypeEnum,
  MetaContentOrderFieldTypeEnum,
  MetaContentSubjectEnum,
  MetaContentTargetGroupEnum,
  MetaContentTypeEnum,
  MonthlyReportPresetTypeEnum,
  MonthlyReportSubjectTypeEnum,
  MpdStatusEnum,
  MultipleChoiceSelectionStatsByMetaContentOrderFieldsEnum,
  OperationEnum,
  OrderDirectionTypeEnum,
  PartOfSpeechEnum,
  PhonicsCommentEnum,
  PlatformAdoptionStatusTypeEnum,
  PostFilterTypeEnum,
  PostTypeEnum,
  ProductExpireStateEnum,
  ProficiencyNameEnum,
  ProgressFeedStatusEnum,
  ProgressTypesEnum,
  PublisherEnum,
  QuestionStudyActivitySubTypeEnum,
  RESTORE_STATUSEnum,
  RecommendationCommentTypeEnum,
  RecommendationStrategyCategoryEnum,
  RecommendationStrategyManagedTagConditionEnum,
  RecommendationTypeEnum,
  ReferenceInformationCategoryEnum,
  ReferenceInformationFieldEnum,
  ReferenceInformationFindTypeEnum,
  ReferenceInformationOrderEnum,
  ReferenceInformationSourceEnum,
  ReferenceInformationTargetEnum,
  ReferenceInformationTypeEnum,
  ReportTypeEnum,
  ResourcePermissionEnum,
  ResultViewOptionEnum,
  ReviewSettingContentTypeEnum,
  ScheduledMessageEventTypeEnum,
  ScheduledMessageStatusEnum,
  SchoolTypeEnum,
  SelectionQuizOptionEnum,
  SelfStudyAssignmentTransactionStatusEnum,
  SelfStudyAssignmentTypeEnum,
  SendRuleTypeEnum,
  SendingStateEnum,
  SentenceAmendReasonTypeEnum,
  SentencePublishTypeEnum,
  SentenceStudyActivityTypesEnum,
  SentenceStudyGradeResultLabelEnum,
  SentenceStudyHintCategoryEnum,
  SentenceStudyHintFalseReasonEnum,
  SentenceStudyHistoryStatusEnum,
  SentenceStudyTranslationGradingErrorTypeEnum,
  SentenceStudyTranslationGradingFeedbackReasonEnum,
  SentenceStudyTranslationGradingSeverityEnum,
  SentenceStudyTranslationGradingStatusEnum,
  SentenceStudyTranslationGradingVerdictEnum,
  SessionClassificationPhaseEnum,
  SessionInstanceStatusEnum,
  SessionSendModeEnum,
  ShortAnswerBlockEstimationAnswerResultTypeEnum,
  ShortAnswerWordHintEnum,
  SpeakingBlockCategoryEnum,
  SpeakingOverallCommentEnum,
  StatsActivityTypeEnum,
  StatsCategoryEnum,
  StatsGradeEnum,
  StatsViewTypeEnum,
  SttAlignmentByWordErrorTypeEnum,
  SttStatusEnum,
  StudentAuthorityExpireStateEnum,
  StudentCustomIntegratedActivityLearningStatusTypeEnum,
  StudentCustomStudyStatsOrderFieldEnum,
  StudentCustomStudyUnitCommentTypeEnum,
  StudentLearningProgressStatusEnum,
  StudyActivityDifficultyTypesEnum,
  StudyActivityEvaluatableTypesEnum,
  StudyActivityHistoryLearningStateEnum,
  StudyActivityInstanceLearningStateTypeEnum,
  StudyActivityOrderFieldTypeEnum,
  StudyActivityQuestionSubTypeFilterEnum,
  StudyActivitySubTypeOptionEnum,
  StudyActivityTypesEnum,
  StudyActivityViewerTypeEnum,
  StudyModuleGenerateTemplateTypeEnum,
  StudyModuleOrderFieldTypeEnum,
  StudyModuleReferenceInformationCategoryEnum,
  StudyOptionEnum,
  StudyUnitCategoryEnum,
  StudyUnitGradingUnitEnum,
  StudyUnitInstanceTypeEnum,
  StudyUnitReferenceInformationCategoryEnum,
  StudyUnitTypeEnum,
  StudyUnitViewTypeEnum,
  SubjectEnum,
  SubmissionPolicyEnum,
  SyncStudyViewTypeEnum,
  SyntaxTypeEnum,
  TagTargetEntityEnum,
  TeacherAiSettingApplyScopeEnum,
  TeacherAiSettingOptionEnum,
  TeacherAiSettingTargetEnum,
  TimerInstanceStatusEnum,
  TimerNotificationEnum,
  UnusedFeatureTypeEnum,
  UserOrderByFieldEnum,
  UserRoleEnum,
  ValidStatusTypesEnum,
  VerticalDirectionEnum,
  WebContentSpeakingBlockCategoryEnum,
  WeekDayEnum,
  WordLearningStateEnum,
  WordOrderFieldTypeEnum,
  WordReferenceInformationCategoryEnum,
  WrongAnswerGroupReplicaCurriculumTypeEnum,
  __DirectiveLocationEnum,
  __TypeKindEnum,
  replicaCurriculumOnGroupAnalysisOrderFieldTypeEnum,
  studyModuleInstanceAnalysisOrderFieldTypeEnum,
  studyUnitInstanceAnalysisOrderFieldTypeEnum
};
